var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _path6, _path7, _g6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 349,
    viewBox: "0 0 394 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11846_111534)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.12 152.087H163.033V164.034H152.451V152.087H128.001V142.788L149.165 108.074H161.191L141.07 141.584H152.454V127.393L163.036 128.676V141.584H167.123V152.084L167.12 152.087Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.695 135.895C211.695 143.484 210.198 149.897 207.206 155.135C203.518 161.495 198.145 164.676 191.09 164.676C184.036 164.676 178.584 161.523 174.897 155.216C171.85 150.032 170.326 143.647 170.326 136.055C170.326 128.463 171.85 122.052 174.897 116.815C178.584 110.455 183.982 107.273 191.09 107.273C198.199 107.273 203.515 110.427 207.206 116.733C210.198 121.917 211.695 128.305 211.695 135.895ZM200.151 136.055C200.151 131.672 199.642 127.985 198.629 124.992C197.079 120.556 194.567 118.34 191.094 118.34C187.62 118.34 184.947 120.531 183.398 124.913C182.329 127.906 181.794 131.622 181.794 136.055C181.794 140.488 182.329 144.125 183.398 147.118C184.947 151.5 187.513 153.692 191.094 153.692C197.133 153.692 200.154 147.813 200.154 136.055H200.151Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.379 132.153C240.379 135.674 239.646 138.545 238.178 140.767C236.417 143.408 233.839 144.729 230.444 144.729C227.049 144.729 224.471 143.408 222.71 140.767C221.201 138.545 220.447 135.674 220.447 132.153C220.447 128.632 221.201 125.762 222.71 123.539C224.471 120.899 227.049 119.578 230.444 119.578C233.839 119.578 236.417 120.899 238.178 123.539C239.646 125.762 240.379 128.632 240.379 132.153ZM233.588 132.153C233.588 128.214 232.541 126.243 230.444 126.243C228.347 126.243 227.237 128.214 227.237 132.153C227.237 136.092 228.306 138.064 230.444 138.064C232.582 138.064 233.588 136.092 233.588 132.153ZM257.795 120.144L237.738 164.031H229.375L249.496 120.144H257.795ZM266.786 152.085C266.786 155.565 266.032 158.435 264.523 160.699C262.762 163.34 260.184 164.66 256.789 164.66C253.394 164.66 250.816 163.34 249.055 160.699C247.587 158.435 246.855 155.565 246.855 152.085C246.855 148.605 247.587 145.672 249.055 143.408C250.816 140.767 253.394 139.447 256.789 139.447C260.184 139.447 262.762 140.767 264.523 143.408C266.032 145.672 266.786 148.564 266.786 152.085ZM259.996 152.085C259.996 148.146 258.927 146.175 256.789 146.175C254.651 146.175 253.582 148.146 253.582 152.085C253.582 156.024 254.651 157.932 256.789 157.932C258.927 157.932 259.996 155.983 259.996 152.085Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.879 203.969C310.761 211.102 306.02 217.817 300.735 224.045C300.546 224.268 300.358 224.488 300.166 224.708C300.04 224.853 299.915 224.997 299.789 225.142C297.704 227.538 295.529 229.87 293.265 232.134C288.776 236.623 284.019 240.764 279.018 244.549L258.001 215.619C258.489 215.245 258.973 214.868 259.454 214.485C259.62 214.353 259.787 214.22 259.954 214.085C260.281 213.821 260.608 213.554 260.932 213.287C266.946 208.338 272.35 202.711 277.081 196.449C278.185 194.987 279.241 193.5 280.26 191.988C280.3 191.928 280.338 191.868 280.379 191.808C280.766 191.23 281.149 190.651 281.523 190.067C281.64 189.884 281.753 189.702 281.869 189.52C282.168 189.048 282.463 188.576 282.753 188.102C282.925 187.816 283.095 187.53 283.268 187.24C283.494 186.86 283.721 186.483 283.941 186.099C284.164 185.716 284.378 185.329 284.595 184.942C284.758 184.653 284.922 184.364 285.079 184.071C285.346 183.581 285.607 183.087 285.868 182.594C285.969 182.405 286.069 182.217 286.167 182.025C286.487 181.405 286.799 180.783 287.107 180.157C287.138 180.095 287.17 180.035 287.198 179.972C287.996 178.334 288.76 176.674 289.474 174.989C290.273 173.103 291.008 171.198 291.687 169.274L325.672 180.318C324.619 183.38 323.462 186.392 322.201 189.356C320.066 194.336 317.627 199.212 314.879 203.965V203.969Z",
    fill: "url(#paint0_linear_11846_111534)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.086 261.645C248.529 261.875 247.973 262.098 247.417 262.321C247.187 262.413 246.961 262.504 246.731 262.592C246.389 262.727 246.046 262.856 245.703 262.988C245.263 263.158 244.82 263.324 244.38 263.488C244.254 263.535 244.125 263.582 243.996 263.629C232.578 267.814 220.625 270.467 208.487 271.498C205.525 271.743 202.545 271.891 199.552 271.941V236.2C203.268 236.112 206.975 235.813 210.647 235.31C219.405 234.131 227.934 231.798 236.124 228.334C240.139 226.636 244.012 224.687 247.737 222.502C247.904 222.405 248.067 222.307 248.234 222.21C248.599 221.993 248.966 221.776 249.328 221.556C249.85 221.238 250.369 220.914 250.884 220.587C251.067 220.471 251.249 220.352 251.431 220.235C251.915 219.924 252.396 219.607 252.874 219.289C252.981 219.217 253.088 219.148 253.195 219.075C253.478 218.887 253.758 218.695 254.037 218.5L275.051 247.423C271.841 249.658 268.524 251.768 265.1 253.745C259.941 256.725 254.606 259.35 249.139 261.62C249.121 261.627 249.105 261.636 249.086 261.642V261.645Z",
    fill: "url(#paint1_linear_11846_111534)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11846_111534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.724 271.581C186.438 271.559 186.155 271.537 185.869 271.511C172.936 270.424 160.209 267.497 148.112 262.838C148.015 262.8 147.914 262.762 147.817 262.725C147.345 262.542 146.873 262.354 146.405 262.165C146.097 262.039 145.786 261.917 145.478 261.791C145.214 261.684 144.953 261.574 144.688 261.464C144.167 261.247 143.648 261.027 143.129 260.804C143.076 260.779 143.019 260.757 142.966 260.731C138.231 258.675 133.603 256.346 129.108 253.752C125.684 251.775 122.368 249.665 119.158 247.43L140.174 218.504C140.419 218.671 140.661 218.84 140.906 219.007C141.114 219.148 141.321 219.287 141.532 219.425C141.872 219.651 142.214 219.875 142.557 220.098C143.777 220.89 145.015 221.654 146.27 222.393C146.27 222.393 146.273 222.393 146.276 222.396C150.064 224.625 154.004 226.615 158.087 228.344C166.296 231.815 174.844 234.151 183.621 235.326C183.911 235.367 184.2 235.402 184.489 235.44C184.533 235.446 184.574 235.449 184.618 235.455C187.947 235.873 191.298 236.125 194.659 236.207V271.948C192.097 271.904 189.547 271.791 187.01 271.606C186.916 271.599 186.822 271.593 186.727 271.584L186.724 271.581Z",
    stroke: "url(#paint2_linear_11846_111534)",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11846_111534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.944 232.134C98.721 229.912 96.5832 227.623 94.5334 225.272C94.3448 225.051 94.1531 224.835 93.9644 224.614C93.8198 224.445 93.672 224.275 93.5274 224.105C88.2238 217.862 83.4641 211.128 79.3332 203.969C76.5855 199.209 74.1428 194.327 72.005 189.344C70.7475 186.386 69.5906 183.377 68.5405 180.322L102.528 169.277C103.207 171.198 103.943 173.103 104.741 174.993C105.455 176.681 106.216 178.341 107.017 179.976C107.049 180.039 107.08 180.098 107.109 180.161C107.417 180.787 107.728 181.409 108.049 182.029C108.146 182.217 108.247 182.406 108.347 182.598C108.608 183.091 108.869 183.585 109.136 184.075C109.297 184.368 109.46 184.657 109.621 184.946C109.837 185.333 110.054 185.719 110.274 186.103C110.495 186.487 110.721 186.864 110.947 187.244C111.117 187.53 111.287 187.819 111.46 188.102C111.749 188.577 112.044 189.049 112.343 189.52C112.459 189.703 112.573 189.885 112.689 190.067C113.063 190.652 113.447 191.234 113.833 191.812C113.871 191.872 113.912 191.928 113.95 191.988C114.968 193.5 116.024 194.99 117.128 196.449C121.922 202.793 127.408 208.484 133.517 213.482C133.727 213.655 133.938 213.831 134.152 214.001C134.384 214.187 134.617 214.372 134.85 214.557C135.299 214.916 135.752 215.268 136.208 215.617L115.188 244.546C110.186 240.761 105.43 236.621 100.94 232.131L100.944 232.134Z",
    stroke: "url(#paint3_linear_11846_111534)",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_11846_111534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.33 67.9708C83.4547 60.8281 88.2018 54.1066 93.4929 47.8756C93.6658 47.6712 93.8387 47.4669 94.0147 47.2657C94.1625 47.0928 94.3102 46.923 94.458 46.7533C96.5329 44.3734 98.6927 42.0564 100.944 39.8055C105.433 35.3161 110.19 31.1758 115.191 27.3906L136.208 56.3198C135.723 56.6908 135.243 57.0649 134.768 57.4453C134.592 57.5837 134.416 57.7251 134.243 57.8634C133.928 58.1149 133.617 58.3728 133.306 58.6274C127.282 63.582 121.866 69.2157 117.128 75.4876C116.024 76.9495 114.968 78.4396 113.95 79.9486C113.909 80.0084 113.871 80.065 113.833 80.1247C113.447 80.7032 113.063 81.2847 112.689 81.8695C112.573 82.0518 112.459 82.2342 112.343 82.4165C112.044 82.8881 111.749 83.3596 111.46 83.8344C111.287 84.1204 111.117 84.4065 110.947 84.6926C110.721 85.073 110.495 85.4534 110.274 85.8338C110.051 86.2174 109.837 86.6041 109.621 86.9907C109.457 87.28 109.294 87.5692 109.136 87.8616C108.869 88.352 108.608 88.8456 108.347 89.3391C108.247 89.5278 108.146 89.7164 108.049 89.9082C107.728 90.5275 107.417 91.15 107.109 91.7756C107.077 91.8385 107.046 91.8982 107.017 91.9611C106.219 93.599 105.455 95.2589 104.741 96.944C103.943 98.8303 103.207 100.735 102.528 102.659L68.5405 91.6153C69.5906 88.5626 70.7443 85.554 72.0019 82.5957C74.1396 77.6097 76.5823 72.7273 79.33 67.9645V67.9708Z",
    stroke: "url(#paint4_linear_11846_111534)",
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_11846_111534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.264 10.2393C145.717 10.0539 146.169 9.87151 146.625 9.68917C146.955 9.55713 147.285 9.42509 147.618 9.2962C147.857 9.20188 148.093 9.11071 148.332 9.01954C148.876 8.81205 149.42 8.60457 149.967 8.40337C149.989 8.39394 150.011 8.38762 150.033 8.37819C161.542 4.1435 173.596 1.46501 185.835 0.433846C186.139 0.408695 186.444 0.383513 186.749 0.361506C186.822 0.355219 186.891 0.352098 186.963 0.34581C189.513 0.160326 192.078 0.0440132 194.653 0V35.7418C191.27 35.8236 187.9 36.0751 184.552 36.4995C184.549 36.4995 184.542 36.4995 184.539 36.4995C184.219 36.5404 183.898 36.5812 183.58 36.6253C174.816 37.8042 166.28 40.1369 158.081 43.6045C154.051 45.3084 150.162 47.2701 146.418 49.4645C146.292 49.5368 146.166 49.6123 146.043 49.6846C145.644 49.9204 145.248 50.1561 144.852 50.3982C144.346 50.7063 143.846 51.0207 143.346 51.3351C143.139 51.4671 142.934 51.6023 142.727 51.7343C142.271 52.0267 141.821 52.3254 141.372 52.6241C141.246 52.7089 141.117 52.7938 140.991 52.8787C140.718 53.0642 140.444 53.2497 140.171 53.4383L119.158 24.5153C122.368 22.2801 125.684 20.1706 129.108 18.1932C134.22 15.2443 139.501 12.638 144.915 10.3839C145.034 10.3336 145.151 10.2865 145.27 10.2362L145.264 10.2393Z",
    stroke: "url(#paint5_linear_11846_111534)",
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_11846_111534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.471 0.363823C207.767 0.385829 208.063 0.411012 208.358 0.436162C221.266 1.52077 233.974 4.44133 246.049 9.09101C246.178 9.14131 246.307 9.19164 246.439 9.24195C246.879 9.41171 247.319 9.58774 247.756 9.76379C248.099 9.90212 248.441 10.0405 248.781 10.1788C249.01 10.2731 249.24 10.3705 249.469 10.4648C250.023 10.6975 250.579 10.9302 251.129 11.1691C251.151 11.1785 251.17 11.1879 251.192 11.1974C255.946 13.2597 260.589 15.5956 265.1 18.2018C268.524 20.1792 271.841 22.2887 275.051 24.5239L254.034 53.45C253.783 53.2771 253.528 53.1011 253.277 52.9313C253.094 52.8056 252.909 52.6861 252.723 52.5603C252.349 52.312 251.975 52.0636 251.598 51.8215C251.331 51.6486 251.066 51.4757 250.799 51.3059C250.686 51.2336 250.573 51.1645 250.46 51.0953C249.652 50.586 248.838 50.0924 248.014 49.6083C247.97 49.5831 247.929 49.558 247.885 49.5328C244.112 47.3133 240.189 45.3359 236.124 43.6162C227.928 40.1486 219.393 37.8159 210.625 36.637C210.304 36.593 209.987 36.5521 209.666 36.5113C209.663 36.5113 209.656 36.5113 209.653 36.5113C206.305 36.0868 202.935 35.8322 199.552 35.7536V0.0117188C202.121 0.0557319 204.677 0.168939 207.223 0.357567C207.305 0.363855 207.387 0.370123 207.471 0.37641V0.363823Z",
    stroke: "url(#paint6_linear_11846_111534)",
    strokeMiterlimit: 10
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.274 39.8031C295.503 42.0321 297.644 44.3271 299.7 46.6849C299.882 46.8924 300.065 47.103 300.244 47.3137C300.395 47.4897 300.546 47.6658 300.697 47.845C306 54.0854 310.754 60.8194 314.885 67.9716C317.632 72.7281 320.072 77.6042 322.206 82.5871C323.467 85.5485 324.624 88.5634 325.674 91.6224L291.686 102.667C291.007 100.746 290.272 98.8405 289.473 96.9511C288.76 95.2629 287.999 93.6029 287.197 91.9682C287.166 91.9053 287.134 91.8456 287.106 91.7827C286.798 91.1571 286.487 90.5346 286.166 89.9153C286.069 89.7267 285.968 89.538 285.867 89.3462C285.606 88.8527 285.345 88.3591 285.078 87.8687C284.918 87.5763 284.754 87.2871 284.594 86.9978C284.377 86.6112 284.16 86.2244 283.94 85.8409C283.72 85.4574 283.494 85.0801 283.267 84.6997C283.098 84.4136 282.928 84.1244 282.752 83.8383C282.463 83.3636 282.167 82.892 281.868 82.4204C281.752 82.2381 281.639 82.0558 281.523 81.8734C281.149 81.2887 280.765 80.7071 280.378 80.1318C280.337 80.072 280.3 80.0123 280.259 79.9526C279.24 78.4404 278.184 76.9534 277.08 75.4915C272.302 69.1662 266.835 63.4917 260.752 58.5087C260.513 58.3107 260.274 58.1158 260.032 57.9208C259.815 57.7479 259.601 57.575 259.381 57.4021C258.922 57.0406 258.463 56.679 257.998 56.3238L279.017 27.3945C284.019 31.1797 288.775 35.3201 293.265 39.8094L293.274 39.8031Z",
    fill: "url(#paint7_linear_11846_111534)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.101 135.969C333.101 141.458 332.777 146.9 332.136 152.279C331.363 158.617 330.14 164.924 328.467 171.167C328.065 172.673 327.634 174.17 327.181 175.657L293.2 164.616C293.354 164.1 293.502 163.588 293.646 163.072C293.662 163.019 293.675 162.962 293.69 162.909C293.782 162.582 293.873 162.252 293.961 161.921C294.049 161.591 294.137 161.261 294.222 160.928C294.234 160.875 294.25 160.821 294.262 160.768C295.3 156.7 296.083 152.559 296.605 148.359C297.029 144.951 297.274 141.537 297.347 138.129C297.347 138.073 297.347 138.016 297.35 137.956C297.356 137.654 297.359 137.353 297.362 137.048C297.362 136.906 297.362 136.768 297.365 136.626C297.365 136.406 297.365 136.186 297.365 135.963C297.365 135.743 297.365 135.523 297.365 135.3C297.365 135.158 297.365 135.02 297.362 134.878C297.359 134.577 297.356 134.275 297.35 133.97C297.35 133.913 297.35 133.857 297.347 133.797C297.274 130.389 297.029 126.978 296.605 123.57C296.083 119.367 295.3 115.227 294.262 111.159C294.25 111.111 294.237 111.064 294.225 111.017C294.137 110.678 294.049 110.341 293.961 110.005C293.876 109.684 293.788 109.363 293.697 109.043C293.678 108.98 293.662 108.917 293.643 108.854C293.499 108.339 293.348 107.823 293.197 107.311L327.178 96.2695C327.631 97.7565 328.061 99.253 328.464 100.759C330.136 107.006 331.359 113.309 332.133 119.647C332.774 125.026 333.098 130.465 333.098 135.957L333.101 135.969Z",
    fill: "url(#paint8_linear_11846_111534)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_11846_111534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.561 108.867C100.542 108.929 100.526 108.992 100.507 109.055C100.419 109.376 100.331 109.697 100.243 110.017C100.152 110.354 100.064 110.693 99.9792 111.03C99.9667 111.077 99.9541 111.124 99.9415 111.171C98.9041 115.239 98.1212 119.379 97.5994 123.583C97.175 126.991 96.9297 130.402 96.8574 133.81C96.8574 133.866 96.8574 133.926 96.8543 133.982C96.848 134.284 96.8449 134.586 96.8417 134.888C96.8417 135.029 96.8417 135.168 96.8386 135.309C96.8386 135.529 96.8386 135.749 96.8386 135.972C96.8386 136.193 96.8386 136.413 96.8386 136.636C96.8386 136.777 96.8386 136.916 96.8417 137.057C96.8449 137.359 96.848 137.661 96.8543 137.962C96.8543 138.019 96.8543 138.079 96.8574 138.135C96.9297 141.543 97.175 144.954 97.5994 148.362C98.1212 152.565 98.9041 156.706 99.9415 160.771C99.9541 160.824 99.9698 160.878 99.9824 160.931C100.067 161.261 100.152 161.594 100.243 161.924C100.331 162.255 100.423 162.582 100.514 162.912C100.529 162.965 100.542 163.022 100.558 163.075C100.702 163.591 100.853 164.106 101.004 164.619L67.0228 175.66C66.5701 174.173 66.1394 172.676 65.737 171.17C64.0645 164.924 62.8416 158.62 62.0682 152.282C61.4269 146.903 61.103 141.465 61.103 135.972C61.103 130.48 61.4269 125.041 62.0682 119.662C62.8416 113.325 64.0645 107.018 65.737 100.774C66.1394 99.2686 66.5701 97.7722 67.0228 96.2852L101.004 107.326C100.85 107.839 100.702 108.354 100.558 108.87L100.561 108.867Z",
    stroke: "url(#paint9_linear_11846_111534)",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M298.927 319.12C298.927 319.12 299.037 318.97 299.187 318.75C299.327 318.53 299.397 318.23 299.547 317.94C299.577 317.87 299.617 317.79 299.647 317.72C299.647 317.65 299.657 317.57 299.667 317.5C299.687 317.36 299.707 317.23 299.717 317.12C299.757 316.9 299.777 316.75 299.777 316.75H315.947C315.947 316.75 315.917 316.92 315.877 317.18C315.857 317.31 315.837 317.46 315.817 317.62C315.817 317.7 315.797 317.78 315.787 317.87C315.747 317.95 315.717 318.04 315.677 318.12C315.517 318.46 315.417 318.8 315.267 319.06C315.087 319.31 314.967 319.48 314.967 319.48L298.927 319.11V319.12Z",
    fill: "url(#paint10_linear_11846_111534)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M327.126 319.77C327.126 319.77 327.256 319.58 327.456 319.3C327.626 319.02 327.746 318.64 327.916 318.27C327.956 318.18 327.996 318.08 328.036 317.99C328.046 317.9 328.056 317.81 328.076 317.72C328.096 317.54 328.126 317.38 328.146 317.24C328.186 316.96 328.216 316.77 328.216 316.77H360.426C360.426 316.77 360.396 317 360.356 317.36C360.336 317.54 360.306 317.74 360.266 317.96C360.246 318.07 360.236 318.18 360.216 318.3C360.166 318.42 360.126 318.53 360.076 318.65C359.876 319.12 359.716 319.59 359.496 319.94C359.256 320.29 359.096 320.52 359.096 320.52L327.136 319.79L327.126 319.77Z",
    fill: "url(#paint11_linear_11846_111534)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M309.658 329C309.658 329 309.978 328.9 310.538 328.72C310.818 328.63 311.158 328.52 311.548 328.4C311.938 328.28 312.398 328.14 312.818 327.98C313.258 327.82 313.738 327.65 314.238 327.47C314.738 327.29 315.298 327.1 315.768 326.9C316.738 326.5 317.888 326.08 318.768 325.64C319.238 325.42 319.718 325.2 320.178 324.99C320.588 324.77 320.988 324.56 321.378 324.35C321.748 324.14 322.168 323.94 322.468 323.75C322.768 323.56 323.058 323.37 323.318 323.2C323.578 323.03 323.828 322.88 324.038 322.74C324.218 322.6 324.368 322.48 324.498 322.38C324.748 322.18 324.898 322.07 324.898 322.07L356.308 323.37C356.308 323.37 356.128 323.51 355.808 323.76C355.648 323.88 355.448 324.04 355.228 324.21C354.958 324.38 354.668 324.57 354.338 324.79C354.008 325 353.648 325.23 353.268 325.47C352.898 325.71 352.388 325.96 351.918 326.22C351.428 326.48 350.928 326.75 350.418 327.02C349.838 327.29 349.258 327.56 348.668 327.83C347.548 328.38 346.138 328.9 344.918 329.4C344.318 329.65 343.628 329.88 343.008 330.11C342.378 330.33 341.788 330.54 341.238 330.74C340.708 330.94 340.138 331.11 339.658 331.26C339.168 331.41 338.748 331.55 338.398 331.66C337.698 331.88 337.298 332.01 337.298 332.01L309.658 329Z",
    fill: "url(#paint12_linear_11846_111534)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.918 333.421C290.918 333.421 291.638 333.281 292.708 333.081C293.238 332.981 293.898 332.861 294.518 332.731C295.158 332.601 295.828 332.451 296.508 332.311C297.178 332.171 297.888 332.031 298.488 331.891C299.088 331.751 299.648 331.621 300.128 331.511C301.088 331.291 301.728 331.141 301.728 331.141L327.428 334.671C327.428 334.671 326.628 334.851 325.438 335.131C324.838 335.271 324.138 335.431 323.388 335.601C322.628 335.771 321.768 335.951 320.928 336.121C320.078 336.301 319.238 336.471 318.448 336.641C317.668 336.811 316.848 336.951 316.198 337.081C314.858 337.331 313.968 337.501 313.968 337.501L290.908 333.411L290.918 333.421Z",
    fill: "url(#paint13_linear_11846_111534)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.408 338.882C246.408 338.882 247.008 338.842 248.058 338.762C249.088 338.682 250.548 338.552 252.308 338.412C254.088 338.272 256.058 338.072 258.218 337.882C259.308 337.782 260.378 337.672 261.478 337.552C262.578 337.442 263.698 337.322 264.808 337.202C265.908 337.082 266.978 336.952 268.048 336.822C269.108 336.692 270.188 336.582 271.158 336.452C272.138 336.322 273.088 336.202 273.998 336.082C274.908 335.962 275.758 335.852 276.508 335.742C278.028 335.522 279.298 335.342 280.178 335.222C280.628 335.162 280.948 335.102 281.178 335.072C281.408 335.032 281.528 335.012 281.528 335.012L302.298 339.492C302.298 339.492 302.148 339.512 301.858 339.562C301.568 339.602 301.168 339.672 300.618 339.752C299.518 339.912 297.938 340.132 296.048 340.402C295.118 340.542 294.058 340.682 292.928 340.822C291.808 340.972 290.618 341.122 289.398 341.282C288.188 341.442 286.848 341.592 285.528 341.742C284.198 341.892 282.858 342.052 281.488 342.212C280.098 342.362 278.708 342.502 277.338 342.652C275.968 342.792 274.628 342.942 273.278 343.062C270.588 343.312 268.128 343.552 265.918 343.732C263.728 343.912 261.898 344.062 260.618 344.172C259.308 344.262 258.568 344.322 258.568 344.322L246.428 338.892L246.408 338.882Z",
    fill: "url(#paint14_linear_11846_111534)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.834 340.361C216.834 340.361 217.094 340.361 217.534 340.341C217.984 340.331 218.614 340.301 219.384 340.281C220.154 340.261 221.044 340.231 221.994 340.191C222.474 340.171 222.964 340.161 223.464 340.141C223.964 340.121 224.464 340.101 224.974 340.081C226.984 339.991 229.024 339.921 230.514 339.841C232.004 339.761 233.004 339.711 233.004 339.711L241.834 345.351C241.834 345.351 240.594 345.411 238.724 345.511C236.854 345.611 234.324 345.701 231.814 345.811C231.184 345.841 230.554 345.861 229.934 345.891C229.304 345.911 228.694 345.931 228.094 345.951C226.904 345.991 225.794 346.031 224.834 346.061C223.884 346.091 223.084 346.121 222.524 346.131C221.964 346.151 221.644 346.161 221.644 346.161L216.814 340.371L216.834 340.361Z",
    fill: "url(#paint15_linear_11846_111534)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.226 339.829C163.226 339.829 163.376 339.829 163.666 339.849C163.956 339.869 164.386 339.889 164.936 339.909C166.036 339.959 167.596 340.019 169.486 340.099C170.426 340.139 171.456 340.169 172.546 340.209C173.636 340.249 174.786 340.279 175.976 340.319C177.156 340.359 178.406 340.379 179.656 340.409C180.916 340.439 182.186 340.469 183.466 340.499C184.746 340.519 186.036 340.539 187.296 340.549C188.566 340.559 189.806 340.589 191.016 340.589C193.436 340.589 195.686 340.619 197.626 340.609C199.556 340.609 201.166 340.589 202.296 340.589C202.856 340.589 203.306 340.589 203.606 340.589C203.906 340.589 204.066 340.589 204.066 340.589L205.776 346.439C205.776 346.439 205.576 346.439 205.206 346.439C204.836 346.439 204.286 346.439 203.586 346.439C202.186 346.439 200.186 346.459 197.786 346.469C195.386 346.469 192.586 346.449 189.586 346.439C188.086 346.439 186.536 346.399 184.966 346.389C183.396 346.369 181.796 346.339 180.196 346.319C178.606 346.279 177.016 346.249 175.446 346.209C173.886 346.169 172.336 346.139 170.856 346.089C169.376 346.039 167.946 345.999 166.586 345.949C165.226 345.909 163.946 345.869 162.776 345.809C160.426 345.709 158.476 345.629 157.106 345.569C156.416 345.539 155.886 345.519 155.526 345.499C155.166 345.479 154.966 345.469 154.966 345.469L163.226 339.809V339.829Z",
    fill: "url(#paint16_linear_11846_111534)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.694 337.782C134.694 337.782 135.614 337.872 137.004 337.992C138.394 338.122 140.214 338.302 142.124 338.452C144.024 338.602 145.884 338.772 147.344 338.862C148.794 338.962 149.754 339.032 149.754 339.032L138.154 344.502C138.154 344.502 136.954 344.412 135.144 344.282C133.324 344.162 130.994 343.952 128.634 343.762C126.264 343.572 123.974 343.352 122.254 343.192C120.534 343.032 119.384 342.922 119.384 342.922L134.694 337.762V337.782Z",
    fill: "url(#paint17_linear_11846_111534)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.955 334.121C106.955 334.121 107.195 334.161 107.625 334.241C108.055 334.311 108.635 334.421 109.415 334.541C110.175 334.661 111.065 334.801 112.015 334.951C112.495 335.031 112.985 335.101 113.485 335.181C114.005 335.251 114.535 335.331 115.065 335.411C116.125 335.561 117.175 335.711 118.165 335.851C119.165 335.991 120.145 336.111 120.965 336.221C121.785 336.331 122.475 336.411 122.945 336.481C123.425 336.541 123.705 336.581 123.705 336.581L105.695 341.441C105.695 341.441 105.355 341.401 104.755 341.321C104.155 341.241 103.305 341.131 102.285 341.001C101.265 340.871 100.055 340.721 98.8052 340.541C97.5752 340.361 96.2552 340.181 94.9352 339.991C94.2752 339.901 93.6252 339.801 92.9752 339.711C92.3552 339.611 91.7352 339.521 91.1452 339.421C89.9652 339.231 88.8552 339.061 87.9052 338.911C86.9452 338.761 86.2152 338.631 85.6752 338.541C85.1452 338.451 84.8452 338.401 84.8452 338.401L106.955 334.141V334.121Z",
    fill: "url(#paint18_linear_11846_111534)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2865 328.992C84.2865 328.992 84.4165 329.032 84.6365 329.102C84.8665 329.172 85.2265 329.272 85.6465 329.392C86.0665 329.512 86.5565 329.652 87.0765 329.802C87.6065 329.952 88.1365 330.112 88.7565 330.262C89.9665 330.572 91.1465 330.882 92.0765 331.102C93.0365 331.322 93.6765 331.472 93.6765 331.472L68.3365 335.092C68.3365 335.092 67.5365 334.912 66.3465 334.632C65.1865 334.352 63.7065 333.962 62.2065 333.582C61.4365 333.392 60.7665 333.192 60.1065 333.012C59.4565 332.822 58.8465 332.652 58.3165 332.502C57.7965 332.352 57.3565 332.232 57.0665 332.142C56.7865 332.052 56.6265 332.002 56.6265 332.002L84.2665 328.992H84.2865Z",
    fill: "url(#paint19_linear_11846_111534)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8343 319.76C66.8343 319.76 66.9143 319.88 67.0543 320.08C67.1343 320.18 67.1943 320.31 67.3243 320.45C67.4643 320.59 67.6243 320.75 67.7943 320.92C67.9643 321.09 68.1443 321.28 68.3443 321.48C68.5443 321.68 68.8443 321.88 69.1043 322.1C69.3743 322.31 69.6643 322.53 69.9443 322.76C70.2943 322.98 70.6443 323.21 70.9943 323.43C72.3843 324.33 74.2043 325.21 75.6543 325.86C75.9943 326.02 76.3643 326.17 76.6843 326.3C77.0043 326.43 77.2943 326.54 77.5243 326.64C77.9843 326.83 78.2543 326.93 78.2543 326.93L49.1243 329.43C49.1243 329.43 48.7943 329.3 48.2143 329.06C47.9243 328.94 47.5743 328.8 47.1743 328.64C46.7743 328.48 46.3143 328.3 45.8843 328.09C44.0643 327.28 41.8043 326.18 40.0643 325.06C39.6243 324.78 39.1943 324.5 38.7643 324.22C38.4043 323.94 38.0443 323.66 37.7043 323.4C37.3743 323.13 37.0143 322.88 36.7643 322.63C36.5243 322.38 36.2943 322.15 36.0743 321.93C35.8643 321.71 35.6743 321.52 35.5043 321.34C35.3443 321.16 35.2643 321.01 35.1643 320.88C34.9843 320.63 34.8843 320.48 34.8843 320.48L66.8443 319.75L66.8343 319.76Z",
    fill: "url(#paint20_linear_11846_111534)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.534 314.169C66.534 314.169 66.504 314.219 66.444 314.299C66.414 314.379 66.364 314.499 66.304 314.639C66.204 314.919 65.984 315.299 65.914 315.679C65.864 316.059 65.804 316.439 65.764 316.719C65.794 316.999 65.824 317.189 65.824 317.189L33.624 317.289C33.624 317.289 33.584 317.059 33.564 316.699C33.614 316.349 33.674 315.879 33.744 315.409C33.834 314.939 34.094 314.469 34.224 314.119C34.304 313.939 34.364 313.799 34.414 313.699C34.484 313.599 34.524 313.539 34.524 313.539L66.544 314.169H66.534Z",
    fill: "url(#paint21_linear_11846_111534)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1354 304.892C83.1354 304.892 82.8154 304.992 82.2554 305.172C81.6654 305.342 80.9554 305.612 80.0754 305.922C79.6354 306.082 79.1554 306.252 78.6554 306.432C78.2054 306.612 77.7254 306.812 77.2254 307.012C76.9754 307.112 76.7254 307.212 76.4654 307.312C76.3354 307.362 76.2054 307.412 76.0754 307.472C75.9654 307.522 75.8454 307.582 75.7254 307.632C75.2654 307.842 74.7854 308.062 74.3154 308.282C74.0854 308.392 73.8254 308.502 73.6254 308.612C73.4254 308.722 73.2154 308.832 73.0154 308.942C72.6054 309.162 72.2054 309.372 71.8254 309.582C71.1254 310.002 70.5454 310.402 69.9954 310.732C69.1154 311.412 68.5354 311.872 68.5354 311.872L37.0054 310.682C37.0054 310.682 37.1854 310.542 37.4954 310.292C37.8154 310.042 38.2454 309.682 38.8354 309.262C39.4954 308.842 40.2254 308.342 41.1154 307.822C41.5954 307.562 42.0954 307.292 42.5954 307.022C42.8454 306.882 43.1054 306.752 43.3654 306.612C43.6254 306.472 43.9354 306.342 44.2254 306.202C44.8154 305.932 45.4054 305.662 45.9854 305.392C46.1354 305.322 46.2754 305.262 46.4254 305.192C46.5854 305.132 46.7454 305.062 46.9054 305.002C47.2254 304.872 47.5354 304.742 47.8454 304.622C48.4654 304.372 49.0654 304.132 49.6354 303.902C50.2554 303.682 50.8454 303.462 51.3954 303.272C52.4954 302.882 53.3954 302.552 54.1154 302.342C54.8154 302.122 55.2154 301.992 55.2154 301.992L83.1454 304.912L83.1354 304.892Z",
    fill: "url(#paint22_linear_11846_111534)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.414 300.401C101.414 300.401 101.234 300.431 100.924 300.491C100.614 300.551 100.154 300.631 99.6344 300.741C98.6144 300.951 97.2544 301.241 95.8944 301.521C94.6044 301.821 93.3244 302.111 92.3644 302.331C91.8744 302.441 91.5044 302.541 91.2444 302.601C90.9844 302.671 90.8344 302.711 90.8344 302.711L64.7944 299.261C64.7944 299.261 64.9844 299.211 65.3144 299.131C65.6444 299.051 66.1044 298.931 66.7144 298.791C67.9144 298.511 69.4944 298.141 71.1144 297.781C72.8044 297.421 74.4944 297.071 75.7644 296.801C76.4044 296.671 76.9744 296.561 77.3644 296.491C77.7544 296.421 77.9744 296.371 77.9744 296.371L101.434 300.391L101.414 300.401Z",
    fill: "url(#paint23_linear_11846_111534)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.376 294.8C145.376 294.8 144.786 294.85 143.766 294.93C142.746 295.02 141.256 295.13 139.526 295.28C137.816 295.44 135.786 295.62 133.676 295.83C132.626 295.94 131.546 296.05 130.446 296.17C129.896 296.23 129.336 296.28 128.786 296.34C128.246 296.4 127.706 296.47 127.166 296.53C126.086 296.66 124.996 296.78 123.926 296.91C122.876 297.04 121.876 297.17 120.886 297.3C119.906 297.43 118.936 297.55 118.066 297.67C117.196 297.79 116.376 297.91 115.616 298.02C114.856 298.13 114.156 298.23 113.546 298.32C112.956 298.41 112.436 298.5 112.006 298.56C111.156 298.69 110.666 298.77 110.666 298.77L89.4663 294.36C89.4663 294.36 90.0763 294.26 91.1363 294.1C91.6663 294.02 92.3163 293.92 93.0563 293.8C93.8263 293.69 94.6863 293.57 95.6363 293.43C96.5863 293.3 97.6063 293.15 98.6863 292.99C99.7763 292.84 100.976 292.69 102.196 292.53C103.426 292.37 104.676 292.21 105.986 292.05C107.316 291.89 108.666 291.74 110.016 291.58C110.696 291.5 111.366 291.42 112.036 291.34C112.716 291.26 113.416 291.19 114.096 291.12C115.466 290.98 116.816 290.84 118.116 290.7C120.746 290.43 123.276 290.21 125.406 290.01C127.566 289.82 129.416 289.67 130.686 289.57C131.966 289.47 132.696 289.41 132.696 289.41L145.376 294.8Z",
    fill: "url(#paint24_linear_11846_111534)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174.804 293.219C174.804 293.219 173.784 293.249 172.254 293.299C170.714 293.339 168.704 293.429 166.684 293.519C165.674 293.559 164.654 293.599 163.724 293.649C162.794 293.699 161.914 293.739 161.174 293.779C159.674 293.859 158.684 293.909 158.684 293.909L149.294 288.299C149.294 288.299 150.534 288.239 152.404 288.139C153.334 288.089 154.424 288.039 155.594 287.979C156.764 287.919 158.024 287.869 159.284 287.819C161.804 287.709 164.314 287.599 166.234 287.549C168.144 287.489 169.414 287.449 169.414 287.449L174.814 293.229L174.804 293.219Z",
    fill: "url(#paint25_linear_11846_111534)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.045 292.981C209.045 292.981 207.705 292.961 205.695 292.931C203.685 292.891 200.995 292.891 198.305 292.881C196.955 292.871 195.615 292.881 194.355 292.881C193.095 292.881 191.915 292.891 190.905 292.901C189.895 292.901 189.065 292.921 188.475 292.931C187.885 292.931 187.555 292.941 187.555 292.941L185.275 287.091C185.275 287.091 185.695 287.091 186.425 287.071C187.155 287.071 188.195 287.041 189.445 287.041C190.695 287.041 192.155 287.031 193.725 287.021C195.295 287.021 196.955 287.001 198.625 287.021C201.965 287.041 205.305 287.041 207.805 287.081C210.305 287.111 211.975 287.141 211.975 287.141L209.055 292.981H209.045Z",
    fill: "url(#paint26_linear_11846_111534)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M244.256 294.479C244.256 294.479 243.296 294.409 241.846 294.309C240.376 294.219 238.406 294.099 236.446 293.979C234.466 293.869 232.466 293.769 230.966 293.689C230.216 293.649 229.596 293.619 229.156 293.599C228.716 293.579 228.466 293.569 228.466 293.569L236.166 287.879C236.166 287.879 236.476 287.889 237.036 287.919C237.586 287.939 238.366 287.979 239.296 288.029C241.156 288.129 243.656 288.249 246.126 288.389C248.576 288.539 251.026 288.689 252.856 288.799C254.676 288.919 255.866 289.009 255.866 289.009L244.256 294.479Z",
    fill: "url(#paint27_linear_11846_111534)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M289.296 299.791C289.296 299.791 288.826 299.711 288.016 299.571C287.186 299.431 286.066 299.221 284.616 298.991C283.886 298.881 283.096 298.751 282.256 298.621C281.416 298.491 280.556 298.341 279.596 298.211C277.676 297.941 275.716 297.641 273.576 297.381C272.526 297.241 271.476 297.111 270.446 296.971C269.376 296.851 268.326 296.721 267.316 296.601C266.286 296.481 265.336 296.361 264.366 296.261C263.406 296.161 262.496 296.061 261.666 295.981C260.826 295.891 260.066 295.811 259.376 295.741C258.676 295.681 258.066 295.621 257.566 295.571C256.566 295.481 255.986 295.421 255.986 295.421L270.496 290.191C270.496 290.191 271.206 290.261 272.456 290.371C273.076 290.431 273.836 290.501 274.706 290.581C275.566 290.671 276.516 290.771 277.556 290.881C278.596 290.991 279.726 291.111 280.926 291.231C282.126 291.351 283.326 291.501 284.596 291.651C285.856 291.801 287.166 291.951 288.496 292.111C289.786 292.281 291.086 292.441 292.396 292.611C295.046 292.941 297.506 293.311 299.886 293.651C301.086 293.821 302.156 293.991 303.206 294.161C304.246 294.321 305.226 294.481 306.136 294.621C307.936 294.911 309.346 295.171 310.376 295.341C311.386 295.521 311.966 295.621 311.966 295.621L289.306 299.781L289.296 299.791Z",
    fill: "url(#paint28_linear_11846_111534)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.444 304.16C308.444 304.16 307.884 304 307.044 303.76C306.614 303.64 306.154 303.5 305.594 303.35C305.034 303.21 304.424 303.05 303.824 302.9C303.224 302.75 302.624 302.59 302.054 302.45C301.454 302.31 300.894 302.18 300.414 302.07C299.454 301.85 298.814 301.7 298.814 301.7L323.794 298C323.794 298 324.594 298.18 325.794 298.46C326.394 298.6 327.084 298.76 327.834 298.93C328.534 299.11 329.294 299.3 330.044 299.49C330.794 299.68 331.534 299.87 332.234 300.05C332.924 300.23 333.514 300.41 334.044 300.55C335.084 300.85 335.784 301.04 335.784 301.04L308.444 304.14V304.16Z",
    fill: "url(#paint29_linear_11846_111534)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M328.205 316.759C328.205 316.759 328.185 316.589 328.135 316.289C328.075 315.989 328.105 315.559 327.825 315.049C327.525 314.029 326.455 312.669 324.755 311.339C324.545 311.169 324.335 311.009 324.125 310.839C323.895 310.679 323.625 310.509 323.375 310.349C322.845 310.029 322.435 309.699 321.825 309.399C321.255 309.099 320.715 308.799 320.195 308.529C319.605 308.259 319.045 307.999 318.525 307.759C318.265 307.639 318.035 307.529 317.775 307.419C317.515 307.309 317.255 307.209 317.025 307.119C316.555 306.929 316.145 306.769 315.805 306.629C315.465 306.489 315.205 306.389 314.995 306.319C314.795 306.249 314.685 306.209 314.685 306.209L343.565 303.609C343.565 303.609 343.695 303.659 343.945 303.749C344.205 303.839 344.535 303.969 344.955 304.139C345.375 304.309 345.895 304.519 346.475 304.749C346.765 304.869 347.075 304.989 347.405 305.129C347.725 305.259 348.015 305.409 348.345 305.559C348.985 305.859 349.685 306.179 350.425 306.519C351.075 306.869 351.755 307.229 352.465 307.609C353.205 307.989 353.755 308.389 354.405 308.789C354.715 308.989 355.045 309.189 355.335 309.399C355.595 309.609 355.865 309.809 356.125 310.019C358.255 311.679 359.555 313.369 359.945 314.649C360.265 315.289 360.255 315.819 360.325 316.189C360.375 316.559 360.395 316.769 360.395 316.769H328.185L328.205 316.759Z",
    fill: "url(#paint30_linear_11846_111534)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M388.446 316.76C388.446 316.76 388.416 316.54 388.376 316.13C388.346 315.92 388.306 315.67 388.266 315.37C388.236 315.22 388.236 315.06 388.166 314.89C388.096 314.72 388.026 314.54 387.946 314.34C387.416 312.8 385.986 310.58 382.316 308C380.386 306.71 378.106 305.33 374.936 303.91C373.456 303.19 371.616 302.49 369.796 301.76C368.846 301.4 367.806 301.04 366.786 300.68C366.266 300.5 365.746 300.32 365.226 300.13C364.666 299.95 364.106 299.77 363.536 299.59C362.386 299.23 361.286 298.86 360.036 298.51C358.786 298.15 357.526 297.8 356.256 297.44C354.966 297.08 353.566 296.74 352.196 296.38C351.496 296.2 350.826 296.03 350.096 295.85C349.366 295.68 348.626 295.51 347.886 295.34C344.986 294.65 341.786 293.99 338.586 293.32C336.916 293 335.246 292.68 333.566 292.36L332.296 292.12L330.986 291.89L328.346 291.43C314.236 288.99 297.946 286.98 281.536 285.51L280.006 285.37L278.456 285.24C277.426 285.15 276.396 285.07 275.376 284.99C273.326 284.82 271.306 284.65 269.246 284.51C267.196 284.36 265.166 284.22 263.166 284.08C261.146 283.95 259.126 283.83 257.136 283.7C256.136 283.64 255.156 283.58 254.176 283.52C253.186 283.46 252.196 283.41 251.216 283.36C249.256 283.26 247.326 283.16 245.426 283.06C243.516 282.97 241.616 282.89 239.766 282.81C237.906 282.74 236.096 282.65 234.296 282.59C232.496 282.53 230.736 282.47 229.006 282.42C228.146 282.39 227.296 282.37 226.446 282.34C225.606 282.31 224.766 282.3 223.936 282.28C222.286 282.24 220.676 282.2 219.106 282.17C218.326 282.15 217.556 282.14 216.796 282.12C216.036 282.1 215.286 282.1 214.546 282.08C211.596 282.04 208.826 282 206.266 281.97C203.706 281.96 201.356 281.95 199.236 281.94C197.116 281.93 195.216 281.94 193.566 281.94C191.916 281.94 190.516 281.95 189.376 281.96C187.106 281.96 185.886 281.99 185.886 281.99L185.576 281C185.576 281 186.826 280.98 189.156 280.97C190.326 280.97 191.766 280.96 193.466 280.95C195.156 280.95 197.106 280.93 199.296 280.95C201.476 280.96 203.896 280.97 206.526 280.98C209.156 281.01 212.006 281.05 215.036 281.09C215.796 281.1 216.566 281.11 217.346 281.13C218.126 281.15 218.926 281.16 219.726 281.18C221.336 281.22 222.986 281.26 224.686 281.3C225.536 281.32 226.396 281.34 227.266 281.36C228.136 281.39 229.006 281.41 229.896 281.44C231.666 281.5 233.486 281.56 235.336 281.62C237.186 281.68 239.056 281.77 240.966 281.84C242.876 281.92 244.826 282 246.786 282.09C248.736 282.19 250.726 282.29 252.746 282.4C253.756 282.45 254.776 282.5 255.786 282.56C256.796 282.62 257.816 282.68 258.836 282.75C260.876 282.88 262.956 283 265.036 283.14C267.096 283.29 269.186 283.44 271.296 283.59C273.416 283.74 275.496 283.91 277.606 284.08C278.656 284.17 279.716 284.25 280.776 284.34L282.366 284.47L283.936 284.61C300.806 286.12 317.556 288.19 332.076 290.7L334.786 291.17L336.136 291.41L337.436 291.66C339.156 291.99 340.876 292.32 342.596 292.65C345.886 293.33 349.176 294.01 352.156 294.72C352.916 294.9 353.666 295.07 354.426 295.25C355.166 295.43 355.866 295.61 356.586 295.79C357.996 296.15 359.436 296.51 360.766 296.88C362.076 297.25 363.366 297.62 364.656 297.98C365.936 298.35 367.076 298.73 368.256 299.09C368.836 299.28 369.416 299.46 369.996 299.65C370.536 299.84 371.066 300.03 371.606 300.21C372.656 300.58 373.716 300.95 374.696 301.32C376.566 302.07 378.456 302.8 379.986 303.54C383.246 305 385.596 306.42 387.576 307.74C391.346 310.4 392.826 312.67 393.366 314.26C393.446 314.46 393.516 314.65 393.586 314.82C393.656 315 393.656 315.16 393.686 315.32C393.726 315.63 393.766 315.89 393.796 316.1C393.846 316.53 393.866 316.75 393.866 316.75H388.426L388.446 316.76Z",
    fill: "url(#paint31_linear_11846_111534)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.866 283.282C143.866 283.282 142.696 283.342 140.496 283.462C138.316 283.592 135.136 283.782 131.096 284.042C123.096 284.582 111.796 285.452 99.2059 286.812C97.6059 286.972 96.0559 287.162 94.4459 287.352C92.8459 287.542 91.2059 287.732 89.5759 287.922C87.9659 288.132 86.3359 288.342 84.6759 288.552C83.8559 288.662 83.0159 288.762 82.1859 288.882C81.3759 289.002 80.5559 289.112 79.7259 289.232C73.0659 290.152 66.5159 291.232 60.1059 292.412C47.3559 294.782 35.6259 297.662 26.7459 300.822C24.4559 301.602 22.4859 302.422 20.5159 303.232C19.6259 303.642 18.7259 304.052 17.8359 304.462L17.1759 304.772L16.5859 305.082C16.1959 305.292 15.8059 305.502 15.4259 305.702C15.0459 305.912 14.6659 306.112 14.2859 306.322C13.9159 306.532 13.6059 306.742 13.2759 306.952C12.6359 307.372 11.9559 307.782 11.3759 308.202C10.8459 308.622 10.3159 309.032 9.79588 309.442L9.41588 309.752L9.10588 310.062C8.90588 310.272 8.69588 310.472 8.49588 310.682C7.61588 311.502 7.14588 312.312 6.58588 313.102C6.35588 313.502 6.21588 313.892 6.04588 314.282C5.88588 314.672 5.72588 315.052 5.69588 315.432C5.64588 315.812 5.59588 316.182 5.54588 316.552C5.49587 316.922 5.59588 317.282 5.62588 317.642C5.68588 318.002 5.70588 318.352 5.82588 318.692C5.96588 319.032 6.10588 319.372 6.23588 319.702C7.43588 322.352 10.1659 324.532 12.4159 326.022C13.0059 326.392 13.5259 326.732 13.9859 327.022C14.4659 327.312 14.9459 327.552 15.3059 327.752C16.0459 328.142 16.4359 328.352 16.4359 328.352L11.3059 328.682C11.3059 328.682 10.9059 328.462 10.1459 328.062C9.77588 327.862 9.29588 327.612 8.79588 327.312C8.32588 327.012 7.78587 326.672 7.18587 326.282C4.86587 324.742 2.05588 322.502 0.825882 319.782C0.685882 319.442 0.545876 319.092 0.405876 318.742C0.275876 318.392 0.265879 318.032 0.205879 317.662C0.175879 317.292 0.0658749 316.922 0.115875 316.542C0.165875 316.162 0.215876 315.782 0.265876 315.392C0.295876 315.002 0.455877 314.602 0.625877 314.202C0.795877 313.802 0.94588 313.392 1.17588 312.992C1.73588 312.172 2.23588 311.342 3.13588 310.502C3.34588 310.292 3.55588 310.082 3.76588 309.872L4.08588 309.552L4.47588 309.232C5.01588 308.812 5.55588 308.382 6.10588 307.952C6.69588 307.522 7.39588 307.102 8.05588 306.672C8.40588 306.462 8.71588 306.242 9.09588 306.032C9.48588 305.822 9.87588 305.602 10.2659 305.392C10.6659 305.182 11.0659 304.962 11.4659 304.752L12.0759 304.432L12.7459 304.112C13.6659 303.692 14.5759 303.272 15.4959 302.842C17.5259 302.012 19.5459 301.172 21.8959 300.372C31.0259 297.122 43.0859 294.162 56.1959 291.722C62.7859 290.512 69.5259 289.402 76.3759 288.452C77.2259 288.332 78.0659 288.212 78.9059 288.092C79.7559 287.972 80.6159 287.862 81.4659 287.752C83.1759 287.532 84.8559 287.312 86.5059 287.102C88.1859 286.892 89.8759 286.702 91.5159 286.512C93.1659 286.322 94.7659 286.132 96.4059 285.962C109.346 284.562 120.976 283.672 129.206 283.122C133.356 282.862 136.626 282.662 138.876 282.532C141.136 282.412 142.346 282.352 142.346 282.352L143.856 283.302L143.866 283.282Z",
    fill: "url(#paint32_linear_11846_111534)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0546 335.34C35.0546 335.34 35.7146 335.53 36.9446 335.88C38.1446 336.23 40.1146 336.73 42.5846 337.36C47.6446 338.61 55.3146 340.34 65.9546 342.16C76.5346 343.99 90.2546 345.87 106.335 347.46C114.395 348.25 123.055 348.95 132.075 349.55C141.115 350.15 150.575 350.61 160.145 350.96C162.545 351.04 164.945 351.12 167.345 351.19C169.755 351.26 172.165 351.31 174.575 351.36C175.775 351.39 176.985 351.42 178.185 351.44C179.385 351.46 180.595 351.47 181.795 351.49C182.995 351.51 184.195 351.52 185.395 351.54L187.195 351.56H188.985C191.375 351.58 193.755 351.59 196.115 351.6C198.485 351.6 200.835 351.59 203.175 351.58C204.345 351.58 205.515 351.57 206.675 351.56C207.835 351.55 208.995 351.53 210.155 351.52C212.465 351.49 214.755 351.46 217.025 351.42C221.555 351.32 226.025 351.23 230.345 351.07C231.425 351.03 232.505 351 233.575 350.96C234.645 350.92 235.715 350.89 236.755 350.84C238.855 350.75 240.925 350.67 242.965 350.58C245.015 350.5 246.995 350.39 248.965 350.29C250.925 350.19 252.865 350.09 254.745 349.98C256.615 349.87 258.455 349.75 260.265 349.64C261.165 349.58 262.055 349.53 262.935 349.47C263.805 349.41 264.665 349.35 265.525 349.29C279.215 348.33 289.915 347.25 297.195 346.45C298.995 346.24 300.595 346.05 301.985 345.89C302.675 345.81 303.325 345.73 303.915 345.66C304.485 345.59 305.015 345.52 305.475 345.46C307.335 345.22 308.335 345.09 308.335 345.09L311.505 345.89C311.505 345.89 310.485 346.02 308.565 346.27C308.085 346.33 307.545 346.4 306.955 346.47C306.345 346.54 305.685 346.62 304.975 346.7C303.545 346.87 301.895 347.06 300.045 347.27C292.565 348.1 281.555 349.21 267.475 350.2C266.595 350.26 265.715 350.32 264.815 350.39C263.905 350.45 262.985 350.51 262.065 350.56C260.205 350.67 258.315 350.79 256.395 350.91C254.465 351.03 252.465 351.12 250.455 351.23C248.435 351.33 246.395 351.45 244.285 351.53C242.185 351.62 240.055 351.71 237.895 351.8C236.815 351.85 235.725 351.88 234.625 351.92C233.525 351.96 232.415 351.99 231.305 352.03C226.855 352.19 222.265 352.28 217.605 352.39C215.275 352.43 212.915 352.46 210.535 352.5C209.345 352.52 208.155 352.53 206.965 352.55C205.765 352.55 204.575 352.56 203.365 352.57C200.955 352.57 198.535 352.6 196.105 352.59C193.675 352.58 191.225 352.57 188.775 352.56H186.935L185.085 352.53C183.855 352.51 182.615 352.5 181.385 352.48C180.145 352.46 178.915 352.44 177.675 352.43C176.435 352.41 175.205 352.38 173.965 352.35C171.485 352.29 169.005 352.24 166.535 352.17C164.065 352.09 161.595 352.01 159.125 351.93C149.285 351.57 139.555 351.09 130.255 350.48C120.965 349.86 112.065 349.14 103.775 348.33C87.2346 346.7 73.1246 344.76 62.2446 342.88C51.2946 341.01 43.4146 339.23 38.2046 337.95C35.6646 337.3 33.6346 336.79 32.4046 336.43C31.1346 336.07 30.4546 335.88 30.4546 335.88L35.0546 335.35V335.34Z",
    fill: "url(#paint33_linear_11846_111534)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M185.897 351.54C185.897 351.54 187.107 351.56 189.387 351.57C190.527 351.57 191.927 351.58 193.577 351.59C195.227 351.59 197.117 351.61 199.247 351.59C201.367 351.58 203.717 351.57 206.277 351.56C208.837 351.54 211.607 351.49 214.557 351.45C215.297 351.44 216.047 351.43 216.807 351.41C217.567 351.39 218.337 351.38 219.117 351.36C220.677 351.32 222.287 351.29 223.947 351.25C224.767 351.23 225.607 351.21 226.457 351.19C227.297 351.16 228.147 351.14 229.017 351.11C230.737 351.05 232.507 351 234.307 350.94C236.107 350.88 237.917 350.8 239.777 350.72C241.627 350.64 243.527 350.57 245.437 350.47C247.337 350.37 249.267 350.27 251.227 350.17C252.207 350.12 253.197 350.07 254.187 350.01C255.167 349.95 256.157 349.89 257.147 349.83C259.137 349.71 261.157 349.59 263.177 349.45C265.177 349.31 267.207 349.16 269.257 349.02C271.317 348.88 273.337 348.71 275.387 348.54C276.407 348.46 277.437 348.37 278.467 348.29L280.017 348.16L281.547 348.02C297.947 346.55 314.247 344.54 328.357 342.1L330.997 341.64L332.307 341.41L333.577 341.17C335.257 340.85 336.927 340.53 338.597 340.21C341.797 339.55 344.987 338.89 347.897 338.19C348.637 338.02 349.367 337.85 350.107 337.68C350.827 337.51 351.507 337.33 352.207 337.15C353.577 336.8 354.977 336.45 356.267 336.09C357.537 335.73 358.797 335.37 360.047 335.02C361.297 334.66 362.397 334.3 363.547 333.94C364.117 333.76 364.677 333.58 365.237 333.4C365.757 333.22 366.277 333.03 366.797 332.85C367.817 332.49 368.857 332.13 369.807 331.77C371.627 331.04 373.467 330.33 374.947 329.62C378.117 328.21 380.397 326.82 382.327 325.53C385.997 322.95 387.427 320.73 387.957 319.19C388.037 319 388.107 318.81 388.177 318.64C388.247 318.47 388.247 318.31 388.277 318.16C388.317 317.86 388.357 317.6 388.387 317.4C388.437 316.99 388.457 316.77 388.457 316.77H393.897C393.897 316.77 393.867 317 393.827 317.42C393.797 317.63 393.757 317.9 393.717 318.2C393.687 318.35 393.687 318.52 393.617 318.7C393.547 318.88 393.477 319.06 393.397 319.26C392.847 320.85 391.377 323.12 387.607 325.78C385.627 327.1 383.277 328.53 380.017 329.98C378.497 330.72 376.607 331.45 374.727 332.2C373.747 332.57 372.687 332.94 371.637 333.31C371.107 333.5 370.567 333.68 370.027 333.87C369.447 334.05 368.867 334.24 368.287 334.43C367.107 334.8 365.967 335.18 364.687 335.54C363.397 335.91 362.107 336.27 360.797 336.64C359.467 337.01 358.027 337.36 356.617 337.73C355.897 337.91 355.207 338.09 354.457 338.27C353.707 338.45 352.947 338.62 352.187 338.8C349.197 339.51 345.917 340.19 342.627 340.87C340.907 341.2 339.187 341.53 337.467 341.86L336.167 342.11L334.817 342.35L332.107 342.82C317.597 345.33 300.837 347.4 283.967 348.91L282.397 349.05L280.807 349.18C279.747 349.27 278.687 349.36 277.637 349.44C275.527 349.61 273.447 349.79 271.327 349.93C269.217 350.08 267.127 350.23 265.067 350.38C262.987 350.52 260.907 350.64 258.867 350.77C257.847 350.83 256.827 350.89 255.817 350.96C254.797 351.02 253.787 351.07 252.777 351.12C250.757 351.22 248.767 351.33 246.817 351.43C244.857 351.52 242.907 351.6 240.997 351.68C239.087 351.76 237.217 351.85 235.367 351.9C233.517 351.96 231.707 352.02 229.927 352.08C229.037 352.11 228.167 352.14 227.297 352.16C226.427 352.19 225.567 352.2 224.717 352.22C223.017 352.26 221.367 352.3 219.757 352.34C218.947 352.36 218.157 352.38 217.377 352.39C216.597 352.41 215.827 352.41 215.067 352.43C212.027 352.47 209.187 352.52 206.557 352.54C203.927 352.55 201.507 352.56 199.327 352.57C197.147 352.58 195.197 352.57 193.497 352.57C191.807 352.57 190.357 352.56 189.187 352.55C186.847 352.55 185.607 352.52 185.607 352.52L185.917 351.53L185.897 351.54Z",
    fill: "url(#paint34_linear_11846_111534)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M302.044 328.17C302.044 328.17 302.554 328.01 303.454 327.72C304.404 327.44 305.534 327.02 306.954 326.52C309.654 325.51 312.774 324.12 314.924 322.68C317.134 321.24 318.374 319.75 318.864 318.63C318.974 318.35 319.104 318.09 319.174 317.86C319.204 317.63 319.234 317.43 319.254 317.27C319.304 316.94 319.334 316.75 319.334 316.75H324.354C324.354 316.75 324.324 316.95 324.274 317.29C324.254 317.46 324.224 317.67 324.194 317.91C324.114 318.15 323.984 318.41 323.874 318.71C323.354 319.88 322.074 321.42 319.764 322.93C317.524 324.43 314.274 325.88 311.464 326.93C309.994 327.45 308.804 327.89 307.824 328.18C306.894 328.48 306.354 328.64 306.354 328.64L302.044 328.17Z",
    fill: "url(#paint35_linear_11846_111534)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M292.867 316.76C292.867 316.76 292.847 316.65 292.807 316.44C292.797 316.34 292.777 316.21 292.757 316.05C292.737 315.97 292.757 315.89 292.717 315.8C292.677 315.71 292.637 315.62 292.587 315.52C292.317 314.72 291.597 313.54 289.377 312.1C289.097 311.92 288.817 311.74 288.517 311.55C288.167 311.36 287.807 311.17 287.447 310.98C287.127 310.78 286.657 310.59 286.227 310.39C285.777 310.19 285.397 309.98 284.847 309.78C282.907 308.95 280.357 308.09 277.207 307.22C270.917 305.48 261.987 303.69 250.217 302.26C244.327 301.55 237.787 300.93 230.697 300.44C229.827 300.37 228.907 300.33 228.007 300.27C227.097 300.22 226.197 300.15 225.277 300.1C224.347 300.05 223.417 300.01 222.487 299.96L221.087 299.89C220.617 299.87 220.137 299.85 219.657 299.83C218.707 299.79 217.747 299.75 216.787 299.71C215.827 299.67 214.837 299.65 213.857 299.61L212.387 299.56L211.647 299.53L210.897 299.51C209.897 299.49 208.897 299.46 207.897 299.44C206.897 299.41 205.877 299.4 204.857 299.39C203.837 299.38 202.817 299.36 201.787 299.35C200.757 299.35 199.717 299.35 198.677 299.34H197.117C196.597 299.34 196.077 299.34 195.547 299.34C194.497 299.34 193.457 299.34 192.397 299.35C191.347 299.35 190.307 299.38 189.257 299.39C187.147 299.41 185.067 299.47 182.947 299.51C178.767 299.63 174.537 299.78 170.407 300.01C168.307 300.1 166.287 300.25 164.207 300.37C163.187 300.44 162.177 300.52 161.157 300.59L159.627 300.7L158.127 300.83C150.067 301.47 142.387 302.35 135.397 303.41L132.807 303.82C131.957 303.96 131.157 304.11 130.317 304.25C129.907 304.32 129.477 304.39 129.067 304.47L127.887 304.7L126.697 304.93C126.297 305 125.887 305.08 125.527 305.16C122.437 305.78 119.657 306.46 117.047 307.15L115.167 307.68C114.547 307.86 114.017 308.05 113.417 308.23C113.127 308.32 112.827 308.41 112.547 308.5L111.767 308.78L110.967 309.06C110.697 309.15 110.427 309.25 110.207 309.35L108.767 309.93C108.297 310.12 107.917 310.32 107.477 310.52C107.267 310.62 107.027 310.72 106.837 310.82L106.287 311.12L105.727 311.42C105.527 311.52 105.337 311.62 105.197 311.72L104.237 312.33C103.927 312.54 103.717 312.74 103.437 312.95L103.037 313.26L102.737 313.58C102.547 313.79 102.277 314 102.137 314.21C101.447 315.06 101.177 315.92 101.097 316.78C101.187 317.64 101.457 318.5 102.137 319.35C102.277 319.56 102.547 319.77 102.737 319.98L103.037 320.3L103.437 320.61C103.717 320.82 103.927 321.03 104.237 321.23L105.197 321.84C105.337 321.94 105.527 322.04 105.727 322.14L106.287 322.44L106.837 322.74C107.037 322.84 107.267 322.94 107.477 323.04C107.917 323.24 108.307 323.44 108.767 323.63L110.207 324.21C110.427 324.31 110.697 324.4 110.967 324.5L111.767 324.78L112.547 325.06C112.827 325.15 113.127 325.24 113.417 325.33C114.007 325.51 114.547 325.7 115.167 325.88L117.047 326.41C119.667 327.11 122.437 327.78 125.527 328.4C125.887 328.48 126.297 328.56 126.697 328.63L127.887 328.86L129.067 329.09C129.477 329.16 129.897 329.23 130.317 329.31C131.157 329.45 131.957 329.6 132.807 329.74L135.397 330.15C142.387 331.21 150.067 332.09 158.127 332.73L159.627 332.86L161.157 332.97C162.177 333.04 163.187 333.12 164.207 333.19C166.287 333.31 168.307 333.46 170.407 333.55C174.537 333.78 178.757 333.92 182.947 334.05C185.057 334.09 187.137 334.16 189.257 334.17C190.307 334.18 191.347 334.21 192.397 334.21C193.447 334.21 194.497 334.21 195.547 334.22C196.067 334.22 196.587 334.22 197.117 334.22H198.677C199.717 334.21 200.747 334.2 201.787 334.2C202.817 334.19 203.837 334.17 204.857 334.16C205.877 334.15 206.897 334.14 207.897 334.11C208.897 334.09 209.897 334.06 210.897 334.04L211.647 334.02L212.387 333.99L213.857 333.94C214.837 333.91 215.817 333.88 216.787 333.84C217.747 333.8 218.707 333.76 219.657 333.72C220.137 333.7 220.617 333.68 221.087 333.66L222.487 333.59C223.427 333.54 224.357 333.49 225.277 333.45C226.197 333.4 227.097 333.34 228.007 333.28C228.907 333.22 229.827 333.18 230.697 333.11C237.787 332.62 244.327 332 250.217 331.29C261.977 329.86 270.917 328.07 277.207 326.33C280.357 325.46 282.907 324.59 284.847 323.77C285.397 323.57 285.787 323.36 286.227 323.16C286.657 322.96 287.127 322.77 287.447 322.57C287.817 322.37 288.167 322.18 288.517 322C288.807 321.81 289.097 321.63 289.377 321.45C291.597 320.01 292.307 318.83 292.587 318.03C292.637 317.93 292.677 317.83 292.717 317.75C292.767 317.66 292.737 317.58 292.757 317.5C292.777 317.35 292.797 317.22 292.807 317.11C292.847 316.9 292.867 316.79 292.867 316.79H295.667C295.667 316.79 295.647 316.9 295.607 317.12C295.597 317.23 295.577 317.36 295.557 317.52C295.537 317.6 295.557 317.69 295.517 317.78C295.477 317.87 295.427 317.97 295.387 318.07C295.107 318.9 294.367 320.11 292.087 321.59C291.797 321.77 291.507 321.97 291.207 322.16C290.847 322.35 290.477 322.55 290.107 322.75C289.777 322.95 289.297 323.15 288.847 323.36C288.387 323.57 287.987 323.78 287.417 323.99C285.417 324.84 282.797 325.73 279.547 326.63C273.077 328.42 263.887 330.26 251.777 331.73C245.717 332.46 238.987 333.1 231.687 333.61C230.797 333.68 229.837 333.73 228.917 333.79C227.987 333.85 227.057 333.91 226.107 333.96C225.147 334.01 224.197 334.06 223.227 334.11L221.787 334.19C221.297 334.21 220.807 334.23 220.317 334.25C219.337 334.29 218.347 334.33 217.357 334.38C216.367 334.42 215.347 334.44 214.347 334.48L212.837 334.53L212.077 334.56L211.307 334.58C210.277 334.6 209.247 334.63 208.217 334.65C207.187 334.68 206.137 334.69 205.087 334.7C204.037 334.71 202.987 334.73 201.937 334.74C200.877 334.74 199.807 334.74 198.737 334.75H197.127C196.587 334.75 196.057 334.75 195.517 334.75C194.437 334.75 193.367 334.75 192.277 334.74C191.197 334.74 190.127 334.71 189.037 334.7C186.867 334.68 184.717 334.62 182.547 334.57C178.237 334.44 173.897 334.3 169.637 334.06C167.477 333.96 165.397 333.81 163.257 333.69C162.207 333.62 161.167 333.54 160.117 333.47L158.537 333.36L156.997 333.23C148.697 332.57 140.797 331.67 133.607 330.57C132.717 330.43 131.837 330.29 130.947 330.15C130.067 330.01 129.247 329.85 128.387 329.71C127.967 329.64 127.527 329.56 127.107 329.49L125.897 329.26L124.667 329.03C124.257 328.95 123.837 328.88 123.467 328.79C120.287 328.15 117.427 327.46 114.737 326.74L112.807 326.19C112.167 326.01 111.617 325.81 111.007 325.63C110.707 325.54 110.397 325.44 110.107 325.35L109.297 325.06L108.477 324.77C108.197 324.67 107.917 324.58 107.687 324.48L106.207 323.88C105.727 323.68 105.327 323.47 104.877 323.27C104.657 323.17 104.417 323.07 104.217 322.97L103.647 322.66L103.067 322.35C102.867 322.25 102.667 322.14 102.527 322.04L101.537 321.41C101.217 321.2 100.997 320.98 100.707 320.77L100.287 320.45L99.9766 320.13C99.7866 319.91 99.5066 319.7 99.3566 319.48C98.6466 318.61 98.3666 317.72 98.2866 316.84C98.3766 315.95 98.6566 315.07 99.3566 314.2C99.5066 313.98 99.7766 313.77 99.9766 313.55L100.287 313.23L100.707 312.91C100.997 312.7 101.217 312.48 101.537 312.27L102.527 311.64C102.667 311.53 102.867 311.43 103.067 311.33L103.647 311.02L104.217 310.71C104.417 310.61 104.657 310.51 104.877 310.41C105.337 310.21 105.727 310 106.207 309.8L107.687 309.2C107.917 309.1 108.187 309 108.477 308.91L109.297 308.62L110.107 308.33C110.387 308.23 110.707 308.14 111.007 308.05C111.617 307.86 112.167 307.67 112.807 307.49L114.737 306.94C117.427 306.22 120.277 305.53 123.467 304.89C123.837 304.81 124.257 304.73 124.667 304.65L125.897 304.42L127.107 304.19C127.527 304.11 127.967 304.04 128.387 303.97C129.247 303.82 130.067 303.67 130.947 303.53C131.837 303.39 132.727 303.25 133.607 303.11C140.797 302.02 148.707 301.12 156.997 300.45L158.537 300.32L160.117 300.21C161.167 300.14 162.207 300.06 163.257 299.99C165.397 299.87 167.477 299.72 169.637 299.62C173.887 299.38 178.237 299.24 182.547 299.11C184.717 299.07 186.867 299 189.037 298.98C190.117 298.97 191.197 298.94 192.277 298.94C193.357 298.94 194.437 298.94 195.517 298.93C196.057 298.93 196.587 298.93 197.127 298.93H198.737C199.807 298.94 200.867 298.95 201.937 298.95C202.997 298.96 204.047 298.98 205.087 298.99C206.137 299.01 207.187 299.01 208.217 299.04C209.247 299.06 210.277 299.09 211.307 299.11L212.077 299.13L212.837 299.16L214.347 299.21C215.357 299.25 216.367 299.27 217.357 299.31C218.347 299.35 219.337 299.39 220.317 299.44C220.807 299.46 221.307 299.48 221.787 299.5L223.227 299.58C224.187 299.63 225.147 299.68 226.107 299.73C227.057 299.78 227.977 299.85 228.917 299.9C229.847 299.96 230.797 300.01 231.687 300.08C238.987 300.59 245.727 301.23 251.777 301.96C263.887 303.44 273.077 305.27 279.547 307.06C282.787 307.96 285.417 308.85 287.417 309.7C287.987 309.91 288.387 310.12 288.847 310.33C289.297 310.54 289.767 310.74 290.107 310.94C290.487 311.14 290.857 311.34 291.207 311.53C291.507 311.72 291.807 311.92 292.087 312.1C294.367 313.58 295.107 314.79 295.387 315.62C295.437 315.72 295.477 315.82 295.517 315.91C295.567 316 295.547 316.09 295.557 316.17C295.577 316.33 295.597 316.46 295.607 316.57C295.647 316.78 295.667 316.9 295.667 316.9H292.867V316.76Z",
    fill: "url(#paint36_linear_11846_111534)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M282.414 316.76C282.414 316.76 282.394 316.66 282.354 316.48C282.344 316.39 282.324 316.27 282.314 316.13C282.294 316.06 282.314 315.99 282.284 315.91C282.244 315.83 282.204 315.75 282.164 315.66C281.924 314.94 281.284 313.89 279.314 312.61C279.064 312.45 278.814 312.29 278.554 312.12C278.234 311.96 277.914 311.79 277.594 311.61C277.314 311.43 276.894 311.26 276.504 311.08C276.104 310.9 275.774 310.72 275.274 310.54C273.554 309.8 271.274 309.03 268.464 308.26C262.864 306.71 254.884 305.11 244.404 303.84C239.154 303.21 233.324 302.65 227.024 302.22C226.254 302.16 225.424 302.12 224.624 302.07C223.814 302.02 223.014 301.97 222.194 301.92C221.364 301.88 220.534 301.84 219.704 301.79L218.454 301.72C218.034 301.7 217.604 301.69 217.184 301.67C216.334 301.63 215.484 301.6 214.624 301.56C213.764 301.52 212.884 301.5 212.014 301.47L210.704 301.43L210.044 301.41H209.374C208.484 301.38 207.594 301.36 206.704 301.33C205.814 301.3 204.904 301.3 203.994 301.28C203.084 301.27 202.174 301.25 201.254 301.24C200.334 301.24 199.404 301.24 198.474 301.23H197.084C196.614 301.23 196.154 301.23 195.684 301.23C194.754 301.23 193.814 301.23 192.874 301.24C191.934 301.24 191.004 301.27 190.064 301.28C188.174 301.29 186.324 301.35 184.444 301.39C180.714 301.5 176.964 301.63 173.284 301.83C171.414 301.91 169.624 302.05 167.764 302.15C166.864 302.21 165.954 302.28 165.054 302.34L163.684 302.44L162.354 302.55C155.184 303.12 148.334 303.9 142.104 304.85C141.344 304.97 140.574 305.09 139.794 305.21C139.034 305.33 138.324 305.47 137.574 305.59C137.204 305.65 136.824 305.72 136.464 305.78L135.414 305.98L134.354 306.18C133.994 306.25 133.634 306.31 133.314 306.39C130.554 306.94 128.084 307.55 125.754 308.17C125.204 308.33 124.644 308.49 124.074 308.64C123.524 308.8 123.054 308.97 122.514 309.13C122.254 309.21 121.984 309.29 121.734 309.37L121.034 309.62L120.324 309.87C120.074 309.95 119.834 310.04 119.644 310.12C119.224 310.29 118.804 310.46 118.364 310.64C117.944 310.81 117.614 310.99 117.214 311.17C117.024 311.26 116.814 311.34 116.634 311.43L116.144 311.7L115.644 311.97C115.464 312.06 115.294 312.15 115.174 312.24C114.904 312.42 114.614 312.6 114.324 312.79C114.044 312.97 113.864 313.16 113.614 313.34L113.254 313.62L112.994 313.9C112.834 314.09 112.584 314.27 112.454 314.46C111.844 315.21 111.614 315.98 111.524 316.75C111.614 317.52 111.844 318.29 112.454 319.04C112.584 319.23 112.824 319.41 112.994 319.6L113.254 319.88L113.614 320.16C113.864 320.34 114.044 320.53 114.324 320.71C114.624 320.89 114.904 321.07 115.174 321.26C115.294 321.35 115.464 321.44 115.644 321.53L116.144 321.8L116.634 322.07C116.814 322.16 117.024 322.25 117.214 322.33C117.614 322.5 117.944 322.68 118.364 322.86C118.804 323.03 119.234 323.2 119.644 323.38C119.834 323.47 120.084 323.55 120.324 323.63L121.034 323.88L121.734 324.13C121.984 324.21 122.254 324.29 122.514 324.37C123.044 324.53 123.514 324.7 124.074 324.86C124.644 325.02 125.204 325.18 125.754 325.33C128.094 325.95 130.554 326.55 133.314 327.11C133.634 327.18 133.994 327.25 134.354 327.32L135.414 327.52L136.464 327.72C136.824 327.79 137.214 327.85 137.574 327.91C138.324 328.04 139.034 328.17 139.794 328.29C140.574 328.41 141.344 328.53 142.104 328.65C148.344 329.6 155.184 330.38 162.354 330.95L163.684 331.06L165.054 331.16C165.964 331.23 166.864 331.29 167.764 331.35C169.614 331.45 171.414 331.59 173.284 331.67C176.954 331.88 180.714 332 184.444 332.11C186.324 332.15 188.184 332.21 190.064 332.22C191.004 332.23 191.934 332.25 192.874 332.26C193.814 332.26 194.754 332.26 195.684 332.27C196.154 332.27 196.614 332.27 197.084 332.27H198.474C199.404 332.26 200.324 332.25 201.254 332.25C202.164 332.24 203.084 332.22 203.994 332.21C204.904 332.2 205.814 332.19 206.704 332.16C207.594 332.14 208.494 332.12 209.374 332.1H210.044L210.704 332.06L212.014 332.02C212.884 331.99 213.764 331.97 214.624 331.93C215.484 331.89 216.334 331.86 217.184 331.82C217.604 331.8 218.034 331.79 218.454 331.77L219.704 331.7C220.534 331.66 221.364 331.62 222.194 331.57C223.014 331.52 223.814 331.47 224.624 331.42C225.424 331.37 226.254 331.33 227.024 331.27C233.334 330.83 239.164 330.28 244.404 329.65C254.894 328.37 262.864 326.78 268.464 325.23C271.274 324.45 273.554 323.68 275.274 322.95C275.774 322.77 276.104 322.58 276.504 322.41C276.894 322.23 277.304 322.06 277.594 321.88C277.914 321.71 278.234 321.54 278.554 321.37C278.814 321.2 279.064 321.04 279.314 320.88C281.294 319.6 281.924 318.55 282.164 317.83C282.204 317.74 282.244 317.66 282.284 317.58C282.324 317.5 282.304 317.43 282.314 317.36C282.334 317.22 282.344 317.11 282.354 317.01C282.394 316.82 282.414 316.73 282.414 316.73H289.164C289.164 316.73 289.144 316.83 289.104 317.03C289.094 317.13 289.074 317.26 289.054 317.4C289.034 317.47 289.054 317.55 289.014 317.64C288.974 317.73 288.934 317.82 288.884 317.91C288.624 318.68 287.934 319.82 285.804 321.2C285.534 321.37 285.264 321.55 284.984 321.73C284.644 321.91 284.304 322.09 283.954 322.28C283.644 322.47 283.194 322.66 282.784 322.85C282.354 323.04 281.984 323.24 281.454 323.44C279.594 324.24 277.134 325.07 274.104 325.91C268.064 327.58 259.464 329.3 248.154 330.68C242.494 331.36 236.204 331.96 229.394 332.43C228.564 332.5 227.674 332.54 226.804 332.6C225.934 332.65 225.064 332.71 224.184 332.76C223.294 332.81 222.394 332.85 221.494 332.9L220.144 332.97C219.694 332.99 219.224 333.01 218.774 333.03C217.854 333.07 216.934 333.11 216.014 333.15C215.094 333.19 214.144 333.21 213.204 333.24L211.794 333.29L211.084 333.31L210.364 333.33C209.404 333.35 208.444 333.37 207.484 333.4C206.524 333.43 205.544 333.44 204.564 333.45C203.584 333.46 202.604 333.48 201.614 333.49C200.624 333.49 199.624 333.49 198.624 333.5H197.124C196.624 333.5 196.124 333.5 195.614 333.5C194.604 333.5 193.604 333.5 192.584 333.49C191.574 333.49 190.574 333.46 189.564 333.45C187.534 333.44 185.534 333.37 183.504 333.33C179.484 333.21 175.424 333.08 171.454 332.85C169.434 332.76 167.494 332.62 165.494 332.5C164.514 332.43 163.544 332.36 162.564 332.29L161.094 332.19L159.654 332.07C151.914 331.45 144.524 330.61 137.804 329.59L135.314 329.2C134.494 329.07 133.724 328.92 132.924 328.79C132.524 328.72 132.114 328.65 131.724 328.58L130.594 328.36L129.444 328.14C129.054 328.07 128.664 328 128.324 327.92C125.344 327.32 122.684 326.67 120.174 326L118.364 325.49C117.764 325.32 117.254 325.14 116.684 324.96C116.404 324.87 116.114 324.79 115.844 324.7L115.094 324.43L114.324 324.16C114.064 324.07 113.804 323.98 113.594 323.89C113.144 323.7 112.684 323.52 112.204 323.33C111.754 323.14 111.394 322.95 110.964 322.76C110.764 322.67 110.534 322.57 110.344 322.48L109.814 322.19L109.274 321.9C109.084 321.8 108.894 321.71 108.764 321.61C108.464 321.41 108.164 321.22 107.844 321.02C107.544 320.82 107.344 320.62 107.074 320.42L106.684 320.12L106.404 319.82C106.224 319.62 105.964 319.42 105.824 319.21C105.164 318.4 104.904 317.57 104.814 316.74C104.904 315.91 105.164 315.08 105.824 314.27C105.964 314.07 106.224 313.87 106.404 313.66L106.684 313.36L107.074 313.06C107.344 312.86 107.544 312.66 107.844 312.46C108.164 312.26 108.474 312.07 108.764 311.87C108.894 311.77 109.084 311.67 109.274 311.58L109.814 311.29L110.344 311C110.534 310.9 110.764 310.81 110.964 310.72C111.394 310.53 111.754 310.34 112.204 310.15C112.674 309.97 113.134 309.78 113.594 309.59C113.804 309.5 114.064 309.41 114.324 309.32L115.094 309.05L115.844 308.78C116.114 308.69 116.404 308.6 116.684 308.52C117.254 308.35 117.764 308.16 118.364 307.99L120.174 307.48C122.694 306.81 125.354 306.16 128.324 305.56C128.674 305.48 129.064 305.41 129.444 305.34L130.594 305.12L131.724 304.9C132.114 304.83 132.524 304.76 132.924 304.69C133.734 304.55 134.494 304.41 135.314 304.28L137.804 303.89C144.524 302.87 151.914 302.03 159.654 301.41L161.094 301.29L162.564 301.19C163.544 301.12 164.514 301.05 165.494 300.98C167.494 300.87 169.434 300.72 171.454 300.63C175.424 300.41 179.484 300.27 183.504 300.15C185.534 300.11 187.534 300.05 189.564 300.03C190.574 300.02 191.574 300 192.584 299.99C193.594 299.99 194.604 299.99 195.614 299.98C196.114 299.98 196.624 299.98 197.124 299.98H198.624C199.624 299.99 200.624 300 201.614 300C202.604 300.01 203.584 300.03 204.564 300.04C205.544 300.05 206.524 300.06 207.484 300.09C208.444 300.11 209.414 300.13 210.364 300.16L211.084 300.18L211.794 300.2L213.204 300.25C214.144 300.28 215.094 300.3 216.014 300.34C216.934 300.38 217.854 300.42 218.774 300.46C219.234 300.48 219.694 300.5 220.144 300.52L221.494 300.59C222.394 300.64 223.284 300.68 224.184 300.73C225.064 300.78 225.934 300.84 226.804 300.89C227.664 300.95 228.554 300.99 229.394 301.06C236.204 301.53 242.494 302.13 248.154 302.81C259.464 304.19 268.064 305.91 274.104 307.58C277.134 308.42 279.594 309.25 281.454 310.04C281.984 310.23 282.354 310.44 282.784 310.63C283.204 310.82 283.644 311.01 283.954 311.2C284.304 311.39 284.654 311.57 284.984 311.75C285.264 311.93 285.544 312.11 285.804 312.28C287.934 313.66 288.624 314.79 288.884 315.57C288.924 315.67 288.974 315.76 289.014 315.84C289.064 315.93 289.034 316.01 289.054 316.08C289.074 316.23 289.094 316.35 289.104 316.45C289.144 316.65 289.164 316.75 289.164 316.75H282.414V316.76Z",
    fill: "url(#paint37_linear_11846_111534)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M243.064 337.378C243.064 337.378 243.304 337.358 243.754 337.328C243.974 337.308 244.254 337.288 244.584 337.268C244.904 337.238 245.264 337.208 245.674 337.178C247.294 337.038 249.694 336.868 252.414 336.598C257.924 336.098 265.014 335.318 271.524 334.398C278.074 333.488 283.994 332.438 288.114 331.598C289.124 331.388 290.054 331.188 290.874 331.018C291.714 330.848 292.334 330.688 292.914 330.558C294.034 330.298 294.664 330.148 294.664 330.148L298.674 330.698C298.674 330.698 298.014 330.848 296.854 331.118C296.264 331.248 295.604 331.418 294.734 331.598C293.874 331.778 292.914 331.978 291.864 332.198C287.574 333.068 281.404 334.158 274.594 335.108C267.814 336.068 260.434 336.868 254.694 337.398C251.864 337.678 249.374 337.858 247.684 337.998C247.254 338.028 246.874 338.068 246.544 338.088C246.204 338.108 245.914 338.128 245.684 338.148C245.214 338.178 244.964 338.198 244.964 338.198L243.074 337.348L243.064 337.378Z",
    fill: "url(#paint38_linear_11846_111534)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M165.497 338.272C165.497 338.272 165.747 338.282 166.207 338.312C166.667 338.332 167.367 338.362 168.237 338.402C169.117 338.442 170.177 338.482 171.397 338.532C171.707 338.542 172.017 338.562 172.337 338.572C172.667 338.582 173.007 338.592 173.347 338.602C174.037 338.622 174.767 338.652 175.527 338.672C181.597 338.872 189.817 339.032 198.077 339.012C206.337 339.002 214.547 338.832 220.587 338.602C220.967 338.592 221.337 338.582 221.697 338.562C222.057 338.542 222.407 338.532 222.747 338.522C223.427 338.492 224.077 338.462 224.687 338.442C225.907 338.392 226.977 338.352 227.847 338.312C229.577 338.222 230.567 338.172 230.567 338.172L231.947 339.052C231.947 339.052 230.917 339.102 229.117 339.202C228.217 339.242 227.097 339.292 225.827 339.342C225.187 339.372 224.517 339.402 223.807 339.432C223.447 339.452 223.087 339.462 222.707 339.482C222.327 339.492 221.937 339.512 221.547 339.522C215.257 339.762 206.707 339.942 198.117 339.952C189.527 339.972 180.967 339.802 174.647 339.592C173.857 339.562 173.097 339.542 172.377 339.522C172.017 339.512 171.667 339.502 171.327 339.492C170.987 339.482 170.657 339.462 170.347 339.452C169.077 339.402 167.967 339.352 167.057 339.312C166.147 339.272 165.427 339.242 164.937 339.222C164.457 339.192 164.197 339.182 164.197 339.182L165.487 338.302L165.497 338.272Z",
    fill: "url(#paint39_linear_11846_111534)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M100.664 330.48C100.664 330.48 101.294 330.63 102.414 330.89C102.984 331.02 103.724 331.16 104.534 331.34C105.364 331.51 106.244 331.71 107.344 331.91C111.504 332.74 117.544 333.77 124.194 334.66C130.804 335.55 137.954 336.31 143.514 336.8C144.904 336.92 146.204 337.02 147.344 337.12C148.484 337.21 149.474 337.3 150.324 337.36C151.994 337.48 152.954 337.55 152.954 337.55L151.144 338.4C151.144 338.4 150.144 338.33 148.404 338.2C147.524 338.14 146.494 338.05 145.304 337.96C144.124 337.86 142.764 337.76 141.324 337.63C135.534 337.12 128.094 336.34 121.204 335.41C114.294 334.49 108.004 333.41 103.674 332.55C102.534 332.34 101.624 332.13 100.754 331.95C99.9041 331.77 99.1441 331.62 98.5441 331.48C97.3841 331.21 96.7241 331.06 96.7241 331.06L100.674 330.5L100.664 330.48Z",
    fill: "url(#paint40_linear_11846_111534)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M180.167 294.699C180.167 294.699 179.657 294.709 178.767 294.729C177.877 294.749 176.617 294.799 175.097 294.849C174.337 294.869 173.517 294.899 172.647 294.929C171.777 294.959 170.877 294.999 169.937 295.039C168.997 295.079 168.027 295.119 167.037 295.159C166.047 295.199 165.067 295.259 164.077 295.309C163.087 295.359 162.097 295.409 161.127 295.459C160.147 295.509 159.227 295.579 158.307 295.629C156.487 295.739 154.767 295.839 153.347 295.949C151.917 296.049 150.717 296.139 149.877 296.199C149.457 296.229 149.137 296.259 148.917 296.269C148.697 296.289 148.577 296.299 148.577 296.299L146.587 295.459C146.587 295.459 146.707 295.449 146.937 295.429C147.167 295.409 147.497 295.379 147.937 295.349C148.807 295.289 150.057 295.199 151.547 295.089C153.027 294.979 154.817 294.869 156.717 294.759C157.667 294.699 158.637 294.639 159.657 294.579C160.667 294.529 161.697 294.469 162.727 294.419C163.757 294.369 164.777 294.309 165.807 294.269C166.837 294.229 167.847 294.179 168.827 294.139C169.807 294.099 170.747 294.059 171.647 294.019C172.557 293.989 173.407 293.959 174.197 293.939C175.777 293.889 177.087 293.839 178.017 293.819C178.947 293.799 179.477 293.789 179.477 293.789L180.157 294.689L180.167 294.699Z",
    fill: "url(#paint41_linear_11846_111534)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M319.336 316.761C319.336 316.761 319.286 316.401 319.206 315.871C319.216 315.601 319.016 315.291 318.896 314.961C318.826 314.791 318.766 314.621 318.676 314.451C318.556 314.281 318.426 314.101 318.306 313.921C318.186 313.741 318.066 313.571 317.946 313.391C317.776 313.221 317.616 313.051 317.446 312.881C317.116 312.551 316.866 312.241 316.486 311.991C316.156 311.731 315.886 311.511 315.696 311.361C315.596 311.281 315.526 311.221 315.476 311.181C315.416 311.141 315.376 311.121 315.376 311.121L320.236 310.891C320.236 310.891 320.266 310.911 320.336 310.951C320.386 310.991 320.466 311.051 320.566 311.131C320.766 311.291 321.056 311.511 321.396 311.781C321.786 312.051 322.046 312.371 322.396 312.711C322.566 312.881 322.736 313.061 322.906 313.241C323.036 313.421 323.156 313.601 323.286 313.791C323.416 313.971 323.546 314.161 323.676 314.341C323.776 314.521 323.826 314.701 323.906 314.871C324.036 315.221 324.236 315.541 324.226 315.821C324.306 316.381 324.356 316.751 324.356 316.751H319.336V316.761Z",
    fill: "url(#paint42_linear_11846_111534)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M228.444 295.24C228.444 295.24 228.324 295.24 228.094 295.22C227.864 295.21 227.524 295.19 227.084 295.17C226.204 295.13 224.954 295.08 223.454 295.02C221.964 294.95 220.184 294.9 218.284 294.84C217.334 294.81 216.354 294.77 215.354 294.75C214.344 294.73 213.324 294.7 212.304 294.68C211.284 294.66 210.264 294.63 209.254 294.61C208.244 294.6 207.244 294.58 206.284 294.57C205.324 294.56 204.394 294.54 203.504 294.53C202.624 294.53 201.784 294.53 201.004 294.52C199.454 294.52 198.164 294.51 197.264 294.5C196.814 294.5 196.454 294.5 196.214 294.5C195.974 294.5 195.844 294.5 195.844 294.5L195.794 293.59C195.794 293.59 195.924 293.59 196.184 293.59C196.434 293.59 196.804 293.59 197.274 293.59C198.214 293.59 199.554 293.6 201.164 293.61C201.964 293.61 202.844 293.61 203.764 293.62C204.684 293.63 205.654 293.65 206.654 293.66C207.654 293.67 208.694 293.69 209.744 293.7C210.794 293.72 211.854 293.75 212.914 293.77C213.974 293.79 215.044 293.82 216.084 293.84C217.124 293.87 218.144 293.91 219.134 293.94C221.114 294 222.964 294.06 224.514 294.13C226.074 294.2 227.384 294.25 228.294 294.29C228.754 294.31 229.104 294.33 229.344 294.34C229.584 294.35 229.714 294.36 229.714 294.36L228.424 295.24H228.444Z",
    fill: "url(#paint43_linear_11846_111534)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6872 317.16C74.6872 317.16 74.7172 317.35 74.7572 317.68C74.7772 317.76 74.7573 317.85 74.8073 317.95C74.8473 318.05 74.8973 318.16 74.9473 318.27C75.0373 318.5 75.1472 318.75 75.2572 319.04C75.9072 320.16 77.2872 321.64 79.6372 323.07C81.9372 324.51 85.1772 325.89 88.0172 326.89C89.3672 327.4 90.7272 327.79 91.6072 328.08C92.0572 328.22 92.3972 328.33 92.6772 328.41C92.9372 328.48 93.0772 328.52 93.0772 328.52L88.8172 329C88.8172 329 88.6672 328.96 88.3972 328.88C88.1172 328.8 87.7472 328.69 87.2872 328.54C86.3672 328.24 84.9572 327.83 83.5472 327.3C80.5972 326.26 77.2172 324.82 74.8272 323.33C72.3772 321.84 70.9372 320.29 70.2672 319.13C70.1472 318.84 70.0372 318.57 69.9372 318.33C69.8872 318.21 69.8372 318.1 69.7972 318C69.7572 317.9 69.7672 317.8 69.7472 317.72C69.6972 317.38 69.6772 317.18 69.6772 317.18L74.6973 317.16H74.6872Z",
    fill: "url(#paint44_linear_11846_111534)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M129.436 298.19C129.436 298.19 129.066 298.23 128.406 298.31C127.756 298.39 126.796 298.52 125.576 298.68C124.966 298.76 124.276 298.84 123.556 298.94C122.846 299.04 122.076 299.15 121.256 299.27C120.446 299.39 119.536 299.51 118.656 299.65C117.766 299.79 116.836 299.94 115.866 300.09C112.046 300.71 107.706 301.47 103.596 302.37C99.456 303.26 95.416 304.28 91.886 305.34C88.326 306.41 85.396 307.54 83.056 308.62C82.756 308.76 82.466 308.89 82.176 309.02C81.886 309.15 81.666 309.29 81.416 309.42C80.936 309.69 80.406 309.94 79.986 310.2C79.206 310.72 78.366 311.2 77.856 311.66C77.576 311.89 77.266 312.1 77.046 312.31C76.846 312.52 76.646 312.72 76.466 312.91C76.296 313.1 76.076 313.27 75.976 313.43C75.866 313.59 75.756 313.74 75.666 313.88C75.486 314.15 75.306 314.36 75.236 314.51C75.176 314.66 75.146 314.73 75.146 314.73L70.146 314.65C70.146 314.65 70.176 314.57 70.236 314.42C70.316 314.27 70.496 314.05 70.686 313.77C70.786 313.63 70.896 313.47 71.006 313.3C71.116 313.13 71.336 312.95 71.516 312.75C71.706 312.56 71.906 312.35 72.116 312.13C72.356 311.91 72.676 311.69 72.966 311.45C73.496 310.97 74.366 310.47 75.186 309.93C75.626 309.66 76.176 309.39 76.676 309.12C76.946 308.98 77.176 308.84 77.476 308.7C77.776 308.56 78.086 308.42 78.386 308.28C80.826 307.15 83.876 305.97 87.586 304.86C91.256 303.75 95.456 302.69 99.766 301.76C104.036 300.82 108.556 300.03 112.536 299.38C113.546 299.22 114.516 299.07 115.436 298.92C116.346 298.77 117.296 298.65 118.136 298.53C118.986 298.41 119.786 298.29 120.526 298.19C121.276 298.09 121.996 298 122.626 297.92C123.896 297.76 124.896 297.63 125.576 297.54C126.266 297.45 126.646 297.41 126.646 297.41L129.426 298.17L129.436 298.19Z",
    fill: "url(#paint45_linear_11846_111534)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M313.065 309.722C313.065 309.722 312.925 309.652 312.675 309.512C312.545 309.442 312.385 309.362 312.205 309.262C312.115 309.212 312.015 309.162 311.905 309.102C311.785 309.042 311.655 308.982 311.515 308.922C310.955 308.672 310.325 308.362 309.515 308.012C309.085 307.842 308.625 307.652 308.145 307.462C307.905 307.362 307.655 307.262 307.405 307.162C307.155 307.062 306.845 306.962 306.555 306.852C305.975 306.642 305.365 306.432 304.735 306.202C304.075 305.982 303.335 305.762 302.605 305.522C302.235 305.402 301.885 305.282 301.485 305.172C301.075 305.052 300.665 304.942 300.245 304.822C299.395 304.592 298.605 304.342 297.635 304.102C294.025 303.132 289.645 302.172 284.865 301.272C280.095 300.372 274.905 299.552 269.755 298.852C264.595 298.152 259.435 297.592 254.955 297.142C253.815 297.032 252.715 296.932 251.675 296.842C251.155 296.792 250.645 296.742 250.155 296.702C249.655 296.662 249.165 296.622 248.685 296.582C247.735 296.502 246.845 296.432 246.025 296.362C245.205 296.292 244.455 296.232 243.745 296.182C240.965 295.982 239.365 295.872 239.365 295.872L241.105 295.012C241.105 295.012 242.765 295.132 245.665 295.342C246.395 295.392 247.185 295.452 248.035 295.532C248.895 295.602 249.815 295.682 250.805 295.762C251.295 295.802 251.815 295.842 252.335 295.892C252.845 295.942 253.375 295.992 253.915 296.042C254.995 296.142 256.135 296.252 257.325 296.362C261.995 296.832 267.365 297.412 272.735 298.142C278.095 298.872 283.495 299.722 288.465 300.652C293.435 301.582 297.995 302.592 301.755 303.592C302.755 303.832 303.585 304.092 304.475 304.342C304.905 304.462 305.345 304.582 305.765 304.712C306.185 304.832 306.545 304.962 306.935 305.082C307.695 305.322 308.455 305.562 309.145 305.792C309.805 306.022 310.435 306.252 311.045 306.472C311.345 306.582 311.665 306.682 311.925 306.792C312.185 306.902 312.445 307.002 312.695 307.102C313.195 307.302 313.675 307.492 314.125 307.672C314.975 308.032 315.625 308.362 316.215 308.622C316.355 308.692 316.495 308.752 316.625 308.812C316.735 308.872 316.845 308.932 316.935 308.982C317.125 309.082 317.295 309.172 317.425 309.252C317.695 309.392 317.835 309.472 317.835 309.472L313.075 309.762L313.065 309.722Z",
    fill: "url(#paint46_linear_11846_111534)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M294.158 322.862C294.158 322.862 294.418 322.722 294.808 322.512C295.248 322.302 295.608 322.022 296.078 321.732C296.568 321.452 296.878 321.162 297.158 320.942C297.438 320.722 297.618 320.582 297.618 320.582L313.448 321.182C313.448 321.182 313.238 321.352 312.918 321.602C312.598 321.852 312.228 322.182 311.658 322.512C311.118 322.842 310.688 323.172 310.188 323.412C309.738 323.652 309.438 323.812 309.438 323.812L294.158 322.852V322.862Z",
    fill: "url(#paint47_linear_11846_111534)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M285.267 326.34C285.267 326.34 285.667 326.21 286.277 326.02C286.587 325.92 286.937 325.81 287.327 325.69C287.687 325.57 288.037 325.43 288.407 325.3C288.777 325.17 289.147 325.04 289.497 324.91C289.847 324.79 290.107 324.67 290.367 324.57C290.867 324.37 291.207 324.23 291.207 324.23L306.017 325.41C306.017 325.41 305.627 325.57 305.047 325.8C304.747 325.92 304.447 326.06 304.037 326.2C303.637 326.34 303.207 326.49 302.777 326.65C302.347 326.8 301.937 326.96 301.517 327.1C301.077 327.24 300.667 327.37 300.307 327.48C299.607 327.7 299.137 327.85 299.137 327.85L285.267 326.34Z",
    fill: "url(#paint48_linear_11846_111534)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M274.544 329.02C274.544 329.02 274.834 328.96 275.274 328.87C275.704 328.78 276.324 328.66 276.854 328.53C277.954 328.27 279.064 328.02 279.064 328.02L291.964 329.79C291.964 329.79 290.684 330.09 289.414 330.38C288.794 330.53 288.094 330.67 287.594 330.78C287.084 330.89 286.744 330.96 286.744 330.96L274.544 329.03V329.02Z",
    fill: "url(#paint49_linear_11846_111534)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M209.258 335.321C209.258 335.321 210.068 335.301 211.268 335.271C212.488 335.251 214.078 335.191 215.668 335.141C216.468 335.111 217.268 335.091 218.008 335.061C218.748 335.031 219.438 335.001 220.028 334.971C221.208 334.921 221.998 334.891 221.998 334.891L225.918 337.741C225.918 337.741 224.998 337.781 223.628 337.841C222.938 337.871 222.138 337.901 221.288 337.941C220.428 337.971 219.498 338.001 218.578 338.031C216.728 338.091 214.888 338.161 213.478 338.181C212.078 338.211 211.148 338.231 211.148 338.231L209.248 335.311L209.258 335.321Z",
    fill: "url(#paint50_linear_11846_111534)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M188.046 335.391C188.046 335.391 188.856 335.401 190.076 335.421C190.686 335.421 191.396 335.451 192.156 335.451C192.926 335.451 193.736 335.451 194.556 335.451C195.376 335.451 196.186 335.451 196.956 335.461C197.726 335.461 198.436 335.461 199.046 335.451C200.276 335.451 201.086 335.451 201.086 335.451L201.716 338.391C201.716 338.391 200.776 338.391 199.356 338.401C198.646 338.401 197.826 338.401 196.946 338.411C196.066 338.411 195.116 338.411 194.176 338.401C193.236 338.401 192.296 338.401 191.406 338.391C190.526 338.391 189.706 338.371 188.996 338.361C187.586 338.341 186.646 338.331 186.646 338.331L188.026 335.401L188.046 335.391Z",
    fill: "url(#paint51_linear_11846_111534)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M167.316 334.672C167.316 334.672 168.096 334.712 169.266 334.772C169.846 334.802 170.526 334.842 171.256 334.882C171.996 334.912 172.786 334.942 173.576 334.982C174.366 335.012 175.156 335.052 175.896 335.082C176.636 335.112 177.346 335.132 177.936 335.152C179.136 335.192 179.936 335.212 179.936 335.212L177.276 338.112C177.276 338.112 176.356 338.082 174.966 338.032C174.276 338.012 173.456 337.992 172.596 337.952C171.736 337.912 170.826 337.872 169.906 337.842C168.986 337.802 168.076 337.762 167.216 337.732C166.366 337.692 165.576 337.642 164.906 337.612C163.556 337.542 162.646 337.492 162.646 337.492L167.306 334.672H167.316Z",
    fill: "url(#paint52_linear_11846_111534)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M150.464 333.43C150.464 333.43 150.864 333.47 151.454 333.52C151.754 333.55 152.094 333.58 152.464 333.62C152.844 333.65 153.254 333.68 153.654 333.72C155.274 333.85 156.894 333.99 156.894 333.99L150.584 336.7C150.584 336.7 148.704 336.55 146.834 336.39C146.364 336.35 145.894 336.31 145.454 336.28C145.024 336.24 144.624 336.2 144.284 336.17C143.594 336.11 143.134 336.06 143.134 336.06L150.464 333.44V333.43Z",
    fill: "url(#paint53_linear_11846_111534)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M256.724 331.97C256.724 331.97 257.384 331.88 258.384 331.76C259.344 331.62 260.624 331.44 261.904 331.26C263.174 331.07 264.364 330.87 265.304 330.73C265.764 330.66 266.164 330.6 266.404 330.55C266.664 330.51 266.804 330.48 266.804 330.48L277.794 332.64C277.794 332.64 277.624 332.67 277.324 332.72C277.034 332.77 276.584 332.84 276.054 332.93C274.974 333.1 273.584 333.33 272.124 333.54C270.644 333.75 269.164 333.96 268.054 334.12C266.904 334.27 266.134 334.37 266.134 334.37L256.724 331.98V331.97Z",
    fill: "url(#paint54_linear_11846_111534)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.008 334.411C231.008 334.411 231.318 334.391 231.858 334.361C232.408 334.331 233.148 334.271 234.068 334.211C234.978 334.141 236.038 334.071 237.178 333.991C238.298 333.901 239.488 333.801 240.678 333.701L241.568 333.631C241.858 333.601 242.148 333.581 242.428 333.551C242.998 333.501 243.568 333.441 244.108 333.391C244.658 333.341 245.188 333.291 245.688 333.241C246.188 333.191 246.638 333.141 247.068 333.101C248.768 332.921 249.908 332.801 249.908 332.801L258.248 335.321C258.248 335.321 256.938 335.461 254.958 335.661C254.458 335.711 253.938 335.771 253.358 335.821C252.778 335.871 252.168 335.931 251.538 335.991C250.908 336.051 250.258 336.111 249.588 336.171C249.258 336.201 248.918 336.231 248.588 336.261L247.558 336.341C246.178 336.451 244.798 336.571 243.508 336.671C242.198 336.771 240.958 336.851 239.898 336.931C238.838 337.001 237.978 337.081 237.338 337.111C236.708 337.151 236.348 337.171 236.348 337.171L230.998 334.391L231.008 334.411Z",
    fill: "url(#paint55_linear_11846_111534)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M132.635 331.34C132.635 331.34 133.275 331.43 134.235 331.57C134.725 331.64 135.255 331.72 135.885 331.8C136.505 331.88 137.175 331.97 137.835 332.05C138.505 332.13 139.145 332.23 139.785 332.3C140.425 332.37 141.025 332.44 141.545 332.5C142.565 332.62 143.255 332.7 143.255 332.7L134.785 335.21C134.785 335.21 133.995 335.12 132.805 334.98C132.215 334.91 131.515 334.83 130.775 334.74C130.035 334.65 129.285 334.55 128.515 334.45C127.745 334.35 126.985 334.25 126.265 334.16C125.535 334.07 124.915 333.97 124.355 333.89C123.245 333.73 122.505 333.63 122.505 333.63L132.635 331.34Z",
    fill: "url(#paint56_linear_11846_111534)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M117.554 328.629C117.554 328.629 117.674 328.659 117.914 328.709C118.144 328.759 118.484 328.829 118.884 328.909C119.704 329.069 120.704 329.309 121.864 329.519C122.424 329.629 122.984 329.729 123.514 329.839C123.774 329.889 124.024 329.939 124.264 329.989C124.514 330.029 124.764 330.079 124.984 330.109C125.874 330.259 126.464 330.369 126.464 330.369L115.364 332.509C115.364 332.509 114.684 332.389 113.664 332.209C113.404 332.169 113.134 332.119 112.834 332.069C112.554 332.019 112.264 331.959 111.964 331.899C111.354 331.779 110.704 331.659 110.054 331.539C108.714 331.299 107.554 331.029 106.604 330.839C106.144 330.739 105.754 330.659 105.484 330.609C105.214 330.549 105.064 330.519 105.064 330.519L117.544 328.649L117.554 328.629Z",
    fill: "url(#paint57_linear_11846_111534)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M105.894 325.418C105.894 325.418 105.984 325.448 106.144 325.508C106.314 325.568 106.514 325.648 106.834 325.748C107.444 325.938 108.244 326.198 109.054 326.448C109.934 326.698 110.814 326.948 111.464 327.128C111.774 327.228 112.104 327.298 112.304 327.348C112.514 327.398 112.634 327.428 112.634 327.428L99.374 329.108C99.374 329.108 99.234 329.078 98.994 329.008C98.764 328.948 98.394 328.858 98.024 328.748C97.264 328.528 96.244 328.248 95.234 327.958C94.294 327.658 93.364 327.368 92.654 327.138C92.284 327.028 92.044 326.928 91.854 326.868C91.664 326.798 91.564 326.768 91.564 326.768L105.884 325.398L105.894 325.418Z",
    fill: "url(#paint58_linear_11846_111534)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8963 322.371C98.8963 322.371 99.4663 322.681 100.036 322.981C100.176 323.061 100.306 323.131 100.456 323.201C100.616 323.271 100.756 323.341 100.876 323.391C101.126 323.501 101.286 323.581 101.286 323.581L86.2363 324.661C86.2363 324.661 86.0463 324.571 85.7663 324.441C85.6263 324.371 85.4563 324.301 85.2763 324.221C85.1063 324.141 84.9563 324.051 84.7863 323.961C84.1263 323.611 83.4663 323.251 83.4663 323.251L98.8963 322.371Z",
    fill: "url(#paint59_linear_11846_111534)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M103.585 308.939C103.585 308.939 103.255 309.069 102.745 309.279C102.195 309.479 101.675 309.759 101.055 310.029C100.415 310.299 99.9446 310.579 99.5446 310.789C99.1546 310.999 98.8846 311.139 98.8846 311.139L83.4546 310.259C83.4546 310.259 83.7546 310.099 84.2146 309.859C84.6746 309.619 85.2246 309.289 85.9646 308.979C86.6746 308.659 87.2946 308.339 87.9246 308.109C88.5046 307.879 88.8946 307.719 88.8946 307.719L103.585 308.949V308.939Z",
    fill: "url(#paint60_linear_11846_111534)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.337 305.631C114.337 305.631 113.867 305.751 113.167 305.931C112.807 306.021 112.397 306.131 111.957 306.241C111.507 306.351 111.107 306.481 110.657 306.601C109.777 306.851 108.877 307.091 108.307 307.291C107.697 307.481 107.297 307.611 107.297 307.611L93.1968 306.171C93.1968 306.171 93.6668 306.021 94.3668 305.801C95.0268 305.571 96.0668 305.291 97.0868 305.001C97.6068 304.861 98.0768 304.711 98.5968 304.581C99.1068 304.451 99.5868 304.331 99.9968 304.221C100.817 304.011 101.357 303.871 101.357 303.871L114.347 305.621L114.337 305.631Z",
    fill: "url(#paint61_linear_11846_111534)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M128.624 302.789C128.624 302.789 128.474 302.809 128.194 302.859C127.914 302.899 127.554 302.969 127.114 303.039C126.244 303.199 125.034 303.389 123.894 303.609C122.774 303.819 121.644 304.039 120.804 304.199C120.014 304.369 119.484 304.479 119.484 304.479L107.294 302.549C107.294 302.549 107.904 302.419 108.834 302.229C109.804 302.039 111.104 301.799 112.404 301.549C113.724 301.309 115.124 301.079 116.124 300.899C116.634 300.809 117.054 300.739 117.374 300.689C117.684 300.639 117.864 300.609 117.864 300.609L128.624 302.809V302.789Z",
    fill: "url(#paint62_linear_11846_111534)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M143.246 300.811C143.246 300.811 141.746 300.991 140.246 301.161C139.476 301.241 138.776 301.341 138.226 301.411C137.686 301.481 137.316 301.531 137.316 301.531L127.916 299.141C127.916 299.141 128.336 299.091 128.966 299.001C129.596 298.921 130.416 298.801 131.306 298.711C133.046 298.511 134.776 298.301 134.776 298.301L143.246 300.811Z",
    fill: "url(#paint63_linear_11846_111534)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4757 318.069C94.4757 318.069 94.5357 318.219 94.6257 318.439C94.6657 318.659 94.9357 318.949 95.1257 319.249C95.2357 319.399 95.2957 319.539 95.4357 319.679C95.5757 319.819 95.6957 319.939 95.8057 320.049C96.0157 320.269 96.1557 320.409 96.1557 320.409L80.2957 320.979C80.2957 320.979 80.1357 320.809 79.8857 320.559C79.7557 320.429 79.6157 320.289 79.4557 320.129C79.2957 319.969 79.2157 319.799 79.0857 319.629C78.8657 319.289 78.5657 318.949 78.5057 318.689C78.3957 318.429 78.3257 318.259 78.3257 318.259L94.4557 318.059L94.4757 318.069Z",
    fill: "url(#paint64_linear_11846_111534)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5166 312.792C96.5166 312.792 96.4366 312.852 96.3066 312.952C96.1866 313.052 96.0666 313.202 95.8966 313.372C95.7366 313.552 95.4866 313.752 95.3166 313.972C95.1666 314.192 94.9966 314.432 94.8366 314.662L94.7066 314.842C94.6866 314.902 94.6666 314.962 94.6366 315.022C94.5866 315.142 94.5466 315.252 94.4966 315.362C94.4066 315.582 94.2766 315.792 94.2866 315.972C94.2366 316.332 94.2066 316.572 94.2066 316.572L78.0366 316.542C78.0366 316.542 78.0766 316.262 78.1366 315.852C78.1366 315.642 78.2666 315.402 78.3666 315.142C78.4166 315.012 78.4766 314.882 78.5266 314.742C78.5566 314.672 78.5766 314.602 78.6066 314.542L78.7466 314.342C78.9366 314.072 79.1266 313.792 79.3066 313.542C79.5066 313.282 79.7866 313.052 79.9666 312.842C80.1666 312.642 80.3166 312.472 80.4566 312.352C80.6066 312.232 80.6966 312.172 80.6966 312.172L96.5066 312.792H96.5166Z",
    fill: "url(#paint65_linear_11846_111534)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M162.346 299.141C162.346 299.141 162.156 299.151 161.816 299.171C161.476 299.191 161.016 299.231 160.446 299.271C159.876 299.311 159.226 299.361 158.516 299.411C157.816 299.461 157.046 299.511 156.316 299.571C154.836 299.691 153.366 299.811 152.256 299.911C151.176 300.011 150.456 300.081 150.456 300.081L143.126 297.461C143.126 297.461 143.966 297.381 145.216 297.261C146.496 297.151 148.206 297.011 149.916 296.871C150.756 296.791 151.656 296.741 152.466 296.681C153.286 296.621 154.046 296.571 154.706 296.521C156.006 296.421 156.906 296.371 156.906 296.371L162.356 299.141H162.346Z",
    fill: "url(#paint66_linear_11846_111534)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M182.835 298.229C182.835 298.229 182.635 298.229 182.285 298.239C181.935 298.239 181.425 298.249 180.825 298.279C179.625 298.319 178.035 298.369 176.435 298.419C174.855 298.489 173.275 298.549 172.095 298.599C171.795 298.609 171.525 298.619 171.285 298.629C171.045 298.639 170.845 298.649 170.675 298.659C170.335 298.679 170.145 298.689 170.145 298.689L165.935 295.849C165.935 295.849 166.165 295.839 166.555 295.819C166.755 295.809 166.995 295.799 167.265 295.779C167.545 295.769 167.855 295.759 168.205 295.739C169.575 295.679 171.405 295.609 173.235 295.529C175.085 295.469 176.935 295.409 178.325 295.359C179.015 295.329 179.605 295.329 180.015 295.319C180.425 295.319 180.655 295.309 180.655 295.309L182.855 298.229H182.835Z",
    fill: "url(#paint67_linear_11846_111534)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M204.024 298.101C204.024 298.101 203.824 298.101 203.464 298.101C203.104 298.101 202.604 298.081 201.994 298.081C200.764 298.081 199.134 298.071 197.504 298.061C195.874 298.061 194.234 298.081 193.014 298.081C192.404 298.081 191.894 298.081 191.534 298.081C191.174 298.081 190.974 298.081 190.974 298.081L190.044 295.141C190.044 295.141 190.274 295.141 190.684 295.141C191.094 295.141 191.684 295.141 192.394 295.141C193.804 295.141 195.694 295.121 197.574 295.121C199.454 295.121 201.344 295.141 202.754 295.141C203.464 295.141 204.044 295.161 204.454 295.161C204.864 295.161 205.104 295.161 205.104 295.161L204.014 298.101H204.024Z",
    fill: "url(#paint68_linear_11846_111534)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M222.014 298.61C222.014 298.61 220.284 298.54 218.554 298.46C217.694 298.42 216.814 298.4 216.154 298.37C215.494 298.35 215.064 298.33 215.064 298.33L217.884 295.43C217.884 295.43 218.394 295.45 219.154 295.47C219.914 295.5 220.934 295.52 221.934 295.57C223.944 295.65 225.944 295.74 225.944 295.74L222.024 298.59L222.014 298.61Z",
    fill: "url(#paint69_linear_11846_111534)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M282.467 306.359C282.467 306.359 282.367 306.329 282.157 306.269C281.947 306.219 281.657 306.139 281.297 306.049C280.947 305.959 280.537 305.849 280.087 305.739C279.867 305.679 279.647 305.619 279.417 305.559C279.167 305.499 278.917 305.439 278.667 305.389C277.637 305.159 276.687 304.919 275.877 304.749C275.077 304.579 274.537 304.469 274.537 304.469L286.737 302.539C286.737 302.539 287.357 302.669 288.277 302.859C289.207 303.049 290.317 303.329 291.497 303.599C291.787 303.669 292.077 303.729 292.367 303.799C292.637 303.869 292.897 303.939 293.147 303.999C293.657 304.129 294.137 304.249 294.547 304.359C294.957 304.459 295.297 304.549 295.537 304.609C295.777 304.669 295.887 304.709 295.887 304.709L282.457 306.349L282.467 306.359Z",
    fill: "url(#paint70_linear_11846_111534)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M292.324 309.759C292.324 309.759 292.254 309.729 292.124 309.669C291.984 309.609 291.834 309.519 291.574 309.419C291.074 309.219 290.404 308.949 289.734 308.679C288.994 308.419 288.254 308.149 287.704 307.959C287.444 307.859 287.184 307.779 287.004 307.729C286.824 307.669 286.724 307.639 286.724 307.639L300.834 306.199C300.834 306.199 300.954 306.239 301.154 306.299C301.364 306.359 301.664 306.459 301.964 306.569C302.604 306.799 303.454 307.099 304.314 307.409C305.084 307.719 305.864 308.029 306.444 308.269C306.744 308.389 306.924 308.489 307.084 308.559C307.234 308.629 307.324 308.669 307.324 308.669L292.334 309.769L292.324 309.759Z",
    fill: "url(#paint71_linear_11846_111534)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M298.135 313.449C298.135 313.449 297.995 313.299 297.785 313.089C297.575 312.869 297.145 312.589 296.805 312.299C296.715 312.229 296.625 312.159 296.545 312.089C296.435 312.019 296.325 311.949 296.215 311.889C296.005 311.759 295.815 311.629 295.645 311.529C295.485 311.419 295.345 311.329 295.255 311.269C295.165 311.209 295.095 311.169 295.095 311.169L310.525 310.289C310.525 310.289 310.605 310.329 310.715 310.399C310.825 310.469 310.985 310.569 311.175 310.699C311.365 310.819 311.595 310.969 311.835 311.119C311.955 311.199 312.085 311.279 312.205 311.359C312.305 311.439 312.415 311.529 312.515 311.609C312.915 311.939 313.395 312.269 313.645 312.529C313.895 312.779 314.055 312.949 314.055 312.949L298.135 313.469V313.449Z",
    fill: "url(#paint72_linear_11846_111534)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M299.778 316.762C299.778 316.762 299.728 316.432 299.678 316.112C299.648 315.952 299.668 315.782 299.588 315.662C299.538 315.542 299.498 315.462 299.498 315.462L315.628 315.262C315.628 315.262 315.668 315.352 315.728 315.492C315.818 315.632 315.808 315.822 315.838 316.012C315.898 316.392 315.948 316.762 315.948 316.762H299.778Z",
    fill: "url(#paint73_linear_11846_111534)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M244.425 300.161C244.425 300.161 243.705 300.091 242.625 299.991C241.565 299.881 240.055 299.771 238.585 299.651C237.125 299.521 235.605 299.421 234.475 299.341C233.345 299.261 232.595 299.201 232.595 299.201L238.195 296.441C238.195 296.441 239.065 296.501 240.375 296.601C241.685 296.691 243.445 296.811 245.135 296.961C246.835 297.101 248.575 297.231 249.815 297.361C251.065 297.481 251.905 297.561 251.905 297.561L244.425 300.171V300.161Z",
    fill: "url(#paint74_linear_11846_111534)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M268.035 303.252C268.035 303.252 267.795 303.212 267.385 303.142C266.955 303.072 266.405 302.962 265.645 302.842C264.905 302.722 264.035 302.592 263.105 302.442C262.875 302.402 262.635 302.372 262.405 302.332C262.155 302.292 261.905 302.262 261.645 302.222C261.135 302.152 260.615 302.072 260.105 302.002C259.595 301.932 259.075 301.852 258.575 301.782C258.045 301.712 257.535 301.652 257.025 301.582C256.025 301.452 255.085 301.332 254.285 301.232C252.625 301.042 251.525 300.912 251.525 300.912L260.125 298.422C260.125 298.422 261.405 298.572 263.315 298.792C264.245 298.912 265.325 299.052 266.485 299.202C267.065 299.282 267.665 299.352 268.275 299.432C268.865 299.512 269.455 299.602 270.055 299.692C270.655 299.782 271.245 299.862 271.835 299.942C272.125 299.982 272.425 300.022 272.705 300.062C272.985 300.102 273.255 300.152 273.525 300.192C274.605 300.362 275.605 300.522 276.465 300.652C277.335 300.782 277.985 300.912 278.475 300.992C278.955 301.072 279.225 301.122 279.225 301.122L268.045 303.252H268.035Z",
    fill: "url(#paint75_linear_11846_111534)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M363.736 320.612C363.736 320.612 363.906 320.372 364.146 320.012C364.366 319.652 364.526 319.172 364.736 318.692C364.786 318.572 364.836 318.452 364.876 318.332C364.896 318.212 364.916 318.092 364.926 317.982C364.956 317.752 364.986 317.542 365.016 317.362C365.066 317.002 365.096 316.762 365.096 316.762H381.266C381.266 316.762 381.236 317.022 381.186 317.422C381.156 317.622 381.126 317.852 381.086 318.102C381.066 318.222 381.046 318.352 381.026 318.482C380.976 318.612 380.926 318.742 380.876 318.872C380.656 319.402 380.466 319.932 380.226 320.322C379.956 320.712 379.776 320.982 379.776 320.982L363.736 320.612Z",
    fill: "url(#paint76_linear_11846_111534)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M355.908 326.742C355.908 326.742 356.338 326.512 356.968 326.172C357.648 325.832 358.308 325.362 359.058 324.892C359.828 324.432 360.388 323.952 360.838 323.602C361.278 323.252 361.578 323.012 361.578 323.012L377.408 323.612C377.408 323.612 377.088 323.872 376.598 324.262C376.098 324.652 375.478 325.172 374.648 325.682C373.838 326.192 373.098 326.702 372.358 327.082C371.658 327.462 371.188 327.712 371.188 327.712L355.908 326.752V326.742Z",
    fill: "url(#paint77_linear_11846_111534)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M341.326 332.442C341.326 332.442 341.986 332.232 342.986 331.922C343.476 331.762 344.056 331.582 344.676 331.382C345.266 331.182 345.866 330.962 346.476 330.752C347.076 330.532 347.686 330.322 348.246 330.122C348.806 329.922 349.256 329.722 349.676 329.562C350.496 329.232 351.046 329.012 351.046 329.012L365.856 330.192C365.856 330.192 365.256 330.432 364.356 330.792C363.896 330.972 363.396 331.182 362.786 331.412C362.166 331.632 361.506 331.872 360.846 332.102C360.176 332.342 359.516 332.572 358.876 332.792C358.196 333.012 357.566 333.212 357.026 333.382C355.936 333.722 355.206 333.952 355.206 333.952L341.336 332.442H341.326Z",
    fill: "url(#paint78_linear_11846_111534)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M323.826 336.831C323.826 336.831 324.306 336.731 325.016 336.581C325.726 336.431 326.696 336.231 327.586 336.021C329.386 335.601 331.186 335.191 331.186 335.191L344.086 336.961L340.146 337.871C339.176 338.101 338.106 338.321 337.336 338.481C336.556 338.641 336.036 338.751 336.036 338.751L323.836 336.821L323.826 336.831Z",
    fill: "url(#paint79_linear_11846_111534)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M216.947 347.13C216.947 347.13 218.267 347.1 220.237 347.05C222.217 347.01 224.837 346.92 227.447 346.84C228.757 346.8 230.067 346.76 231.287 346.71C232.507 346.66 233.637 346.61 234.607 346.57C236.547 346.49 237.847 346.43 237.847 346.43L241.767 349.28C241.767 349.28 240.347 349.34 238.217 349.43C237.147 349.47 235.907 349.53 234.577 349.58C233.237 349.63 231.807 349.67 230.367 349.72C227.497 349.81 224.627 349.91 222.457 349.95C220.287 350 218.847 350.03 218.847 350.03L216.947 347.11V347.13Z",
    fill: "url(#paint80_linear_11846_111534)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M174.386 347.069C174.386 347.069 174.966 347.079 175.986 347.109C177.006 347.129 178.456 347.169 180.206 347.199C183.706 347.249 188.376 347.329 193.056 347.339C194.226 347.339 195.396 347.339 196.546 347.349C197.696 347.349 198.826 347.349 199.926 347.339C202.116 347.329 204.166 347.319 205.916 347.309C209.416 347.259 211.756 347.229 211.756 347.229L213.156 350.159C213.156 350.159 210.596 350.189 206.756 350.249C204.836 350.269 202.596 350.269 200.196 350.279C198.996 350.279 197.756 350.289 196.496 350.289C195.236 350.289 193.956 350.279 192.676 350.269C187.556 350.269 182.446 350.169 178.606 350.119C176.696 350.079 175.096 350.039 173.986 350.019C172.876 349.989 172.236 349.979 172.236 349.979L174.396 347.059L174.386 347.069Z",
    fill: "url(#paint81_linear_11846_111534)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M148.496 346.051C148.496 346.051 149.776 346.121 151.696 346.221C152.656 346.271 153.776 346.331 154.976 346.391C156.186 346.441 157.486 346.501 158.776 346.551C160.076 346.601 161.366 346.661 162.586 346.711C163.806 346.761 164.956 346.791 165.936 346.821C167.896 346.881 169.206 346.931 169.206 346.931L166.546 349.831C166.546 349.831 165.116 349.781 162.956 349.711C161.886 349.671 160.626 349.641 159.286 349.581C157.956 349.521 156.536 349.471 155.106 349.411C153.686 349.351 152.266 349.291 150.936 349.231C149.616 349.161 148.386 349.101 147.336 349.051C145.236 348.941 143.826 348.871 143.826 348.871L148.486 346.051H148.496Z",
    fill: "url(#paint82_linear_11846_111534)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M120.828 344.03C120.828 344.03 121.478 344.09 122.448 344.18C122.938 344.23 123.508 344.28 124.118 344.33C124.738 344.38 125.408 344.44 126.068 344.49C128.728 344.71 131.388 344.93 131.388 344.93L125.078 347.64C125.078 347.64 122.158 347.4 119.248 347.16C118.518 347.1 117.798 347.04 117.108 346.98C116.438 346.92 115.818 346.86 115.278 346.81C114.208 346.71 113.498 346.64 113.498 346.64L120.828 344.02V344.03Z",
    fill: "url(#paint83_linear_11846_111534)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M294.755 341.641C294.755 341.641 295.835 341.501 297.455 341.291C299.025 341.071 301.115 340.771 303.205 340.471C305.265 340.171 307.235 339.841 308.755 339.611C309.505 339.491 310.135 339.391 310.545 339.321C310.965 339.251 311.205 339.211 311.205 339.211L322.195 341.371C322.195 341.371 321.935 341.421 321.465 341.491C321.015 341.571 320.325 341.681 319.505 341.811C317.855 342.071 315.685 342.421 313.425 342.761C311.145 343.091 308.855 343.421 307.125 343.661C305.355 343.891 304.165 344.051 304.165 344.051L294.755 341.661V341.641Z",
    fill: "url(#paint84_linear_11846_111534)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M252.617 345.63C252.617 345.63 253.127 345.6 254.017 345.54C254.917 345.49 256.147 345.39 257.647 345.29C259.137 345.18 260.897 345.06 262.747 344.92C264.577 344.77 266.537 344.61 268.487 344.45L269.947 344.33C270.427 344.29 270.897 344.24 271.367 344.2C272.307 344.11 273.227 344.03 274.127 343.94C275.017 343.86 275.887 343.78 276.707 343.7C277.527 343.62 278.267 343.54 278.967 343.47C281.757 343.18 283.607 342.98 283.607 342.98L291.947 345.5C291.947 345.5 289.907 345.71 286.857 346.03C286.087 346.11 285.277 346.2 284.377 346.28C283.477 346.36 282.537 346.45 281.557 346.55C280.577 346.64 279.557 346.74 278.527 346.83C278.007 346.88 277.487 346.93 276.967 346.97C276.437 347.01 275.897 347.06 275.367 347.1C273.227 347.28 271.077 347.45 269.067 347.62C267.037 347.77 265.107 347.91 263.467 348.03C261.817 348.15 260.467 348.25 259.487 348.31C258.517 348.37 257.957 348.41 257.957 348.41L252.607 345.63H252.617Z",
    fill: "url(#paint85_linear_11846_111534)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6962 340.602C91.6962 340.602 92.7362 340.752 94.3062 340.972C95.0962 341.082 95.9861 341.222 97.0061 341.352C98.0161 341.482 99.0961 341.622 100.186 341.762C101.276 341.902 102.346 342.042 103.376 342.172C104.426 342.292 105.396 342.412 106.236 342.512C107.916 342.712 109.036 342.842 109.036 342.842L100.566 345.352C100.566 345.352 99.3361 345.212 97.4961 344.992C96.5761 344.882 95.5061 344.762 94.3561 344.622C93.2161 344.482 92.0461 344.332 90.8561 344.172C89.6761 344.022 88.4861 343.862 87.3761 343.722C86.2661 343.582 85.2862 343.432 84.4162 343.312C82.6962 343.062 81.5562 342.902 81.5562 342.902L91.6861 340.612L91.6962 340.602Z",
    fill: "url(#paint86_linear_11846_111534)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1165 336.191C67.1165 336.191 67.3265 336.241 67.7065 336.321C68.0865 336.401 68.6265 336.511 69.2765 336.651C70.5965 336.921 72.2765 337.301 74.1365 337.641C75.0565 337.811 75.9665 337.991 76.8265 338.151C77.2565 338.231 77.6765 338.311 78.0665 338.391C78.4765 338.461 78.8665 338.531 79.2265 338.591C80.6665 338.841 81.6265 339.011 81.6265 339.011L70.5265 341.151C70.5265 341.151 69.4765 340.971 67.8965 340.691C67.5065 340.621 67.0765 340.551 66.6265 340.471C66.1965 340.391 65.7365 340.301 65.2665 340.211C64.3265 340.031 63.3265 339.841 62.3165 339.651C60.2765 339.271 58.4265 338.861 56.9865 338.561C56.2765 338.411 55.6865 338.281 55.2665 338.201C54.8465 338.111 54.6265 338.061 54.6265 338.061L67.1065 336.191H67.1165Z",
    fill: "url(#paint87_linear_11846_111534)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0363 330.941C48.0363 330.941 48.1863 330.991 48.4563 331.091C48.7263 331.181 49.0863 331.321 49.5963 331.481C50.5863 331.791 51.9163 332.211 53.2463 332.631C54.6763 333.041 56.1163 333.441 57.1863 333.751C57.7163 333.901 58.2263 334.021 58.5463 334.111C58.8863 334.201 59.0763 334.251 59.0763 334.251L45.8163 335.931C45.8163 335.931 45.6063 335.881 45.2363 335.781C44.8763 335.681 44.3263 335.551 43.7463 335.381C42.5663 335.051 40.9963 334.601 39.4263 334.151C37.9763 333.691 36.5163 333.231 35.4263 332.891C34.8763 332.721 34.4763 332.571 34.1763 332.471C33.8863 332.371 33.7163 332.311 33.7163 332.311L48.0363 330.941Z",
    fill: "url(#paint88_linear_11846_111534)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5777 325.941C36.5777 325.941 37.5077 326.441 38.4477 326.951C38.6877 327.081 38.9077 327.201 39.1477 327.321C39.3977 327.441 39.6277 327.541 39.8277 327.641C40.2277 327.831 40.4977 327.951 40.4977 327.951L25.4477 329.031C25.4477 329.031 25.1577 328.891 24.7177 328.691C24.4977 328.591 24.2477 328.471 23.9777 328.341C23.7177 328.211 23.4677 328.071 23.2077 327.941C22.1877 327.391 21.1577 326.841 21.1577 326.841L36.5877 325.961L36.5777 325.941Z",
    fill: "url(#paint89_linear_11846_111534)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M44.256 303.972C44.256 303.972 43.706 304.192 42.886 304.522C42.026 304.852 41.096 305.302 40.116 305.752C39.096 306.202 38.276 306.662 37.636 307.002C36.996 307.342 36.576 307.572 36.576 307.572L21.146 306.692C21.146 306.692 21.606 306.442 22.306 306.062C23.006 305.682 23.916 305.182 25.026 304.692C26.106 304.202 27.126 303.702 28.066 303.342C28.966 302.982 29.566 302.742 29.566 302.742L44.256 303.972Z",
    fill: "url(#paint90_linear_11846_111534)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8563 298.551C61.8563 298.551 61.0863 298.751 59.9263 299.041C59.3463 299.191 58.6763 299.361 57.9563 299.551C57.2363 299.731 56.5463 299.941 55.8163 300.141C54.3763 300.551 52.9363 300.951 51.9763 301.271C50.9863 301.581 50.3163 301.791 50.3163 301.791L36.2163 300.351C36.2163 300.351 36.9463 300.121 38.0263 299.781C39.0863 299.431 40.6563 298.991 42.2363 298.541C43.0363 298.321 43.7963 298.091 44.5763 297.891C45.3663 297.691 46.0963 297.501 46.7263 297.341C47.9963 297.021 48.8463 296.801 48.8463 296.801L61.8363 298.551H61.8563Z",
    fill: "url(#paint91_linear_11846_111534)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1544 293.919C85.1544 293.919 84.9044 293.959 84.4644 294.029C84.0144 294.099 83.4244 294.199 82.6944 294.329C81.2644 294.579 79.3044 294.909 77.4444 295.249C75.6144 295.599 73.7844 295.949 72.4144 296.209C71.1044 296.479 70.2344 296.669 70.2344 296.669L58.0444 294.739C58.0444 294.739 59.0044 294.539 60.4344 294.239C61.9144 293.949 63.9344 293.569 65.9444 293.179C67.9844 292.799 70.1244 292.439 71.6944 292.169C72.4844 292.029 73.1444 291.919 73.6344 291.839C74.1144 291.759 74.3844 291.719 74.3844 291.719L85.1444 293.919H85.1544Z",
    fill: "url(#paint92_linear_11846_111534)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M109.025 290.682C109.025 290.682 106.575 290.972 104.115 291.252C102.875 291.392 101.705 291.552 100.815 291.662C99.9251 291.782 99.3351 291.852 99.3351 291.852L89.9351 289.462C89.9351 289.462 90.5851 289.382 91.5651 289.252C92.5451 289.132 93.8251 288.952 95.1851 288.802C97.8751 288.492 100.565 288.172 100.565 288.172L109.035 290.682H109.025Z",
    fill: "url(#paint93_linear_11846_111534)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3055 318.898C29.3055 318.898 29.4055 319.138 29.5555 319.498C29.6655 319.858 30.0455 320.338 30.3655 320.818C30.5455 321.058 30.6755 321.298 30.8955 321.518C31.1155 321.738 31.3155 321.948 31.4855 322.128C31.8355 322.488 32.0755 322.728 32.0755 322.728L16.2155 323.298C16.2155 323.298 15.9555 323.038 15.5655 322.648C15.3755 322.448 15.1555 322.228 14.9155 321.978C14.6755 321.738 14.5255 321.468 14.3355 321.208C13.9755 320.678 13.5655 320.158 13.4455 319.758C13.2755 319.358 13.1655 319.098 13.1655 319.098L29.2955 318.898H29.3055Z",
    fill: "url(#paint94_linear_11846_111534)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3768 308.969C34.3768 308.969 34.1468 309.099 33.8568 309.339C33.5568 309.579 33.1168 309.919 32.6068 310.329C32.3268 310.529 32.1068 310.759 31.8768 310.989C31.6468 311.229 31.3968 311.479 31.1468 311.729C31.0268 311.859 30.8868 311.989 30.7768 312.119C30.6768 312.249 30.5868 312.389 30.4868 312.529C30.2968 312.799 30.1068 313.079 29.9068 313.359C29.6868 313.639 29.6068 313.919 29.4868 314.189C29.3768 314.459 29.2668 314.729 29.1568 314.999C28.9868 315.519 28.9768 316.009 28.9068 316.429C28.8968 316.529 28.8868 316.629 28.8668 316.729C28.8668 316.829 28.8868 316.919 28.8968 316.999C28.9168 317.169 28.9368 317.319 28.9568 317.439C28.9868 317.679 29.0068 317.819 29.0068 317.819L12.8468 317.919C12.8468 317.919 12.8268 317.769 12.7868 317.499C12.7668 317.369 12.7468 317.199 12.7268 317.019C12.7268 316.929 12.7068 316.829 12.6968 316.719C12.7068 316.619 12.7168 316.509 12.7368 316.389C12.8068 315.929 12.8268 315.399 13.0168 314.829C13.1368 314.539 13.2568 314.249 13.3768 313.949C13.5168 313.649 13.6068 313.339 13.8468 313.039C14.0568 312.739 14.2668 312.429 14.4768 312.129C14.5868 311.979 14.6868 311.829 14.7968 311.689C14.9168 311.539 15.0668 311.399 15.2068 311.259C15.4868 310.979 15.7568 310.699 16.0068 310.439C16.2568 310.179 16.5068 309.939 16.8068 309.709C17.3768 309.259 17.8468 308.889 18.1868 308.629C18.5068 308.369 18.7568 308.219 18.7568 308.219L34.3968 308.969H34.3768Z",
    fill: "url(#paint95_linear_11846_111534)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M140.335 287.95C140.335 287.95 139.065 288.02 137.225 288.16C136.295 288.23 135.215 288.3 134.055 288.39C132.905 288.48 131.645 288.56 130.445 288.66C128.025 288.86 125.595 289.06 123.795 289.21C122.015 289.37 120.835 289.48 120.835 289.48L113.505 286.86C113.505 286.86 114.805 286.74 116.755 286.56C118.725 286.39 121.395 286.17 124.055 285.96C125.375 285.85 126.745 285.76 128.015 285.66C129.285 285.57 130.475 285.48 131.495 285.41C133.525 285.26 134.915 285.18 134.915 285.18L140.365 287.95H140.335Z",
    fill: "url(#paint96_linear_11846_111534)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M173.948 286.449C173.948 286.449 173.618 286.449 173.038 286.469C172.468 286.489 171.638 286.499 170.658 286.529C168.698 286.589 166.078 286.679 163.458 286.759C160.858 286.859 158.268 286.969 156.328 287.059C155.838 287.079 155.398 287.099 155.008 287.119C154.618 287.139 154.278 287.159 153.998 287.169C153.438 287.199 153.118 287.219 153.118 287.219L148.908 284.379C148.908 284.379 149.258 284.359 149.878 284.329C150.188 284.309 150.558 284.299 150.988 284.269C151.418 284.249 151.908 284.229 152.438 284.209C154.568 284.119 157.408 283.999 160.258 283.889C163.128 283.799 165.998 283.699 168.148 283.629C169.218 283.589 170.128 283.579 170.758 283.559C171.388 283.549 171.748 283.539 171.748 283.539L173.948 286.449Z",
    fill: "url(#paint97_linear_11846_111534)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M208.424 286.241C208.424 286.241 208.094 286.241 207.514 286.231C206.934 286.231 206.104 286.211 205.114 286.201C203.124 286.201 200.474 286.181 197.834 286.171C195.184 286.171 192.534 286.191 190.554 286.191C189.564 286.191 188.734 286.191 188.154 286.201C187.574 286.201 187.244 286.211 187.244 286.211L186.314 283.271C186.314 283.271 186.674 283.271 187.314 283.261C187.944 283.261 188.854 283.261 189.944 283.241C192.124 283.241 195.024 283.211 197.924 283.211C200.824 283.221 203.724 283.241 205.904 283.251C206.994 283.251 207.894 283.271 208.534 283.281C209.164 283.281 209.534 283.291 209.534 283.291L208.444 286.231L208.424 286.241Z",
    fill: "url(#paint98_linear_11846_111534)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M237.855 287.082C237.855 287.082 235.015 286.962 232.175 286.842C230.755 286.782 229.315 286.742 228.245 286.702C227.165 286.662 226.455 286.642 226.455 286.642L229.275 283.742C229.275 283.742 230.065 283.772 231.245 283.802C232.425 283.842 234.005 283.892 235.555 283.952C238.675 284.082 241.785 284.212 241.785 284.212L237.865 287.062L237.855 287.082Z",
    fill: "url(#paint99_linear_11846_111534)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M336.746 299.752C336.746 299.752 336.576 299.702 336.246 299.612C335.906 299.522 335.436 299.402 334.856 299.252C334.276 299.102 333.606 298.932 332.886 298.752C332.526 298.662 332.146 298.562 331.766 298.472C331.366 298.382 330.956 298.282 330.546 298.192C328.896 297.812 327.296 297.432 325.996 297.152C324.696 296.882 323.826 296.692 323.826 296.692L336.026 294.762C336.026 294.762 336.976 294.962 338.406 295.262C339.836 295.562 341.586 295.982 343.396 296.402C343.846 296.502 344.286 296.612 344.726 296.712C345.146 296.822 345.556 296.922 345.956 297.022C346.746 297.222 347.486 297.412 348.116 297.572C348.746 297.732 349.266 297.872 349.636 297.962C349.996 298.062 350.186 298.112 350.186 298.112L336.756 299.752H336.746Z",
    fill: "url(#paint100_linear_11846_111534)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M352.904 305.311C352.904 305.311 352.784 305.251 352.564 305.161C352.344 305.061 352.064 304.921 351.654 304.751C350.834 304.421 349.734 303.981 348.644 303.541C347.464 303.111 346.234 302.681 345.324 302.351C344.884 302.191 344.464 302.061 344.174 301.971C343.884 301.881 343.724 301.831 343.724 301.831L357.834 300.391C357.834 300.391 358.014 300.451 358.334 300.551C358.654 300.651 359.104 300.791 359.594 300.971C360.594 301.321 361.944 301.791 363.234 302.271C364.434 302.751 365.634 303.241 366.534 303.601C366.984 303.781 367.294 303.941 367.534 304.041C367.774 304.151 367.904 304.211 367.904 304.211L352.914 305.311H352.904Z",
    fill: "url(#paint101_linear_11846_111534)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M362.457 311.361C362.457 311.361 362.217 311.121 361.867 310.761C361.507 310.401 360.857 309.931 360.277 309.461C360.127 309.341 359.977 309.221 359.827 309.111C359.647 309.001 359.477 308.881 359.307 308.771C358.967 308.551 358.647 308.351 358.377 308.171C358.107 308.001 357.877 307.851 357.717 307.751C357.567 307.651 357.447 307.591 357.447 307.591L372.877 306.711C372.877 306.711 372.997 306.771 373.167 306.881C373.347 306.991 373.597 307.151 373.897 307.341C374.197 307.531 374.547 307.761 374.917 307.991C375.097 308.111 375.287 308.231 375.487 308.361C375.647 308.491 375.817 308.621 375.987 308.751C376.637 309.271 377.337 309.781 377.737 310.171C378.127 310.561 378.387 310.821 378.387 310.821L362.467 311.341L362.457 311.361Z",
    fill: "url(#paint102_linear_11846_111534)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M365.107 316.761C365.107 316.761 365.037 316.231 364.967 315.701C364.927 315.441 364.907 315.171 364.807 314.971C364.727 314.771 364.677 314.641 364.677 314.641L380.807 314.441C380.807 314.441 380.867 314.581 380.947 314.801C381.057 315.021 381.077 315.311 381.127 315.601C381.197 316.181 381.277 316.761 381.277 316.761H365.107Z",
    fill: "url(#paint103_linear_11846_111534)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M274.654 289.619C274.654 289.619 273.474 289.509 271.694 289.339C269.934 289.169 267.494 288.979 265.074 288.779C262.664 288.569 260.184 288.399 258.324 288.269C256.464 288.139 255.224 288.049 255.224 288.049L260.824 285.289C260.824 285.289 262.184 285.389 264.224 285.529C266.254 285.679 268.984 285.869 271.624 286.089C274.274 286.309 276.954 286.519 278.884 286.709C280.834 286.889 282.124 287.009 282.124 287.009L274.644 289.619H274.654Z",
    fill: "url(#paint104_linear_11846_111534)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M330.546 298.181C330.546 298.181 329.716 297.991 328.256 297.651C326.836 297.311 324.596 296.851 321.946 296.291C319.206 295.751 315.986 295.121 312.276 294.501C311.356 294.341 310.446 294.181 309.466 294.021C308.486 293.861 307.486 293.711 306.486 293.551C305.476 293.391 304.486 293.231 303.436 293.081C302.386 292.931 301.326 292.781 300.266 292.631C299.196 292.481 298.156 292.321 297.066 292.181C295.976 292.041 294.886 291.901 293.806 291.761C292.716 291.621 291.656 291.481 290.576 291.351C289.486 291.221 288.396 291.101 287.336 290.971C286.266 290.851 285.226 290.721 284.196 290.611C283.146 290.501 282.106 290.391 281.106 290.291C279.086 290.081 277.216 289.871 275.396 289.711C273.596 289.541 271.936 289.391 270.476 289.251C269.006 289.121 267.676 289.011 266.606 288.921C264.456 288.741 263.216 288.641 263.216 288.641L269.596 285.941C269.596 285.941 270.946 286.051 273.306 286.241C274.476 286.341 275.926 286.451 277.546 286.601C279.156 286.751 280.966 286.921 282.946 287.101C284.936 287.281 286.996 287.501 289.206 287.731C290.306 287.851 291.436 287.961 292.586 288.091C293.716 288.221 294.856 288.351 296.026 288.491C297.186 288.631 298.376 288.771 299.576 288.911C300.766 289.051 301.926 289.211 303.116 289.361C304.296 289.511 305.496 289.671 306.696 289.821C307.886 289.981 309.036 290.151 310.206 290.311C311.366 290.481 312.526 290.641 313.686 290.811C314.836 290.981 315.926 291.161 317.036 291.331C318.136 291.501 319.226 291.681 320.296 291.851C321.376 292.021 322.366 292.201 323.376 292.371C327.436 293.061 330.966 293.741 333.966 294.341C336.866 294.951 339.326 295.451 340.876 295.831C342.476 296.201 343.386 296.411 343.386 296.411L330.546 298.201V298.181Z",
    fill: "url(#paint105_linear_11846_111534)"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M321.685 310.689C321.685 310.689 321.815 310.529 322.005 310.279C322.175 310.029 322.275 309.699 322.445 309.369C322.485 309.289 322.525 309.199 322.565 309.119C322.575 309.039 322.585 308.959 322.595 308.879C322.615 308.719 322.635 308.579 322.655 308.449C322.695 308.199 322.725 308.039 322.725 308.039H337.095C337.095 308.039 337.065 308.219 337.025 308.499C337.005 308.639 336.985 308.799 336.955 308.969C336.945 309.059 336.935 309.149 336.915 309.239C336.875 309.329 336.835 309.419 336.785 309.509C336.595 309.879 336.485 310.249 336.295 310.519C336.085 310.789 335.945 310.979 335.945 310.979L321.685 310.679V310.689Z",
    fill: "url(#paint106_linear_11846_111534)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M346.744 311.219C346.744 311.219 346.894 311.019 347.124 310.729C347.324 310.429 347.454 310.039 347.654 309.639C347.704 309.539 347.744 309.439 347.784 309.339C347.794 309.239 347.814 309.149 347.824 309.049C347.854 308.859 347.874 308.689 347.904 308.539C347.954 308.239 347.984 308.039 347.984 308.039H376.604C376.604 308.039 376.574 308.279 376.524 308.629C376.494 308.809 376.464 309.009 376.434 309.229C376.414 309.339 376.394 309.449 376.374 309.569C376.324 309.689 376.274 309.799 376.224 309.919C376.004 310.389 375.824 310.859 375.594 311.209C375.334 311.559 375.154 311.799 375.154 311.799L346.754 311.199L346.744 311.219Z",
    fill: "url(#paint107_linear_11846_111534)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M326.634 320.928C326.634 320.928 327.004 320.818 327.654 320.638C328.274 320.448 329.274 320.188 330.284 319.858C332.344 319.208 334.984 318.318 337.144 317.398C337.684 317.168 338.234 316.938 338.764 316.718C339.234 316.488 339.694 316.258 340.144 316.048C340.574 315.828 341.054 315.618 341.394 315.418C341.744 315.218 342.074 315.018 342.374 314.848C342.674 314.668 342.954 314.508 343.204 314.358C343.404 314.208 343.584 314.088 343.734 313.978C344.024 313.768 344.194 313.648 344.194 313.648L372.104 314.708C372.104 314.708 371.904 314.848 371.554 315.098C371.374 315.228 371.164 315.378 370.914 315.548C370.624 315.718 370.294 315.918 369.934 316.128C369.574 316.338 369.174 316.568 368.764 316.808C368.354 317.048 367.794 317.298 367.284 317.558C366.744 317.818 366.194 318.088 365.634 318.358C365.004 318.628 364.354 318.898 363.714 319.178C361.134 320.268 358.014 321.328 355.544 322.108C354.334 322.498 353.164 322.808 352.424 323.038C351.654 323.258 351.214 323.388 351.214 323.388L326.654 320.938L326.634 320.928Z",
    fill: "url(#paint108_linear_11846_111534)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M305.074 325.588C305.074 325.588 305.894 325.448 307.134 325.228C308.404 325.018 309.954 324.718 311.514 324.418C312.284 324.268 313.094 324.118 313.794 323.978C314.484 323.828 315.134 323.697 315.684 323.577C316.794 323.347 317.524 323.188 317.524 323.188L340.354 326.058C340.354 326.058 339.484 326.248 338.164 326.518C337.504 326.658 336.734 326.817 335.914 326.997C335.084 327.167 334.134 327.348 333.214 327.528C331.364 327.888 329.504 328.237 328.004 328.497C326.534 328.757 325.554 328.928 325.554 328.928L305.064 325.598L305.074 325.588Z",
    fill: "url(#paint109_linear_11846_111534)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M253.867 331.33C253.867 331.33 254.557 331.28 255.767 331.21C256.947 331.12 258.637 330.99 260.657 330.84C264.707 330.53 269.937 330.07 275.047 329.57C277.537 329.3 280.067 329.05 282.347 328.78C284.587 328.51 286.767 328.27 288.497 328.04C290.247 327.81 291.697 327.62 292.717 327.49C293.717 327.35 294.267 327.27 294.267 327.27L312.717 330.91C312.717 330.91 312.067 331.01 310.867 331.17C309.657 331.33 307.927 331.56 305.847 331.83C303.787 332.11 301.217 332.39 298.537 332.71C295.827 333.02 292.827 333.33 289.847 333.65C283.787 334.25 277.547 334.8 272.727 335.16C270.317 335.34 268.307 335.49 266.897 335.6C265.467 335.69 264.647 335.75 264.647 335.75L253.857 331.34L253.867 331.33Z",
    fill: "url(#paint110_linear_11846_111534)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M219.814 332.899C219.814 332.899 220.114 332.899 220.624 332.879C221.134 332.859 221.874 332.839 222.754 332.819C223.634 332.789 224.664 332.759 225.764 332.729C226.314 332.709 226.884 332.699 227.464 332.679C228.034 332.659 228.614 332.639 229.194 332.609C231.514 332.519 233.854 332.439 235.574 332.359C237.294 332.279 238.444 332.219 238.444 332.219L246.284 336.799C246.284 336.799 244.914 336.859 242.864 336.959C240.814 337.059 238.034 337.149 235.264 337.259C234.574 337.289 233.884 337.309 233.194 337.339C232.504 337.359 231.834 337.379 231.174 337.399C229.864 337.439 228.644 337.479 227.594 337.509C226.544 337.539 225.674 337.569 225.064 337.579C224.454 337.599 224.104 337.609 224.104 337.609L219.814 332.899Z",
    fill: "url(#paint111_linear_11846_111534)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M158.146 332.34C158.146 332.34 158.326 332.34 158.656 332.36C158.986 332.38 159.476 332.4 160.116 332.42C161.376 332.47 163.186 332.54 165.346 332.62C167.506 332.71 170.076 332.77 172.806 332.85C175.546 332.93 178.496 332.98 181.436 333.04C184.386 333.08 187.346 333.12 190.116 333.14C192.896 333.14 195.486 333.17 197.706 333.17C199.926 333.17 201.776 333.15 203.076 333.15C203.726 333.15 204.236 333.15 204.576 333.15C204.926 333.15 205.106 333.15 205.106 333.15L206.626 337.91C206.626 337.91 206.406 337.91 205.996 337.91C205.586 337.91 204.976 337.91 204.216 337.91C202.676 337.91 200.476 337.93 197.846 337.94C195.206 337.94 192.136 337.92 188.836 337.91C185.546 337.89 182.036 337.83 178.526 337.79C175.036 337.71 171.526 337.65 168.266 337.56C165.016 337.46 161.956 337.38 159.386 337.28C156.806 337.18 154.656 337.1 153.156 337.04C152.406 337.01 151.816 336.99 151.416 336.97C151.016 336.95 150.806 336.94 150.806 336.94L158.146 332.34Z",
    fill: "url(#paint112_linear_11846_111534)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M125.303 330.18C125.303 330.18 126.363 330.27 127.953 330.41C129.543 330.55 131.653 330.73 133.843 330.89C136.023 331.05 138.173 331.23 139.853 331.33C141.513 331.44 142.623 331.51 142.623 331.51L132.313 335.95C132.313 335.95 130.993 335.86 129.013 335.73C127.013 335.61 124.443 335.4 121.853 335.21C119.243 335.02 116.733 334.8 114.833 334.64C112.943 334.48 111.673 334.37 111.673 334.37L125.283 330.18H125.303Z",
    fill: "url(#paint113_linear_11846_111534)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3954 326.328C93.3954 326.328 93.6754 326.368 94.1654 326.448C94.6654 326.528 95.3354 326.638 96.2254 326.768C97.1054 326.898 98.1254 327.038 99.2254 327.198C99.7754 327.278 100.335 327.358 100.915 327.438C101.515 327.518 102.125 327.598 102.725 327.678C103.945 327.838 105.155 327.998 106.295 328.148C107.455 328.298 108.575 328.418 109.515 328.538C111.405 328.758 112.665 328.908 112.665 328.908L96.6654 332.858C96.6654 332.858 95.1654 332.678 92.9154 332.418C91.7954 332.288 90.4654 332.128 89.0954 331.958C87.7354 331.778 86.2954 331.588 84.8454 331.408C84.1254 331.318 83.4054 331.218 82.6954 331.128C82.0154 331.028 81.3354 330.938 80.6854 330.838C79.3854 330.648 78.1654 330.478 77.1254 330.328C76.0754 330.178 75.2654 330.048 74.6754 329.948C74.0954 329.858 73.7554 329.808 73.7554 329.808L93.3954 326.338V326.328Z",
    fill: "url(#paint114_linear_11846_111534)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3137 320.93C67.3137 320.93 67.8937 321.1 68.8837 321.35C69.8737 321.6 71.0937 321.94 72.4737 322.26C73.8637 322.58 75.2237 322.91 76.2937 323.15C77.4037 323.38 78.1337 323.54 78.1337 323.54L55.6137 326.48C55.6137 326.48 54.7437 326.29 53.4237 326.02C52.1437 325.74 50.5237 325.35 48.8737 324.96C47.2337 324.57 45.7737 324.17 44.6037 323.87C43.4337 323.57 42.7437 323.37 42.7437 323.37L67.3037 320.93H67.3137Z",
    fill: "url(#paint115_linear_11846_111534)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M47.224 311.207C47.224 311.207 47.314 311.327 47.484 311.547C47.574 311.657 47.644 311.787 47.794 311.937C47.954 312.087 48.134 312.247 48.324 312.437C48.524 312.617 48.734 312.817 48.954 313.027C49.184 313.237 49.524 313.447 49.824 313.677C50.144 313.907 50.464 314.137 50.794 314.367C51.194 314.597 51.594 314.837 52.004 315.077C53.604 316.027 55.704 316.947 57.374 317.637C58.174 317.987 59.024 318.257 59.524 318.457C60.054 318.657 60.364 318.767 60.364 318.767L34.474 320.797C34.474 320.797 34.114 320.667 33.474 320.427C32.864 320.187 31.874 319.867 30.914 319.447C28.914 318.627 26.434 317.527 24.514 316.397C24.034 316.117 23.554 315.827 23.084 315.557C22.684 315.277 22.294 314.997 21.924 314.727C21.564 314.457 21.164 314.197 20.894 313.957C20.624 313.707 20.374 313.477 20.134 313.257C19.904 313.037 19.694 312.837 19.504 312.667C19.334 312.487 19.234 312.337 19.124 312.207C18.924 311.957 18.814 311.807 18.814 311.807L47.214 311.217L47.224 311.207Z",
    fill: "url(#paint116_linear_11846_111534)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8847 305.33C46.8847 305.33 46.8448 305.38 46.7848 305.47C46.7448 305.56 46.6848 305.68 46.6148 305.83C46.5048 306.13 46.2548 306.52 46.1648 306.92C46.1048 307.32 46.0447 307.71 45.9947 308.01C46.0347 308.31 46.0548 308.51 46.0548 308.51L17.4347 308.59C17.4347 308.59 17.4047 308.35 17.3647 308C17.4147 307.65 17.4847 307.18 17.5547 306.7C17.6547 306.23 17.9447 305.76 18.0847 305.41C18.1747 305.23 18.2447 305.09 18.2947 304.98C18.3747 304.88 18.4147 304.82 18.4147 304.82L46.8747 305.33H46.8847Z",
    fill: "url(#paint117_linear_11846_111534)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9838 295.548C65.9838 295.548 65.6138 295.658 64.9638 295.838C64.2838 296.018 63.4638 296.298 62.4538 296.628C61.9538 296.788 61.4038 296.968 60.8238 297.158C60.3038 297.348 59.7438 297.558 59.1738 297.768C57.9738 298.188 56.9238 298.647 55.8338 299.107C55.2638 299.337 54.7938 299.568 54.3338 299.798C53.8638 300.028 53.4038 300.258 52.9638 300.478C52.1538 300.918 51.4838 301.337 50.8638 301.688C49.8538 302.408 49.1738 302.888 49.1738 302.888L21.1538 301.918C21.1538 301.918 21.3538 301.778 21.6938 301.528C22.0438 301.278 22.5138 300.918 23.1638 300.488C23.8938 300.068 24.6938 299.568 25.6638 299.038C26.1938 298.778 26.7338 298.508 27.2938 298.238C27.8438 297.968 28.4138 297.688 29.0838 297.418C30.3738 296.868 31.6438 296.317 33.0538 295.827C33.7338 295.577 34.3938 295.337 35.0238 295.107C35.7138 294.877 36.3538 294.668 36.9538 294.478C38.1638 294.088 39.1438 293.758 39.9438 293.538C40.7138 293.318 41.1538 293.188 41.1538 293.188L65.9738 295.558L65.9838 295.548Z",
    fill: "url(#paint118_linear_11846_111534)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0268 290.828C87.0268 290.828 86.1868 290.968 84.9768 291.188C83.8068 291.418 82.2468 291.718 80.6768 292.018C79.1968 292.328 77.7168 292.638 76.6068 292.878C76.0368 292.998 75.6168 293.098 75.3168 293.168C75.0168 293.238 74.8368 293.278 74.8368 293.278L51.6968 290.478C51.6968 290.478 51.9068 290.428 52.2668 290.348C52.6268 290.268 53.1368 290.138 53.8068 290.008C55.1268 289.728 56.8568 289.358 58.6468 288.988C60.5068 288.628 62.3568 288.278 63.7568 288.008C65.1968 287.748 66.1868 287.578 66.1868 287.578L87.0268 290.848V290.828Z",
    fill: "url(#paint119_linear_11846_111534)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M137.596 284.929C137.596 284.929 136.926 284.979 135.736 285.069C134.566 285.159 132.856 285.279 130.856 285.439C128.886 285.609 126.546 285.799 124.126 286.019C122.926 286.139 121.676 286.249 120.416 286.379C119.786 286.439 119.146 286.499 118.516 286.559L116.646 286.759C115.396 286.889 114.156 287.029 112.926 287.159C111.716 287.299 110.566 287.439 109.426 287.569C108.306 287.709 107.186 287.829 106.176 287.959C105.176 288.089 104.226 288.209 103.356 288.329C102.486 288.439 101.686 288.549 100.976 288.639C100.296 288.739 99.6957 288.819 99.2057 288.889C98.2257 289.029 97.6657 289.109 97.6657 289.109L78.8257 285.519C78.8257 285.519 79.4957 285.419 80.6557 285.259C81.2357 285.179 81.9457 285.069 82.7657 284.959C83.6057 284.849 84.5557 284.719 85.5957 284.589C86.6357 284.449 87.7657 284.309 88.9557 284.149C90.1457 283.999 91.4757 283.849 92.8157 283.689C94.1657 283.529 95.5457 283.359 96.9857 283.199C98.4457 283.039 99.9257 282.889 101.406 282.729L103.636 282.489C104.386 282.409 105.146 282.339 105.896 282.269C107.396 282.129 108.886 281.979 110.316 281.849C113.206 281.579 115.986 281.359 118.336 281.159C120.706 280.969 122.746 280.819 124.146 280.709C125.556 280.599 126.356 280.539 126.356 280.539L137.626 284.919L137.596 284.929Z",
    fill: "url(#paint120_linear_11846_111534)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M171.486 283.279C171.486 283.279 170.316 283.309 168.546 283.369C166.776 283.409 164.456 283.509 162.136 283.599C160.976 283.649 159.806 283.679 158.726 283.739C157.646 283.789 156.646 283.839 155.786 283.879C154.066 283.959 152.916 284.019 152.916 284.019L144.576 279.459C144.576 279.459 145.946 279.389 147.996 279.299C149.026 279.249 150.216 279.199 151.496 279.139C152.776 279.079 154.176 279.029 155.556 278.979C158.326 278.869 161.086 278.759 163.196 278.709C165.296 278.649 166.686 278.609 166.686 278.609L171.486 283.309V283.279Z",
    fill: "url(#paint121_linear_11846_111534)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M210.866 283.017C210.866 283.017 209.326 282.997 207.016 282.967C204.706 282.927 201.606 282.927 198.516 282.917C196.966 282.907 195.426 282.917 193.976 282.917C192.526 282.917 191.176 282.927 190.016 282.937C188.856 282.937 187.896 282.957 187.216 282.967C186.546 282.967 186.156 282.977 186.156 282.977L184.126 278.227C184.126 278.227 184.586 278.227 185.386 278.207C186.186 278.207 187.336 278.177 188.706 278.177C190.086 278.177 191.686 278.167 193.406 278.157C195.126 278.157 196.956 278.137 198.796 278.157C202.466 278.177 206.136 278.177 208.886 278.217C211.636 278.247 213.466 278.277 213.466 278.277L210.866 283.017Z",
    fill: "url(#paint122_linear_11846_111534)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M251.385 284.6C251.385 284.6 250.275 284.53 248.605 284.42C246.915 284.32 244.655 284.2 242.395 284.07C240.115 283.95 237.805 283.85 236.095 283.77C235.235 283.73 234.515 283.7 234.005 283.68C233.495 283.66 233.205 283.65 233.205 283.65L240.045 279.02C240.045 279.02 240.395 279.03 240.995 279.06C241.605 279.08 242.455 279.12 243.485 279.17C245.535 279.27 248.275 279.39 250.995 279.53C253.685 279.68 256.375 279.83 258.395 279.95C260.395 280.07 261.705 280.16 261.705 280.16L251.385 284.6Z",
    fill: "url(#paint123_linear_11846_111534)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M303.214 290.188C303.214 290.188 302.674 290.098 301.744 289.958C300.794 289.808 299.494 289.588 297.824 289.348C296.124 289.108 294.224 288.818 292.044 288.528C289.844 288.248 287.574 287.928 285.124 287.648C283.914 287.508 282.714 287.358 281.524 287.218C280.294 287.088 279.094 286.958 277.924 286.828C275.614 286.568 273.344 286.358 271.424 286.178C270.454 286.088 269.574 285.998 268.794 285.928C267.994 285.858 267.294 285.798 266.714 285.748C265.564 285.648 264.904 285.598 264.904 285.598L277.794 281.348C277.794 281.348 278.574 281.418 279.954 281.528C280.644 281.588 281.474 281.658 282.424 281.738C283.364 281.828 284.414 281.928 285.564 282.038C287.854 282.258 290.544 282.508 293.304 282.818C294.694 282.968 296.124 283.118 297.584 283.278C298.994 283.448 300.434 283.618 301.874 283.788C304.784 284.118 307.494 284.498 310.104 284.828C312.684 285.168 314.964 285.518 316.974 285.798C318.954 286.088 320.504 286.348 321.634 286.528C322.744 286.708 323.384 286.808 323.384 286.808L303.244 290.198L303.214 290.188Z",
    fill: "url(#paint124_linear_11846_111534)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M325.234 294.78C325.234 294.78 324.594 294.61 323.624 294.36C323.134 294.24 322.594 294.09 321.954 293.93C321.304 293.78 320.614 293.62 319.924 293.45C319.234 293.29 318.534 293.13 317.884 292.98C317.194 292.83 316.544 292.7 315.994 292.58C314.884 292.35 314.154 292.19 314.154 292.19L336.354 289.18C336.354 289.18 337.234 289.37 338.544 289.64C339.204 289.78 339.964 289.94 340.784 290.12C341.554 290.3 342.384 290.49 343.214 290.68C344.034 290.87 344.854 291.07 345.624 291.25C346.374 291.43 347.024 291.61 347.614 291.76C348.764 292.06 349.524 292.26 349.524 292.26L325.224 294.78H325.234Z",
    fill: "url(#paint125_linear_11846_111534)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M347.985 308.05C347.985 308.05 347.955 307.87 347.905 307.56C347.835 307.25 347.865 306.79 347.555 306.26C347.205 305.18 345.985 303.75 344.025 302.35C342.055 300.95 339.395 299.58 336.845 298.58C336.275 298.33 335.665 298.1 335.115 297.9C334.575 297.7 334.095 297.53 333.715 297.38C333.325 297.24 333.025 297.12 332.785 297.05C332.555 296.97 332.435 296.93 332.435 296.93L358.095 294.82C358.095 294.82 358.245 294.87 358.515 294.96C358.805 295.05 359.165 295.18 359.625 295.35C360.085 295.52 360.655 295.73 361.295 295.97C361.945 296.21 362.675 296.48 363.355 296.78C366.365 297.96 369.565 299.6 371.905 301.27C374.245 302.94 375.665 304.64 376.105 305.92C376.455 306.56 376.445 307.09 376.525 307.47C376.575 307.84 376.605 308.06 376.605 308.06H347.985V308.05Z",
    fill: "url(#paint126_linear_11846_111534)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M319.877 320.261C319.877 320.261 320.477 320.091 321.527 319.781C322.627 319.481 323.967 319.031 325.617 318.501C328.787 317.421 332.427 315.931 334.947 314.381C337.537 312.841 338.977 311.251 339.557 310.051C339.687 309.751 339.817 309.481 339.917 309.231C339.957 308.991 339.987 308.771 340.007 308.601C340.067 308.251 340.097 308.051 340.097 308.051H344.557C344.557 308.051 344.527 308.261 344.467 308.621C344.437 308.801 344.407 309.021 344.367 309.271C344.257 309.521 344.127 309.801 343.997 310.111C343.397 311.351 341.917 312.991 339.237 314.581C336.637 316.181 332.877 317.711 329.607 318.831C327.907 319.381 326.527 319.841 325.387 320.151C324.307 320.461 323.687 320.641 323.687 320.641L319.857 320.261H319.877Z",
    fill: "url(#paint127_linear_11846_111534)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M379.725 308.049C379.725 308.049 379.695 307.859 379.655 307.499C379.565 307.139 379.615 306.599 379.235 305.909C378.685 304.519 377.325 302.459 373.105 299.939C372.565 299.629 372.005 299.299 371.435 298.969C370.775 298.639 370.095 298.309 369.405 297.969C368.745 297.629 367.905 297.279 367.075 296.929C366.235 296.579 365.425 296.219 364.415 295.859C360.665 294.409 355.825 292.899 349.825 291.379C337.855 288.339 320.925 285.249 298.525 282.759C287.335 281.519 274.835 280.429 261.245 279.569C247.665 278.709 232.945 278.119 217.635 277.829C215.725 277.779 213.795 277.769 211.865 277.739C209.935 277.719 207.995 277.689 206.045 277.669C204.095 277.669 202.145 277.649 200.185 277.639H197.245C196.265 277.629 195.275 277.639 194.295 277.639C192.325 277.639 190.345 277.659 188.365 277.669C186.385 277.679 184.395 277.709 182.405 277.739C178.415 277.779 174.425 277.879 170.415 277.959C162.415 278.169 154.365 278.429 146.435 278.819C142.435 278.999 138.525 279.229 134.575 279.459C132.615 279.579 130.675 279.709 128.725 279.839L125.805 280.029L122.925 280.249C107.515 281.379 92.8752 282.899 79.6052 284.749C72.9552 285.669 66.7552 286.689 60.8752 287.769C55.0152 288.849 49.6952 290.019 44.7552 291.239C39.8352 292.459 35.5452 293.759 31.6952 295.089C27.8552 296.429 24.7352 297.819 22.0852 299.249C19.4552 300.669 17.6052 302.139 16.2252 303.609C14.9152 305.089 14.3552 306.579 14.2552 308.069C14.3552 309.559 14.9152 311.049 16.2252 312.529C17.6052 313.999 19.4552 315.469 22.0852 316.889C24.7452 318.309 27.8552 319.709 31.6952 321.049C35.5552 322.379 39.8452 323.679 44.7552 324.899C49.6952 326.119 55.0152 327.289 60.8752 328.369C66.7552 329.449 72.9552 330.469 79.6052 331.389C92.8752 333.239 107.515 334.759 122.925 335.889L125.805 336.109L128.725 336.299C130.675 336.429 132.615 336.559 134.575 336.679C138.535 336.899 142.435 337.139 146.435 337.319C154.365 337.709 162.425 337.979 170.415 338.179C174.425 338.259 178.415 338.359 182.405 338.399C184.395 338.419 186.385 338.459 188.365 338.469C190.345 338.469 192.325 338.489 194.295 338.499C195.285 338.499 196.265 338.499 197.245 338.499H200.185C202.145 338.479 204.095 338.469 206.045 338.459C207.995 338.439 209.925 338.409 211.865 338.389C213.795 338.359 215.725 338.349 217.635 338.299C232.935 337.999 247.665 337.419 261.245 336.559C274.835 335.699 287.335 334.609 298.525 333.369C320.915 330.869 337.855 327.779 349.825 324.749C355.825 323.229 360.665 321.719 364.415 320.269C365.425 319.909 366.225 319.549 367.075 319.199C367.905 318.849 368.745 318.509 369.405 318.159C370.095 317.819 370.775 317.479 371.435 317.159C372.005 316.829 372.565 316.509 373.105 316.189C377.315 313.669 378.675 311.609 379.235 310.219C379.615 309.519 379.565 308.989 379.655 308.629C379.705 308.269 379.725 308.079 379.725 308.079H381.405C381.405 308.079 381.375 308.269 381.335 308.629C381.245 308.989 381.295 309.529 380.915 310.239C380.355 311.639 378.985 313.719 374.735 316.269C374.185 316.589 373.625 316.909 373.045 317.249C372.375 317.579 371.695 317.919 370.995 318.259C370.325 318.609 369.485 318.949 368.645 319.309C367.795 319.659 366.985 320.029 365.965 320.389C362.185 321.849 357.295 323.369 351.245 324.909C339.165 327.969 322.075 331.089 299.475 333.609C288.185 334.859 275.565 335.959 261.855 336.829C248.155 337.699 233.295 338.289 217.845 338.589C215.915 338.639 213.975 338.659 212.025 338.679C210.075 338.699 208.115 338.729 206.155 338.749C204.195 338.749 202.215 338.769 200.245 338.779H197.275C196.285 338.789 195.285 338.779 194.295 338.779C192.305 338.779 190.305 338.759 188.305 338.749C186.305 338.739 184.295 338.699 182.285 338.679C178.255 338.639 174.235 338.539 170.185 338.459C162.115 338.249 153.985 337.979 145.985 337.589C141.945 337.409 138.005 337.169 134.015 336.949C132.035 336.829 130.085 336.699 128.115 336.569L125.165 336.369L122.265 336.149C106.715 335.009 91.9352 333.469 78.5452 331.609C71.8352 330.679 65.5752 329.649 59.6452 328.559C53.7352 327.469 48.3552 326.289 43.3752 325.059C38.4152 323.829 34.0852 322.519 30.1952 321.169C26.3252 319.819 23.1752 318.409 20.4952 316.979C17.8452 315.539 15.9752 314.059 14.5852 312.579C13.2652 311.089 12.6952 309.579 12.5952 308.079C12.6952 306.579 13.2652 305.069 14.5852 303.579C15.9752 302.089 17.8452 300.619 20.4952 299.179C23.1752 297.739 26.3252 296.339 30.1952 294.989C34.0852 293.639 38.4152 292.339 43.3752 291.099C48.3552 289.869 53.7352 288.689 59.6452 287.599C65.5852 286.509 71.8352 285.479 78.5452 284.549C91.9352 282.689 106.715 281.149 122.265 280.009L125.165 279.789L128.115 279.589C130.085 279.459 132.045 279.329 134.015 279.209C138.005 278.989 141.955 278.749 145.985 278.569C153.985 278.169 162.115 277.909 170.185 277.699C174.235 277.609 178.265 277.519 182.285 277.479C184.295 277.459 186.305 277.419 188.305 277.409C190.305 277.409 192.305 277.389 194.295 277.379C195.285 277.379 196.285 277.379 197.275 277.379H200.245C202.225 277.399 204.195 277.409 206.155 277.419C208.115 277.439 210.075 277.469 212.025 277.489C213.975 277.519 215.925 277.539 217.845 277.579C233.295 277.879 248.155 278.469 261.855 279.339C275.565 280.199 288.185 281.299 299.475 282.559C322.075 285.079 339.165 288.199 351.245 291.259C357.295 292.789 362.185 294.319 365.965 295.779C366.985 296.139 367.795 296.509 368.645 296.859C369.485 297.219 370.325 297.559 370.995 297.909C371.695 298.259 372.375 298.589 373.045 298.919C373.625 299.249 374.185 299.579 374.735 299.899C378.985 302.449 380.365 304.519 380.915 305.929C381.295 306.629 381.245 307.169 381.335 307.539C381.385 307.899 381.405 308.089 381.405 308.089H379.725V308.049Z",
    fill: "url(#paint128_linear_11846_111534)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M317.824 308.048C317.824 308.048 317.804 307.928 317.764 307.688C317.684 307.448 317.764 307.088 317.484 306.628C317.134 305.708 316.234 304.348 313.444 302.688C313.094 302.478 312.724 302.268 312.354 302.048C311.914 301.838 311.464 301.608 311.004 301.388C310.584 301.158 310.014 300.938 309.464 300.708C308.904 300.478 308.404 300.238 307.714 299.998C305.264 299.038 302.044 298.048 298.074 297.038C290.154 295.028 278.914 292.978 264.094 291.328C256.684 290.508 248.424 289.788 239.474 289.218C230.524 288.648 220.824 288.268 210.704 288.068C209.444 288.038 208.164 288.028 206.884 288.008C205.604 287.988 204.314 287.978 203.024 287.958C201.724 287.958 200.424 287.958 199.124 287.938H197.164C196.514 287.938 195.854 287.938 195.194 287.938C193.884 287.938 192.564 287.948 191.244 287.958C189.924 287.958 188.614 287.988 187.284 288.008C184.634 288.028 182.004 288.098 179.344 288.148C174.064 288.288 168.744 288.458 163.524 288.718C160.874 288.828 158.324 288.998 155.704 289.138C154.414 289.218 153.144 289.308 151.854 289.388L149.924 289.518L148.034 289.658C137.864 290.398 128.184 291.408 119.394 292.628C114.974 293.238 110.894 293.918 106.974 294.628C103.084 295.348 99.5843 296.118 96.2943 296.928C93.0343 297.738 90.2243 298.598 87.6643 299.478C85.1243 300.358 83.1043 301.278 81.3243 302.218C79.5843 303.158 78.3943 304.118 77.4543 305.098C76.5943 306.078 76.2343 307.068 76.1443 308.058C76.2443 309.048 76.5943 310.038 77.4543 311.018C78.3943 311.988 79.5843 312.958 81.3243 313.898C83.0943 314.838 85.1143 315.758 87.6643 316.638C90.2243 317.518 93.0343 318.378 96.2943 319.188C99.5843 319.988 103.084 320.768 106.974 321.488C110.894 322.198 114.974 322.878 119.394 323.488C128.194 324.708 137.874 325.718 148.034 326.458L149.924 326.598L151.854 326.728C153.144 326.808 154.414 326.898 155.704 326.978C158.324 327.118 160.884 327.288 163.524 327.398C168.744 327.658 174.064 327.828 179.344 327.968C182.004 328.018 184.634 328.088 187.284 328.108C188.604 328.118 189.924 328.148 191.244 328.158C192.564 328.158 193.884 328.168 195.194 328.178C195.854 328.178 196.504 328.178 197.164 328.178H199.124C200.424 328.168 201.734 328.158 203.024 328.158C204.314 328.138 205.604 328.128 206.884 328.108C208.164 328.088 209.444 328.078 210.704 328.048C220.824 327.848 230.524 327.468 239.474 326.898C248.424 326.328 256.674 325.618 264.094 324.798C278.914 323.148 290.154 321.088 298.074 319.088C302.044 318.078 305.254 317.088 307.714 316.128C308.404 315.898 308.904 315.658 309.464 315.418C310.014 315.188 310.584 314.958 311.004 314.738C311.464 314.508 311.914 314.288 312.354 314.078C312.724 313.858 313.094 313.648 313.444 313.438C316.234 311.778 317.134 310.418 317.484 309.488C317.764 309.028 317.684 308.668 317.764 308.428C317.804 308.188 317.824 308.068 317.824 308.068H320.314C320.314 308.068 320.294 308.198 320.254 308.438C320.174 308.678 320.254 309.048 319.974 309.518C319.614 310.458 318.694 311.848 315.844 313.548C315.484 313.758 315.114 313.978 314.734 314.198C314.284 314.418 313.824 314.638 313.354 314.868C312.924 315.098 312.344 315.328 311.784 315.568C311.214 315.808 310.694 316.048 309.994 316.288C307.484 317.268 304.204 318.278 300.154 319.308C292.074 321.358 280.604 323.448 265.474 325.138C257.914 325.978 249.484 326.708 240.344 327.288C231.214 327.868 221.314 328.258 210.974 328.458C209.684 328.488 208.384 328.498 207.074 328.518C205.764 328.538 204.454 328.548 203.134 328.568C201.814 328.568 200.484 328.578 199.154 328.588H197.154C196.484 328.588 195.814 328.588 195.144 328.588C193.804 328.588 192.464 328.578 191.114 328.568C189.764 328.568 188.424 328.538 187.074 328.518C184.364 328.498 181.684 328.428 178.974 328.368C173.584 328.228 168.154 328.058 162.824 327.788C160.124 327.678 157.514 327.508 154.844 327.358C153.524 327.278 152.234 327.188 150.914 327.098L148.944 326.968L147.014 326.818C136.634 326.058 126.754 325.028 117.774 323.778C113.264 323.158 109.094 322.458 105.104 321.738C101.134 321.008 97.5543 320.218 94.2043 319.398C90.8743 318.578 88.0043 317.698 85.3943 316.798C82.7943 315.898 80.7343 314.958 78.9243 313.998C77.1443 313.038 75.9343 312.058 74.9743 311.058C74.0943 310.058 73.7343 309.048 73.6343 308.038C73.7343 307.028 74.0943 306.018 74.9743 305.018C75.9343 304.028 77.1443 303.038 78.9243 302.078C80.7343 301.128 82.7943 300.178 85.3943 299.278C88.0143 298.378 90.8743 297.508 94.2043 296.678C97.5543 295.858 101.134 295.068 105.104 294.338C109.094 293.608 113.264 292.918 117.774 292.298C126.754 291.048 136.634 290.018 147.014 289.258L148.944 289.108L150.914 288.978C152.234 288.898 153.534 288.808 154.844 288.718C157.514 288.578 160.124 288.408 162.824 288.288C168.154 288.018 173.584 287.848 178.974 287.708C181.684 287.658 184.374 287.578 187.074 287.558C188.424 287.548 189.764 287.518 191.114 287.508C192.464 287.508 193.804 287.498 195.144 287.488C195.814 287.488 196.484 287.488 197.154 287.488H199.154C200.484 287.498 201.814 287.508 203.134 287.518C204.454 287.538 205.764 287.548 207.074 287.568C208.384 287.588 209.694 287.598 210.974 287.628C221.304 287.828 231.204 288.218 240.344 288.798C249.484 289.378 257.904 290.108 265.474 290.948C280.594 292.638 292.064 294.728 300.154 296.778C304.204 297.808 307.484 298.818 309.994 299.798C310.694 300.038 311.204 300.278 311.784 300.518C312.344 300.758 312.924 300.988 313.354 301.218C313.824 301.448 314.284 301.668 314.734 301.888C315.114 302.108 315.484 302.328 315.844 302.538C318.694 304.238 319.614 305.618 319.974 306.568C320.264 307.038 320.184 307.408 320.254 307.648C320.294 307.888 320.314 308.018 320.314 308.018H317.824V308.048Z",
    fill: "url(#paint129_linear_11846_111534)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M250.894 330.12C250.894 330.12 255.394 329.83 261.824 329.29C268.274 328.75 276.564 327.92 284.174 326.94C291.824 325.97 298.754 324.84 303.574 323.95C304.754 323.72 305.844 323.51 306.804 323.33C307.784 323.15 308.514 322.97 309.184 322.84C310.484 322.56 311.234 322.41 311.234 322.41L314.794 322.86C314.794 322.86 314.024 323.02 312.684 323.31C311.994 323.45 311.234 323.63 310.224 323.82C309.234 324.01 308.114 324.23 306.894 324.46C301.924 325.38 294.784 326.54 286.894 327.55C279.044 328.56 270.494 329.42 263.844 329.97C257.204 330.53 252.564 330.83 252.564 330.83L250.884 330.14L250.894 330.12Z",
    fill: "url(#paint130_linear_11846_111534)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M160.165 331.069C160.165 331.069 160.455 331.079 160.995 331.109C161.535 331.129 162.345 331.159 163.375 331.199C165.425 331.279 168.345 331.399 171.915 331.499C179.015 331.709 188.625 331.889 198.275 331.869C207.915 331.859 217.525 331.669 224.595 331.429C226.385 331.379 227.975 331.309 229.405 331.259C230.835 331.199 232.085 331.159 233.105 331.119C235.125 331.019 236.285 330.969 236.285 330.969L237.505 331.679C237.505 331.679 236.315 331.739 234.225 331.839C233.175 331.889 231.885 331.929 230.415 331.989C228.935 332.039 227.295 332.119 225.455 332.169C218.165 332.419 208.255 332.609 198.325 332.629C188.385 332.649 178.475 332.469 171.145 332.249C167.465 332.149 164.455 332.029 162.335 331.949C161.275 331.909 160.445 331.879 159.885 331.849C159.325 331.819 159.025 331.809 159.025 331.809L160.165 331.089V331.069Z",
    fill: "url(#paint131_linear_11846_111534)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M84.334 322.727C84.334 322.727 85.074 322.887 86.374 323.157C87.044 323.297 87.894 323.447 88.854 323.637C89.824 323.817 90.864 324.037 92.134 324.247C97.004 325.137 104.064 326.237 111.834 327.187C119.564 328.147 127.934 328.947 134.434 329.467C136.054 329.597 137.584 329.707 138.914 329.807C140.254 329.907 141.404 329.997 142.394 330.057C144.354 330.187 145.474 330.257 145.474 330.257L143.864 330.947C143.864 330.947 142.714 330.867 140.694 330.737C139.674 330.677 138.484 330.577 137.104 330.477C135.734 330.367 134.154 330.257 132.484 330.127C125.774 329.587 117.154 328.757 109.174 327.767C101.164 326.787 93.884 325.647 88.864 324.737C87.544 324.517 86.484 324.297 85.484 324.107C84.494 323.917 83.614 323.757 82.924 323.617C81.584 323.337 80.814 323.167 80.814 323.167L84.324 322.707L84.334 322.727Z",
    fill: "url(#paint132_linear_11846_111534)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M177.335 284.448C177.335 284.448 176.735 284.458 175.695 284.478C174.645 284.498 173.175 284.548 171.395 284.598C170.505 284.628 169.545 284.648 168.525 284.678C167.505 284.708 166.455 284.758 165.355 284.798C163.155 284.878 160.805 284.968 158.505 285.088C157.345 285.138 156.195 285.197 155.055 285.247C153.915 285.297 152.825 285.368 151.755 285.428C149.625 285.548 147.615 285.658 145.945 285.768C144.265 285.878 142.865 285.968 141.885 286.038C141.395 286.068 141.015 286.098 140.755 286.118C140.495 286.138 140.365 286.148 140.365 286.148L138.595 285.467C138.595 285.467 138.735 285.457 139.005 285.438C139.265 285.418 139.655 285.387 140.165 285.357C141.175 285.287 142.615 285.198 144.355 285.088C146.075 284.968 148.145 284.858 150.345 284.728C151.455 284.668 152.575 284.598 153.755 284.538C154.935 284.478 156.125 284.428 157.315 284.368C159.685 284.248 162.115 284.158 164.385 284.068C165.525 284.028 166.605 283.978 167.655 283.948C168.705 283.918 169.695 283.887 170.615 283.857C172.445 283.807 173.975 283.758 175.045 283.728C176.125 283.708 176.735 283.688 176.735 283.688L177.345 284.428L177.335 284.448Z",
    fill: "url(#paint133_linear_11846_111534)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M340.104 308.048C340.104 308.048 340.044 307.668 339.954 307.098C339.954 306.808 339.734 306.478 339.594 306.128C339.504 305.948 339.444 305.768 339.334 305.578C339.194 305.388 339.044 305.208 338.904 305.018C338.764 304.828 338.614 304.638 338.474 304.458C338.274 304.278 338.084 304.088 337.894 303.918C337.514 303.568 337.204 303.238 336.774 302.958C336.384 302.678 336.064 302.448 335.844 302.288C335.634 302.128 335.474 302.038 335.474 302.038L339.794 301.848C339.794 301.848 339.964 301.938 340.184 302.108C340.414 302.278 340.744 302.518 341.144 302.798C341.584 303.088 341.904 303.428 342.304 303.788C342.494 303.968 342.694 304.158 342.894 304.348C343.044 304.538 343.184 304.738 343.334 304.928C343.484 305.118 343.634 305.318 343.784 305.508C343.894 305.698 343.964 305.888 344.054 306.078C344.204 306.448 344.434 306.788 344.424 307.078C344.514 307.668 344.574 308.058 344.574 308.058H340.114L340.104 308.048Z",
    fill: "url(#paint134_linear_11846_111534)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 285.02C233.777 285.02 233.637 285.02 233.357 285C233.087 284.99 232.687 284.97 232.177 284.95C231.147 284.91 229.687 284.85 227.927 284.79C226.177 284.71 224.097 284.66 221.877 284.59C220.767 284.56 219.617 284.52 218.447 284.49C217.267 284.47 216.077 284.44 214.887 284.42C213.687 284.4 212.497 284.37 211.317 284.35C210.137 284.34 208.967 284.32 207.847 284.31C206.717 284.3 205.637 284.28 204.597 284.27C203.567 284.27 202.587 284.27 201.677 284.26C199.867 284.26 198.367 284.25 197.307 284.24C196.257 284.24 195.647 284.24 195.647 284.24L195.607 283.5C195.607 283.5 196.227 283.5 197.317 283.5C198.407 283.5 199.957 283.51 201.817 283.52C202.747 283.52 203.757 283.52 204.827 283.53C205.887 283.54 207.017 283.56 208.177 283.57C209.337 283.58 210.537 283.6 211.757 283.62C212.977 283.64 214.197 283.67 215.437 283.7C216.667 283.73 217.897 283.75 219.107 283.78C220.317 283.81 221.497 283.85 222.637 283.88C224.927 283.95 227.067 284.01 228.877 284.08C230.687 284.15 232.207 284.21 233.257 284.25C233.787 284.27 234.197 284.29 234.477 284.3C234.757 284.31 234.907 284.32 234.907 284.32L233.767 285.04L233.777 285.02Z",
    fill: "url(#paint135_linear_11846_111534)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9341 308.48C53.9341 308.48 53.9641 308.68 54.0141 309.03C54.0141 309.21 54.1041 309.42 54.2241 309.66C54.3341 309.9 54.4641 310.18 54.5941 310.48C55.3441 311.68 56.9641 313.26 59.7141 314.8C62.4041 316.34 66.2041 317.82 69.5241 318.89C71.1041 319.43 72.6841 319.86 73.7241 320.16C74.2441 320.31 74.6541 320.43 74.9741 320.51C75.2841 320.59 75.4441 320.63 75.4441 320.63L71.6541 321.02C71.6541 321.02 71.4841 320.98 71.1741 320.9C70.8441 320.82 70.4241 320.7 69.8841 320.54C68.8141 320.23 67.1941 319.78 65.5541 319.23C62.1341 318.13 58.2141 316.6 55.4441 315.02C52.6041 313.44 50.9341 311.8 50.1641 310.57C50.0241 310.26 49.8941 309.98 49.7841 309.73C49.6541 309.48 49.5641 309.26 49.5641 309.08C49.5141 308.72 49.4741 308.51 49.4741 308.51H53.9341V308.48Z",
    fill: "url(#paint136_linear_11846_111534)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M117.965 288.189C117.965 288.189 117.535 288.229 116.755 288.319C115.995 288.409 114.865 288.539 113.445 288.709C112.735 288.799 111.925 288.889 111.085 288.989C110.255 289.099 109.355 289.219 108.395 289.339C107.445 289.469 106.385 289.589 105.355 289.739C104.315 289.889 103.235 290.049 102.095 290.209C97.6249 290.879 92.5549 291.689 87.7549 292.649C82.9049 293.609 78.1949 294.689 74.0649 295.829C69.9049 296.969 66.4749 298.179 63.7249 299.339C63.3849 299.489 63.0349 299.629 62.6949 299.769C62.3549 299.909 62.0949 300.059 61.7949 300.199C61.2249 300.489 60.6249 300.759 60.1249 301.039C59.2049 301.589 58.2349 302.109 57.6349 302.599C57.3049 302.839 56.9549 303.079 56.6849 303.299C56.4449 303.519 56.2149 303.739 56.0049 303.939C55.8049 304.139 55.5549 304.329 55.4349 304.499C55.3049 304.669 55.1849 304.829 55.0749 304.979C54.8649 305.269 54.6649 305.499 54.5749 305.649C54.5049 305.809 54.4649 305.889 54.4649 305.889L50.0249 305.819C50.0249 305.819 50.0649 305.729 50.1349 305.569C50.2249 305.409 50.4249 305.179 50.6449 304.879C50.7549 304.729 50.8849 304.569 51.0249 304.389C51.1549 304.209 51.4049 304.019 51.6149 303.809C51.8349 303.599 52.0749 303.379 52.3149 303.149C52.5849 302.919 52.9549 302.679 53.2949 302.429C53.9149 301.919 54.9049 301.389 55.8649 300.819C56.3749 300.539 57.0049 300.249 57.5849 299.959C57.8949 299.809 58.1649 299.659 58.5149 299.519C58.8649 299.369 59.2149 299.219 59.5749 299.069C62.4049 297.869 65.9449 296.619 70.2349 295.449C74.4849 294.269 79.3549 293.149 84.3449 292.169C89.2949 291.179 94.5249 290.339 99.1349 289.649C100.305 289.479 101.425 289.319 102.495 289.169C103.555 289.009 104.645 288.879 105.625 288.749C106.615 288.619 107.545 288.499 108.395 288.389C109.265 288.279 110.095 288.189 110.825 288.099C112.295 287.929 113.455 287.789 114.245 287.699C115.045 287.609 115.485 287.559 115.485 287.559L117.955 288.179L117.965 288.189Z",
    fill: "url(#paint137_linear_11846_111534)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M332.764 300.518C332.764 300.518 332.604 300.438 332.304 300.288C331.974 300.138 331.624 299.918 330.944 299.648C330.284 299.378 329.554 299.048 328.594 298.668C328.094 298.488 327.554 298.288 326.994 298.078C326.434 297.868 325.844 297.648 325.134 297.428C319.824 295.638 311.054 293.368 299.774 291.468C294.194 290.508 288.124 289.638 282.104 288.888C276.074 288.138 270.044 287.538 264.794 287.058C259.484 286.588 254.914 286.248 251.684 286.028C248.424 285.818 246.564 285.688 246.564 285.688L248.114 284.988C248.114 284.988 250.034 285.118 253.394 285.338C256.734 285.568 261.434 285.928 266.914 286.408C272.324 286.908 278.544 287.528 284.764 288.298C290.974 289.068 297.224 289.978 302.974 290.958C314.604 292.918 323.654 295.258 329.124 297.108C329.854 297.338 330.464 297.558 331.044 297.778C331.624 297.988 332.174 298.198 332.694 298.388C333.674 298.778 334.434 299.118 335.114 299.398C335.814 299.678 336.184 299.908 336.524 300.058C336.834 300.208 337.004 300.288 337.004 300.288L332.774 300.518H332.764Z",
    fill: "url(#paint138_linear_11846_111534)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M315.833 314.88C315.833 314.88 316.154 314.72 316.634 314.49C317.164 314.26 317.614 313.94 318.184 313.62C318.774 313.3 319.164 312.98 319.514 312.74C319.854 312.5 320.074 312.34 320.074 312.34L334.143 312.83C334.143 312.83 333.893 313.01 333.523 313.28C333.143 313.55 332.704 313.91 332.044 314.26C331.414 314.61 330.894 314.97 330.314 315.23C329.784 315.49 329.423 315.67 329.423 315.67L315.844 314.89L315.833 314.88Z",
    fill: "url(#paint139_linear_11846_111534)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M304.953 318.78C304.953 318.78 305.443 318.64 306.183 318.42C306.553 318.31 306.993 318.19 307.453 318.05C307.873 317.91 308.333 317.77 308.783 317.62C309.233 317.47 309.693 317.33 310.113 317.19C310.543 317.05 310.863 316.92 311.173 316.81C311.783 316.58 312.193 316.43 312.193 316.43L325.353 317.39C325.353 317.39 324.893 317.56 324.213 317.81C323.863 317.94 323.493 318.08 323.023 318.24C322.553 318.39 322.043 318.56 321.543 318.72C321.033 318.88 320.533 319.05 320.053 319.2C319.533 319.35 319.053 319.49 318.633 319.61C317.803 319.85 317.253 320.01 317.253 320.01L304.923 318.78H304.953Z",
    fill: "url(#paint140_linear_11846_111534)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M291.857 321.78C291.857 321.78 292.217 321.71 292.747 321.61C293.277 321.51 294.027 321.37 294.677 321.23L297.377 320.66L308.837 322.1C308.837 322.1 307.337 322.42 305.837 322.74C305.107 322.9 304.287 323.05 303.697 323.17C303.097 323.28 302.707 323.36 302.707 323.36L291.867 321.79L291.857 321.78Z",
    fill: "url(#paint141_linear_11846_111534)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M211.976 328.828C211.976 328.828 212.966 328.808 214.436 328.778C215.926 328.758 217.866 328.688 219.826 328.628C220.806 328.598 221.786 328.578 222.696 328.538C223.606 328.498 224.446 328.468 225.176 328.438C226.626 328.378 227.596 328.348 227.596 328.348L231.076 330.668C231.076 330.668 229.996 330.708 228.376 330.768C227.566 330.798 226.626 330.838 225.616 330.878C224.606 330.918 223.506 330.938 222.416 330.978C220.236 331.038 218.066 331.118 216.406 331.138C214.756 331.168 213.656 331.198 213.656 331.198L211.966 328.818L211.976 328.828Z",
    fill: "url(#paint142_linear_11846_111534)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M186.074 328.898C186.074 328.898 187.063 328.908 188.553 328.928C190.033 328.958 192.033 328.958 194.023 328.968C195.023 328.968 196.013 328.968 196.953 328.978C197.883 328.978 198.764 328.978 199.504 328.968C200.994 328.968 201.993 328.958 201.993 328.958L202.553 331.348C202.553 331.348 201.444 331.348 199.784 331.358C198.954 331.358 197.984 331.358 196.944 331.368C195.904 331.368 194.794 331.368 193.684 331.358C191.464 331.358 189.254 331.348 187.594 331.318C185.934 331.298 184.833 331.288 184.833 331.288L186.064 328.908L186.074 328.898Z",
    fill: "url(#paint143_linear_11846_111534)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M160.706 328.09C160.706 328.09 161.656 328.13 163.096 328.2C163.816 328.23 164.646 328.27 165.536 328.32C166.446 328.35 167.406 328.39 168.376 328.43C169.346 328.47 170.306 328.5 171.216 328.54C172.126 328.57 172.986 328.59 173.716 328.62C175.186 328.66 176.156 328.69 176.156 328.69L173.796 331.05C173.796 331.05 172.706 331.02 171.076 330.97C170.266 330.94 169.296 330.92 168.286 330.88C167.276 330.84 166.196 330.8 165.116 330.76C164.036 330.72 162.956 330.68 161.946 330.64C160.946 330.59 160.016 330.55 159.216 330.51C157.616 330.43 156.556 330.38 156.556 330.38L160.696 328.09H160.706Z",
    fill: "url(#paint144_linear_11846_111534)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M140.064 326.707C140.064 326.707 140.544 326.747 141.274 326.807C141.634 326.837 142.064 326.877 142.514 326.917C142.984 326.947 143.474 326.987 143.974 327.027C145.954 327.177 147.934 327.327 147.934 327.327L142.324 329.527C142.324 329.527 140.114 329.357 137.904 329.197C137.354 329.157 136.794 329.117 136.274 329.077C135.764 329.037 135.294 328.997 134.894 328.957C134.084 328.887 133.544 328.837 133.544 328.837L140.064 326.707Z",
    fill: "url(#paint145_linear_11846_111534)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M270.074 325.068C270.074 325.068 270.884 324.968 272.104 324.828C273.274 324.678 274.844 324.468 276.404 324.268C277.954 324.058 279.414 323.838 280.554 323.678C281.114 323.598 281.594 323.528 281.904 323.478C282.214 323.428 282.394 323.398 282.394 323.398L292.164 325.148C292.164 325.148 291.964 325.178 291.614 325.238C291.274 325.298 290.744 325.368 290.114 325.458C288.844 325.638 287.204 325.888 285.484 326.118C283.744 326.348 282.004 326.578 280.694 326.748C279.344 326.908 278.434 327.018 278.434 327.018L270.064 325.078L270.074 325.068Z",
    fill: "url(#paint146_linear_11846_111534)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M238.595 327.8C238.595 327.8 240.125 327.72 242.345 327.57C243.465 327.5 244.765 327.41 246.155 327.32C247.525 327.22 248.975 327.11 250.435 327C251.915 326.9 253.295 326.76 254.645 326.65C255.985 326.54 257.235 326.43 258.265 326.33C260.345 326.13 261.735 326 261.735 326L269.145 328.05C269.145 328.05 267.595 328.2 265.275 328.42C264.125 328.54 262.735 328.65 261.245 328.78C259.745 328.9 258.195 329.05 256.555 329.17C254.925 329.29 253.305 329.41 251.775 329.53C250.225 329.63 248.765 329.73 247.525 329.81C245.055 329.98 243.345 330.07 243.345 330.07L238.595 327.81V327.8Z",
    fill: "url(#paint147_linear_11846_111534)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M118.277 324.359C118.277 324.359 119.057 324.459 120.227 324.619C121.377 324.779 123.007 324.969 124.627 325.159C125.437 325.249 126.237 325.359 127.017 325.439C127.807 325.519 128.537 325.599 129.167 325.669C130.417 325.799 131.257 325.889 131.257 325.889L123.727 327.929C123.727 327.929 122.797 327.829 121.397 327.679C120.697 327.609 119.877 327.519 119.007 327.429C118.137 327.339 117.257 327.219 116.347 327.119C114.537 326.909 112.727 326.699 111.447 326.519C110.137 326.349 109.267 326.239 109.267 326.239L118.277 324.379V324.359Z",
    fill: "url(#paint148_linear_11846_111534)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8437 321.34C99.8437 321.34 99.9937 321.37 100.284 321.43C100.574 321.48 100.974 321.56 101.464 321.66C102.464 321.84 103.694 322.11 105.104 322.34C107.794 322.83 110.724 323.28 110.724 323.28L100.864 325.02C100.864 325.02 97.6137 324.52 94.6137 323.98C93.0437 323.72 91.6637 323.43 90.5537 323.22C90.0137 323.12 89.5537 323.03 89.2337 322.97C88.9137 322.91 88.7437 322.87 88.7437 322.87L99.8337 321.35L99.8437 321.34Z",
    fill: "url(#paint149_linear_11846_111534)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5769 317.75C85.5769 317.75 85.6869 317.79 85.8869 317.85C86.0869 317.91 86.3469 318.01 86.7369 318.11C87.4769 318.33 88.4669 318.61 89.4569 318.9C90.5269 319.18 91.6069 319.46 92.4069 319.67C92.7869 319.78 93.1869 319.86 93.4269 319.92C93.6769 319.98 93.8269 320.01 93.8269 320.01L82.0469 321.38C82.0469 321.38 81.8869 321.34 81.6069 321.28C81.3369 321.21 80.8969 321.12 80.4669 321.01C79.5669 320.78 78.3769 320.47 77.1769 320.16C76.0769 319.84 74.9669 319.52 74.1469 319.28C73.7169 319.16 73.4269 319.06 73.2069 318.99C72.9869 318.92 72.8569 318.88 72.8569 318.88L85.5769 317.77V317.75Z",
    fill: "url(#paint150_linear_11846_111534)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0161 314.33C77.0161 314.33 77.7162 314.67 78.4162 315.02C78.7362 315.19 79.1362 315.36 79.4462 315.49C79.7462 315.62 79.9462 315.7 79.9462 315.7L66.5761 316.57C66.5761 316.57 66.3561 316.48 66.0161 316.33C65.6661 316.19 65.2361 316 64.8661 315.81C64.0861 315.43 63.3062 315.04 63.3062 315.04L77.0161 314.32V314.33Z",
    fill: "url(#paint151_linear_11846_111534)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7561 299.299C82.7561 299.299 82.3461 299.449 81.7361 299.679C81.0761 299.899 80.4162 300.209 79.6662 300.519C78.8862 300.819 78.2961 301.139 77.8161 301.369C77.3361 301.599 77.0161 301.759 77.0161 301.759L63.3062 301.039C63.3062 301.039 63.6662 300.869 64.1962 300.599C64.7362 300.339 65.3961 299.989 66.2561 299.649C67.0861 299.309 67.8261 298.959 68.5661 298.709C69.2461 298.459 69.7061 298.289 69.7061 298.289L82.7561 299.289V299.299Z",
    fill: "url(#paint152_linear_11846_111534)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9054 295.598C95.9054 295.598 95.3354 295.737 94.4654 295.938C94.0354 296.038 93.5254 296.158 92.9854 296.288C92.4454 296.418 91.9454 296.558 91.3954 296.698C90.3254 296.978 89.2254 297.247 88.5254 297.467C87.7854 297.677 87.2854 297.827 87.2854 297.827L74.7554 296.658C74.7554 296.658 75.3054 296.498 76.1354 296.258C76.9254 296.018 78.1454 295.708 79.3354 295.398C79.9454 295.248 80.5054 295.088 81.1054 294.948C81.7054 294.808 82.2654 294.678 82.7554 294.568C83.7154 294.338 84.3554 294.188 84.3554 294.188L95.8954 295.607L95.9054 295.598Z",
    fill: "url(#paint153_linear_11846_111534)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M113.376 292.419C113.376 292.419 113.186 292.449 112.856 292.489C112.516 292.539 112.076 292.609 111.536 292.689C110.476 292.859 108.986 293.089 107.596 293.319C106.226 293.559 104.856 293.799 103.826 293.979C102.856 294.169 102.206 294.289 102.206 294.289L91.3765 292.719C91.3765 292.719 92.0965 292.579 93.1865 292.369C94.3365 292.169 95.8565 291.899 97.3865 291.639C98.9365 291.379 100.576 291.129 101.766 290.939C102.366 290.839 102.856 290.759 103.236 290.709C103.606 290.659 103.816 290.629 103.816 290.629L113.376 292.419Z",
    fill: "url(#paint154_linear_11846_111534)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M131.246 290.198C131.246 290.198 129.416 290.398 127.576 290.588C126.636 290.678 125.776 290.798 125.106 290.868C124.436 290.948 123.996 290.998 123.996 290.998L115.646 289.048C115.646 289.048 116.136 288.988 116.886 288.898C117.636 288.808 118.596 288.688 119.636 288.588C121.676 288.368 123.726 288.148 123.726 288.148L131.256 290.188L131.246 290.198Z",
    fill: "url(#paint155_linear_11846_111534)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6066 309.518C71.6066 309.518 71.6766 309.688 71.7966 309.928C71.8566 310.178 72.1766 310.508 72.4066 310.828C72.5466 310.988 72.6266 311.158 72.7966 311.308C72.9666 311.458 73.1166 311.598 73.2466 311.728C73.5066 311.968 73.6766 312.138 73.6766 312.138L59.5866 312.598C59.5866 312.598 59.3966 312.418 59.1066 312.148C58.9566 312.008 58.7866 311.858 58.6066 311.688C58.4166 311.518 58.3266 311.338 58.1766 311.148C57.9166 310.778 57.5666 310.418 57.4966 310.138C57.3666 309.858 57.2866 309.678 57.2866 309.678L71.6166 309.508L71.6066 309.518Z",
    fill: "url(#paint156_linear_11846_111534)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1033 303.617C74.1033 303.617 74.0133 303.677 73.8533 303.797C73.7133 303.907 73.5533 304.077 73.3433 304.277C73.1433 304.477 72.8533 304.707 72.6433 304.947C72.4533 305.197 72.2533 305.457 72.0533 305.727C71.8133 305.987 71.7933 306.257 71.6433 306.507C71.5333 306.757 71.3833 306.987 71.3933 307.187C71.3333 307.587 71.2933 307.857 71.2933 307.857L56.9233 307.837C56.9233 307.837 56.9733 307.537 57.0333 307.097C57.0333 306.877 57.1833 306.617 57.3033 306.337C57.4633 306.057 57.4933 305.757 57.7633 305.467C57.9833 305.177 58.2133 304.877 58.4233 304.597C58.6533 304.317 58.9833 304.067 59.2033 303.847C59.4433 303.627 59.6233 303.447 59.7833 303.317C59.9633 303.187 60.0633 303.117 60.0633 303.117L74.1133 303.617H74.1033Z",
    fill: "url(#paint157_linear_11846_111534)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M154.624 288.34C154.624 288.34 153.674 288.39 152.304 288.48C150.934 288.58 149.054 288.68 147.244 288.82C145.434 288.96 143.634 289.09 142.274 289.2C140.954 289.31 140.064 289.39 140.064 289.39L133.544 287.26C133.544 287.26 134.524 287.18 136.004 287.05C137.514 286.94 139.534 286.78 141.544 286.63C143.564 286.48 145.654 286.36 147.184 286.25C148.714 286.14 149.774 286.09 149.774 286.09L154.614 288.34H154.624Z",
    fill: "url(#paint158_linear_11846_111534)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M179.706 287.32C179.706 287.32 179.456 287.32 179.026 287.33C178.596 287.34 177.976 287.35 177.246 287.37C175.776 287.41 173.826 287.47 171.876 287.53C169.946 287.6 168.006 287.68 166.556 287.73C165.826 287.76 165.226 287.78 164.816 287.8C164.396 287.82 164.156 287.83 164.156 287.83L160.416 285.52C160.416 285.52 160.686 285.51 161.146 285.49C161.606 285.47 162.276 285.44 163.086 285.41C164.706 285.35 166.856 285.27 169.016 285.18C171.196 285.12 173.376 285.05 175.006 285C175.816 284.97 176.516 284.96 176.996 284.95C177.476 284.95 177.756 284.93 177.756 284.93L179.706 287.3V287.32Z",
    fill: "url(#paint159_linear_11846_111534)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M205.583 287.17C205.583 287.17 204.594 287.15 203.104 287.14C201.614 287.14 199.614 287.13 197.624 287.12C195.634 287.12 193.633 287.14 192.143 287.14C191.393 287.14 190.773 287.14 190.333 287.14C189.903 287.14 189.654 287.14 189.654 287.14L188.833 284.75C188.833 284.75 189.114 284.75 189.594 284.75C190.074 284.75 190.774 284.75 191.604 284.75C193.264 284.75 195.484 284.73 197.694 284.73C199.914 284.73 202.124 284.75 203.794 284.76C205.454 284.77 206.553 284.79 206.553 284.79L205.583 287.18V287.17Z",
    fill: "url(#paint160_linear_11846_111534)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M227.584 287.738C227.584 287.738 225.464 287.658 223.344 287.578C222.294 287.528 221.204 287.508 220.404 287.478C219.604 287.458 219.064 287.438 219.064 287.438L221.564 285.078C221.564 285.078 222.164 285.098 223.054 285.118C223.944 285.148 225.154 285.178 226.324 285.228C228.684 285.318 231.054 285.408 231.054 285.408L227.574 287.728L227.584 287.738Z",
    fill: "url(#paint161_linear_11846_111534)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M301.535 296.42C301.535 296.42 301.415 296.38 301.165 296.32C300.915 296.26 300.555 296.18 300.115 296.08C299.685 295.98 299.175 295.86 298.635 295.73C298.105 295.6 297.525 295.47 296.885 295.34C295.635 295.08 294.465 294.81 293.475 294.63C292.495 294.44 291.845 294.32 291.845 294.32L302.685 292.75C302.685 292.75 303.415 292.89 304.495 293.1C305.595 293.31 306.905 293.61 308.295 293.89C308.995 294.03 309.655 294.18 310.235 294.32C310.835 294.46 311.395 294.59 311.875 294.7C312.355 294.81 312.755 294.91 313.045 294.97C313.325 295.04 313.465 295.08 313.465 295.08L301.525 296.41L301.535 296.42Z",
    fill: "url(#paint162_linear_11846_111534)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M313.596 300.22C313.596 300.22 313.506 300.18 313.346 300.11C313.176 300.04 312.986 299.94 312.666 299.83C312.056 299.6 311.236 299.3 310.416 299C309.516 298.71 308.616 298.41 307.936 298.19C307.616 298.08 307.296 297.99 307.076 297.93C306.856 297.87 306.736 297.83 306.736 297.83L319.266 296.66C319.266 296.66 319.406 296.7 319.646 296.77C319.886 296.84 320.246 296.94 320.606 297.06C321.356 297.31 322.366 297.63 323.366 297.96C324.276 298.3 325.186 298.63 325.876 298.88C326.226 299.01 326.446 299.11 326.636 299.19C326.816 299.27 326.916 299.31 326.916 299.31L313.596 300.21V300.22Z",
    fill: "url(#paint163_linear_11846_111534)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M320.726 304.351C320.726 304.351 320.556 304.191 320.296 303.941C320.036 303.701 319.526 303.381 319.106 303.051C318.996 302.971 318.886 302.891 318.776 302.811C318.646 302.731 318.506 302.661 318.376 302.581C318.126 302.431 317.886 302.291 317.676 302.171C317.476 302.051 317.306 301.951 317.186 301.881C317.076 301.811 316.986 301.771 316.986 301.771L330.696 301.051C330.696 301.051 330.796 301.091 330.916 301.171C331.046 301.251 331.236 301.361 331.466 301.491C331.696 301.621 331.956 301.781 332.246 301.941C332.386 302.021 332.536 302.111 332.686 302.201C332.806 302.291 332.936 302.381 333.056 302.471C333.536 302.831 334.096 303.191 334.386 303.461C334.676 303.731 334.866 303.911 334.866 303.911L320.716 304.331L320.726 304.351Z",
    fill: "url(#paint164_linear_11846_111534)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M322.726 308.05C322.726 308.05 322.666 307.69 322.606 307.32C322.576 307.14 322.586 306.96 322.486 306.82C322.426 306.68 322.376 306.59 322.376 306.59L336.706 306.43C336.706 306.43 336.756 306.53 336.826 306.68C336.926 306.83 336.926 307.03 336.956 307.24C337.016 307.64 337.086 308.05 337.086 308.05H322.716H322.726Z",
    fill: "url(#paint165_linear_11846_111534)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M255.036 289.48C255.036 289.48 254.156 289.4 252.826 289.29C251.526 289.17 249.686 289.04 247.886 288.9C246.096 288.76 244.236 288.64 242.856 288.55C241.476 288.46 240.556 288.4 240.556 288.4L245.536 286.16C245.536 286.16 246.566 286.23 248.106 286.33C249.646 286.43 251.726 286.56 253.716 286.72C255.726 286.87 257.766 287.02 259.226 287.15C260.706 287.28 261.686 287.36 261.686 287.36L255.036 289.48Z",
    fill: "url(#paint166_linear_11846_111534)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M283.895 292.93C283.895 292.93 283.605 292.88 283.095 292.8C282.575 292.72 281.895 292.6 280.965 292.47C279.135 292.21 276.755 291.85 274.185 291.53C273.555 291.45 272.925 291.36 272.305 291.28C271.665 291.2 271.025 291.13 270.415 291.06C269.185 290.92 268.045 290.78 267.065 290.66C265.035 290.44 263.685 290.3 263.685 290.3L271.325 288.27C271.325 288.27 272.825 288.43 275.085 288.67C276.175 288.8 277.455 288.95 278.815 289.11C279.495 289.19 280.205 289.27 280.915 289.36C281.605 289.45 282.305 289.54 283.005 289.63C285.865 289.99 288.515 290.39 290.555 290.68C291.575 290.82 292.345 290.96 292.925 291.05C293.495 291.14 293.815 291.19 293.815 291.19L283.875 292.92L283.895 292.93Z",
    fill: "url(#paint167_linear_11846_111534)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.726 294.224C279.726 294.224 279.806 294.114 279.936 293.944C280.046 293.774 280.116 293.554 280.226 293.334C280.256 293.274 280.276 293.224 280.306 293.164C280.306 293.114 280.326 293.054 280.326 293.004C280.346 292.904 280.356 292.804 280.366 292.714C280.396 292.544 280.406 292.434 280.406 292.434H294.406C294.406 292.434 294.386 292.564 294.356 292.754C294.346 292.854 294.326 292.964 294.306 293.084C294.306 293.144 294.286 293.204 294.276 293.274C294.246 293.334 294.216 293.404 294.186 293.464C294.066 293.724 293.976 293.984 293.846 294.174C293.706 294.364 293.606 294.494 293.606 294.494L279.716 294.194L279.726 294.224Z",
    fill: "url(#paint168_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.845 297.042C275.845 297.042 276.055 296.932 276.375 296.782C276.725 296.622 277.035 296.412 277.405 296.192C277.795 295.982 278.055 295.762 278.285 295.602C278.505 295.442 278.655 295.332 278.655 295.332L292.365 295.812C292.365 295.812 292.195 295.942 291.935 296.132C291.675 296.322 291.355 296.572 290.905 296.822C290.475 297.072 290.095 297.322 289.695 297.512C289.325 297.692 289.075 297.822 289.075 297.822L275.845 297.052V297.042Z",
    fill: "url(#paint169_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.615 299.662C268.615 299.662 268.945 299.562 269.435 299.422C269.685 299.352 269.965 299.262 270.275 299.172C270.555 299.082 270.855 298.982 271.165 298.882C271.465 298.782 271.765 298.682 272.045 298.592C272.325 298.502 272.545 298.412 272.755 298.332C273.165 298.182 273.435 298.082 273.435 298.082L286.265 299.032C286.265 299.032 285.945 299.152 285.475 299.332C285.235 299.422 284.975 299.522 284.645 299.632C284.315 299.742 283.965 299.852 283.615 299.972C283.265 300.092 282.915 300.202 282.575 300.312C282.215 300.422 281.885 300.512 281.595 300.602C281.015 300.772 280.635 300.882 280.635 300.882L268.625 299.672L268.615 299.662Z",
    fill: "url(#paint170_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.927 301.682C259.927 301.682 260.167 301.632 260.517 301.562C260.867 301.492 261.357 301.402 261.797 301.302C262.687 301.112 263.587 300.922 263.587 300.922L274.757 302.342C274.757 302.342 273.717 302.562 272.667 302.792C272.157 302.902 271.587 303.012 271.177 303.092C270.767 303.172 270.487 303.222 270.487 303.222L259.927 301.672V301.682Z",
    fill: "url(#paint171_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.906 306.423C206.906 306.423 207.556 306.413 208.536 306.393C209.526 306.373 210.816 306.333 212.116 306.293C212.766 306.273 213.416 306.253 214.016 306.233C214.616 306.213 215.176 306.183 215.656 306.173C216.616 306.133 217.266 306.113 217.266 306.113L220.656 308.403C220.656 308.403 219.906 308.433 218.776 308.473C218.216 308.493 217.556 308.523 216.856 308.543C216.146 308.573 215.386 308.593 214.636 308.613C213.116 308.663 211.606 308.703 210.456 308.723C209.306 308.743 208.546 308.763 208.546 308.763L206.896 306.413L206.906 306.423Z",
    fill: "url(#paint172_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.746 306.473C189.746 306.473 190.406 306.473 191.386 306.493C192.366 306.513 193.696 306.513 195.016 306.523C195.676 306.523 196.336 306.523 196.956 306.523C197.576 306.523 198.156 306.523 198.646 306.523C199.636 306.523 200.296 306.523 200.296 306.523L200.846 308.883C200.846 308.883 200.076 308.883 198.926 308.883C198.346 308.883 197.676 308.883 196.956 308.883C196.236 308.883 195.466 308.883 194.696 308.883C193.156 308.883 191.616 308.873 190.476 308.853C189.326 308.843 188.556 308.833 188.556 308.833L189.756 306.473H189.746Z",
    fill: "url(#paint173_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.906 305.932C172.906 305.932 173.536 305.962 174.486 306.012C174.966 306.032 175.516 306.062 176.106 306.092C176.706 306.112 177.346 306.142 177.996 306.162C178.636 306.192 179.276 306.212 179.886 306.232C180.486 306.252 181.056 306.272 181.546 306.282C182.516 306.312 183.166 306.332 183.166 306.332L180.866 308.662C180.866 308.662 180.106 308.642 178.966 308.602C178.396 308.582 177.736 308.572 177.026 308.542C176.326 308.512 175.576 308.482 174.826 308.452C174.076 308.422 173.326 308.392 172.626 308.362C171.936 308.332 171.286 308.302 170.726 308.272C169.616 308.222 168.876 308.182 168.876 308.182L172.906 305.922V305.932Z",
    fill: "url(#paint174_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.205 305.004C159.205 305.004 159.525 305.034 160.005 305.074C160.245 305.094 160.525 305.124 160.825 305.144C161.135 305.164 161.465 305.194 161.795 305.214C163.115 305.314 164.425 305.414 164.425 305.414L158.955 307.594C158.955 307.594 157.415 307.474 155.875 307.364C155.495 307.334 155.105 307.304 154.745 307.274C154.395 307.244 154.065 307.214 153.785 307.194C153.225 307.144 152.845 307.114 152.845 307.114L159.195 305.004H159.205Z",
    fill: "url(#paint175_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.486 303.901C245.486 303.901 246.026 303.841 246.826 303.741C247.606 303.641 248.646 303.501 249.676 303.361C250.706 303.221 251.676 303.071 252.436 302.961C252.806 302.911 253.126 302.861 253.326 302.831C253.536 302.801 253.656 302.781 253.656 302.781L263.176 304.511C263.176 304.511 263.036 304.531 262.796 304.571C262.556 304.611 262.196 304.661 261.756 304.731C260.876 304.861 259.736 305.031 258.536 305.191C257.326 305.351 256.116 305.511 255.206 305.631C254.266 305.741 253.636 305.821 253.636 305.821L245.486 303.901Z",
    fill: "url(#paint176_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.584 305.732C224.584 305.732 225.604 305.682 227.074 305.572C227.814 305.522 228.674 305.462 229.604 305.402C230.514 305.332 231.484 305.262 232.444 305.182C233.424 305.112 234.344 305.022 235.234 304.952C236.124 304.872 236.954 304.802 237.634 304.732C239.014 304.602 239.934 304.512 239.934 304.512L247.154 306.532C247.154 306.532 246.074 306.632 244.464 306.792C243.664 306.872 242.694 306.952 241.664 307.042C240.624 307.132 239.544 307.232 238.394 307.312C237.264 307.402 236.134 307.482 235.064 307.562C233.984 307.642 232.974 307.702 232.104 307.762C230.384 307.882 229.194 307.942 229.194 307.942L224.564 305.712L224.584 305.732Z",
    fill: "url(#paint177_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.736 303.424C144.736 303.424 145.256 303.494 146.036 303.594C146.796 303.704 147.876 303.824 148.956 303.954C149.496 304.014 150.026 304.084 150.536 304.144C151.056 304.204 151.546 304.254 151.956 304.294C152.786 304.384 153.346 304.444 153.346 304.444L146.016 306.454C146.016 306.454 145.366 306.384 144.396 306.274C143.906 306.224 143.346 306.164 142.736 306.094C142.136 306.024 141.516 305.954 140.886 305.874C139.626 305.724 138.376 305.574 137.476 305.454C136.566 305.334 135.966 305.254 135.966 305.254L144.736 303.414V303.424Z",
    fill: "url(#paint178_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.526 301.383C132.526 301.383 132.626 301.403 132.816 301.443C133.006 301.483 133.276 301.533 133.596 301.593C134.256 301.713 135.076 301.893 136.016 302.053C136.936 302.213 137.806 302.383 138.546 302.493C139.266 302.613 139.736 302.683 139.736 302.683L130.126 304.403C130.126 304.403 129.566 304.313 128.736 304.183C127.876 304.053 126.856 303.853 125.786 303.673C124.706 303.493 123.736 303.283 122.966 303.143C122.586 303.073 122.276 303.003 122.056 302.963C121.836 302.923 121.716 302.893 121.716 302.893L132.526 301.393V301.383Z",
    fill: "url(#paint179_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.056 298.973C123.056 298.973 123.126 298.993 123.266 299.043C123.406 299.083 123.576 299.153 123.826 299.223C124.316 299.363 124.976 299.563 125.636 299.753C126.346 299.943 127.056 300.123 127.596 300.273C127.856 300.343 128.116 300.403 128.276 300.443C128.446 300.483 128.536 300.503 128.536 300.503L117.056 301.853C117.056 301.853 116.946 301.823 116.746 301.783C116.556 301.733 116.256 301.673 115.956 301.593C115.336 301.433 114.506 301.213 113.676 300.993C112.906 300.763 112.136 300.543 111.566 300.373C111.266 300.293 111.066 300.213 110.906 300.163C110.756 300.113 110.666 300.083 110.666 300.083L123.066 298.983L123.056 298.973Z",
    fill: "url(#paint180_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.377 296.672C117.377 296.672 117.837 296.902 118.307 297.132C118.527 297.252 118.787 297.362 118.987 297.442C119.187 297.522 119.317 297.582 119.317 297.582L106.287 298.442C106.287 298.442 106.137 298.372 105.897 298.272C105.657 298.172 105.357 298.042 105.097 297.902C104.557 297.632 104.017 297.362 104.017 297.362L117.377 296.652V296.672Z",
    fill: "url(#paint181_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.187 286.552C121.187 286.552 120.917 286.652 120.507 286.802C120.067 286.952 119.627 287.162 119.137 287.372C118.627 287.582 118.227 287.792 117.907 287.952C117.587 288.112 117.377 288.212 117.377 288.212L104.017 287.503C104.017 287.503 104.267 287.382 104.637 287.192C105.007 287.012 105.477 286.762 106.067 286.522C106.637 286.282 107.167 286.032 107.677 285.862C108.157 285.682 108.467 285.562 108.467 285.562L121.187 286.552Z",
    fill: "url(#paint182_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.904 284.062C129.904 284.062 129.524 284.152 128.954 284.292C128.664 284.362 128.334 284.442 127.974 284.522C127.614 284.602 127.284 284.702 126.914 284.792C126.204 284.982 125.474 285.162 125.004 285.312C124.514 285.452 124.184 285.552 124.184 285.552L111.974 284.392C111.974 284.392 112.354 284.282 112.934 284.112C113.484 283.942 114.324 283.722 115.164 283.502C115.584 283.392 115.984 283.282 116.404 283.182C116.824 283.082 117.214 282.992 117.544 282.912C118.214 282.752 118.664 282.652 118.664 282.652L129.914 284.062H129.904Z",
    fill: "url(#paint183_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.485 281.922C141.485 281.922 141.365 281.942 141.145 281.972C140.925 282.002 140.625 282.052 140.265 282.112C139.555 282.232 138.575 282.382 137.655 282.542C136.745 282.702 135.835 282.862 135.155 282.982C134.505 283.112 134.075 283.192 134.075 283.192L123.525 281.642C123.525 281.642 124.025 281.542 124.785 281.392C125.585 281.252 126.645 281.062 127.705 280.872C128.785 280.682 129.925 280.512 130.745 280.372C131.165 280.302 131.505 280.252 131.765 280.212C132.015 280.172 132.165 280.152 132.165 280.152L141.485 281.912V281.922Z",
    fill: "url(#paint184_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.346 280.432C153.346 280.432 152.126 280.562 150.916 280.692C150.296 280.752 149.726 280.832 149.276 280.882C148.836 280.932 148.536 280.972 148.536 280.972L140.396 279.052C140.396 279.052 140.736 279.012 141.256 278.952C141.776 278.892 142.446 278.802 143.166 278.732C144.586 278.582 146.006 278.422 146.006 278.422L153.336 280.432H153.346Z",
    fill: "url(#paint185_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.774 293.434C113.774 293.434 113.824 293.544 113.894 293.714C113.934 293.884 114.144 294.104 114.304 294.324C114.394 294.434 114.454 294.544 114.564 294.644C114.674 294.744 114.774 294.844 114.864 294.924C115.034 295.084 115.154 295.194 115.154 295.194L101.424 295.654C101.424 295.654 101.284 295.524 101.084 295.334C100.984 295.234 100.864 295.124 100.734 295.004C100.604 294.884 100.534 294.754 100.434 294.624C100.244 294.364 100.024 294.104 99.964 293.914C99.874 293.724 99.814 293.594 99.814 293.594L113.784 293.434H113.774Z",
    fill: "url(#paint186_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.436 289.463C115.436 289.463 115.376 289.503 115.266 289.583C115.176 289.663 115.066 289.773 114.926 289.903C114.796 290.033 114.606 290.193 114.466 290.353C114.336 290.523 114.206 290.703 114.076 290.873C113.916 291.053 113.896 291.233 113.806 291.403C113.736 291.573 113.636 291.723 113.646 291.863C113.606 292.133 113.576 292.313 113.576 292.313L99.5757 292.293C99.5757 292.293 99.6057 292.083 99.6557 291.773C99.6557 291.613 99.7557 291.433 99.8457 291.233C99.9557 291.033 99.9857 290.823 100.166 290.623C100.326 290.413 100.476 290.203 100.626 290.013C100.786 289.823 101.006 289.643 101.166 289.483C101.336 289.333 101.456 289.203 101.566 289.113C101.686 289.023 101.756 288.973 101.756 288.973L115.446 289.473L115.436 289.463Z",
    fill: "url(#paint187_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.865 279.171C168.865 279.171 168.235 279.201 167.325 279.271C166.415 279.331 165.165 279.411 163.965 279.501C162.765 279.591 161.565 279.681 160.665 279.751C159.785 279.831 159.195 279.881 159.195 279.881L152.845 277.771C152.845 277.771 153.535 277.711 154.555 277.621C155.595 277.541 157.005 277.431 158.415 277.321C159.825 277.211 161.275 277.131 162.345 277.051C163.415 276.981 164.145 276.941 164.145 276.941L168.865 279.171Z",
    fill: "url(#paint188_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.517 278.492C185.517 278.492 185.357 278.492 185.067 278.492C184.777 278.492 184.367 278.502 183.887 278.522C182.917 278.552 181.617 278.592 180.317 278.632C179.037 278.682 177.747 278.732 176.787 278.772C176.307 278.792 175.907 278.802 175.627 278.822C175.347 278.832 175.187 278.842 175.187 278.842L171.537 276.562C171.537 276.562 171.727 276.562 172.047 276.542C172.367 276.522 172.837 276.502 173.397 276.482C174.527 276.442 176.017 276.382 177.527 276.322C179.047 276.272 180.557 276.232 181.697 276.192C182.267 276.172 182.747 276.162 183.077 276.162C183.407 276.162 183.607 276.152 183.607 276.152L185.507 278.492H185.517Z",
    fill: "url(#paint189_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.676 278.393C202.676 278.393 202.516 278.393 202.226 278.393C201.936 278.393 201.526 278.383 201.036 278.383C200.046 278.383 198.726 278.383 197.406 278.363C196.086 278.363 194.766 278.363 193.776 278.373C193.286 278.373 192.866 278.373 192.576 278.373C192.286 278.373 192.126 278.373 192.126 278.373L191.326 276.013C191.326 276.013 191.516 276.013 191.856 276.013C192.196 276.013 192.676 276.013 193.246 276.013C194.396 276.013 195.936 275.993 197.476 276.003C199.016 276.003 200.546 276.013 201.706 276.023C202.286 276.023 202.766 276.033 203.096 276.043C203.436 276.043 203.626 276.043 203.626 276.043L202.686 278.403L202.676 278.393Z",
    fill: "url(#paint190_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.275 278.772C217.275 278.772 215.865 278.722 214.455 278.662C213.755 278.632 213.035 278.612 212.505 278.602C211.975 278.582 211.615 278.572 211.615 278.572L214.055 276.242C214.055 276.242 214.475 276.252 215.095 276.272C215.715 276.292 216.555 276.312 217.375 276.352C219.025 276.412 220.665 276.482 220.665 276.482L217.275 278.772Z",
    fill: "url(#paint191_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.347 284.614C266.347 284.614 266.267 284.594 266.097 284.554C265.927 284.514 265.687 284.454 265.407 284.394C265.117 284.324 264.787 284.244 264.427 284.164C264.247 284.124 264.067 284.074 263.877 284.034C263.677 283.994 263.477 283.944 263.267 283.904C262.437 283.734 261.657 283.554 261.007 283.424C260.357 283.294 259.927 283.214 259.927 283.214L270.487 281.664C270.487 281.664 270.987 281.764 271.747 281.914C272.507 282.064 273.427 282.274 274.387 282.474C274.627 282.524 274.857 282.574 275.097 282.624C275.317 282.674 275.537 282.724 275.747 282.774C276.167 282.874 276.557 282.964 276.887 283.044C277.217 283.124 277.497 283.194 277.697 283.234C277.887 283.284 277.987 283.304 277.987 283.304L266.357 284.624L266.347 284.614Z",
    fill: "url(#paint192_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.354 287.175C274.354 287.175 274.294 287.145 274.184 287.105C274.074 287.065 273.944 286.995 273.734 286.915C273.324 286.765 272.784 286.565 272.244 286.355C271.644 286.155 271.044 285.955 270.594 285.805C270.374 285.725 270.164 285.675 270.024 285.625C269.884 285.585 269.794 285.555 269.794 285.555L282.004 284.395C282.004 284.395 282.104 284.425 282.264 284.475C282.434 284.525 282.674 284.595 282.934 284.685C283.454 284.855 284.154 285.095 284.854 285.325C285.484 285.565 286.124 285.795 286.594 285.975C286.834 286.065 286.994 286.145 287.124 286.195C287.244 286.245 287.314 286.275 287.314 286.275L274.334 287.155L274.354 287.175Z",
    fill: "url(#paint193_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.085 289.951C279.085 289.951 278.965 289.841 278.795 289.681C278.625 289.521 278.285 289.301 278.005 289.081C277.935 289.031 277.855 288.971 277.785 288.921C277.695 288.871 277.605 288.821 277.525 288.771C277.355 288.671 277.195 288.581 277.065 288.501C276.935 288.421 276.815 288.351 276.745 288.311C276.675 288.261 276.615 288.241 276.615 288.241L289.975 287.531C289.975 287.531 290.045 287.561 290.125 287.621C290.215 287.671 290.345 287.751 290.505 287.851C290.665 287.941 290.845 288.051 291.045 288.171C291.145 288.231 291.245 288.291 291.345 288.351C291.435 288.411 291.515 288.481 291.605 288.541C291.945 288.791 292.325 289.051 292.525 289.241C292.725 289.431 292.865 289.561 292.865 289.561L279.085 289.971V289.951Z",
    fill: "url(#paint194_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.407 292.445C280.407 292.445 280.367 292.205 280.327 291.955C280.307 291.835 280.307 291.715 280.247 291.615C280.207 291.525 280.177 291.465 280.177 291.465L294.147 291.305C294.147 291.305 294.177 291.375 294.227 291.485C294.287 291.595 294.297 291.735 294.317 291.875C294.357 292.155 294.397 292.445 294.397 292.445H280.397H280.407Z",
    fill: "url(#paint195_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.504 279.954C235.504 279.954 234.914 279.904 234.034 279.824C233.164 279.744 231.954 279.654 230.754 279.564C229.564 279.464 228.324 279.394 227.414 279.324C226.494 279.264 225.884 279.224 225.884 279.224L230.734 277.004C230.734 277.004 231.454 277.054 232.524 277.124C233.594 277.194 235.044 277.284 236.434 277.394C237.834 277.504 239.254 277.604 240.264 277.694C241.294 277.784 241.974 277.844 241.974 277.844L235.494 279.944L235.504 279.954Z",
    fill: "url(#paint196_linear_11846_111534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.645 282.274C254.645 282.274 254.455 282.244 254.115 282.184C253.775 282.134 253.315 282.054 252.705 281.964C251.495 281.784 249.915 281.544 248.215 281.334C247.795 281.274 247.375 281.224 246.965 281.164C246.535 281.114 246.115 281.064 245.715 281.014C244.905 280.914 244.145 280.824 243.495 280.744C242.155 280.594 241.255 280.504 241.255 280.504L248.695 278.504C248.695 278.504 249.735 278.614 251.305 278.784C252.075 278.874 252.955 278.984 253.905 279.094C254.375 279.154 254.865 279.214 255.365 279.274C255.845 279.334 256.335 279.404 256.825 279.464C258.805 279.714 260.655 279.994 262.065 280.204C262.775 280.304 263.315 280.404 263.715 280.464C264.105 280.524 264.335 280.564 264.335 280.564L254.655 282.274H254.645Z",
    fill: "url(#paint197_linear_11846_111534)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11846_111534",
    x: 118.453,
    y: 213.818,
    width: 76.7058,
    height: 58.6392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_11846_111534"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.254902 0 0 0 0 0.823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11846_111534"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11846_111534",
    x: 67.9023,
    y: 164.651,
    width: 68.9963,
    height: 80.6013,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_11846_111534"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.254902 0 0 0 0 0.823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11846_111534"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_11846_111534",
    x: 67.9023,
    y: 22.6842,
    width: 68.9963,
    height: 80.6014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_11846_111534"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.254902 0 0 0 0 0.823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11846_111534"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_11846_111534",
    x: 118.453,
    y: -4.50867,
    width: 76.6995,
    height: 58.6355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_11846_111534"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.254902 0 0 0 0 0.823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11846_111534"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_11846_111534",
    x: 199.052,
    y: -4.49695,
    width: 76.7026,
    height: 58.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_11846_111534"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.254902 0 0 0 0 0.823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11846_111534"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_11846_111534",
    x: 60.603,
    y: 91.6522,
    width: 41.0208,
    height: 84.6405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_11846_111534"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.254902 0 0 0 0 0.823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11846_111534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11846_111534",
    x1: 258.001,
    y1: 206.913,
    x2: 325.673,
    y2: 206.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11846_111534",
    x1: 199.552,
    y1: 245.222,
    x2: 275.052,
    y2: 245.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11846_111534",
    x1: 119.158,
    y1: 245.226,
    x2: 194.659,
    y2: 245.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#5464E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11846_111534",
    x1: 68.5405,
    y1: 206.912,
    x2: 136.208,
    y2: 206.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#5464E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11846_111534",
    x1: 68.5405,
    y1: 65.025,
    x2: 136.208,
    y2: 65.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#5464E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11846_111534",
    x1: 119.158,
    y1: 26.7191,
    x2: 194.653,
    y2: 26.7191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#5464E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11846_111534",
    x1: 199.552,
    y1: 26.7309,
    x2: 275.051,
    y2: 26.7309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#5464E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11846_111534",
    x1: 257.998,
    y1: 65.032,
    x2: 325.676,
    y2: 65.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11846_111534",
    x1: 293.197,
    y1: 135.965,
    x2: 333.102,
    y2: 135.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11846_111534",
    x1: 61.103,
    y1: 135.972,
    x2: 101.004,
    y2: 135.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#5464E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA3DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11846_111534",
    x1: 298.927,
    y1: 318.115,
    x2: 315.948,
    y2: 318.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11846_111534",
    x1: 327.126,
    y1: 318.645,
    x2: 360.427,
    y2: 318.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11846_111534",
    x1: 309.658,
    y1: 327.041,
    x2: 356.309,
    y2: 327.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11846_111534",
    x1: 290.908,
    y1: 334.321,
    x2: 327.429,
    y2: 334.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11846_111534",
    x1: 246.408,
    y1: 339.667,
    x2: 302.299,
    y2: 339.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11846_111534",
    x1: 216.814,
    y1: 342.936,
    x2: 241.835,
    y2: 342.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_11846_111534",
    x1: 154.966,
    y1: 343.139,
    x2: 205.777,
    y2: 343.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11846_111534",
    x1: 119.384,
    y1: 341.132,
    x2: 149.755,
    y2: 341.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11846_111534",
    x1: 84.8452,
    y1: 337.781,
    x2: 123.706,
    y2: 337.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_11846_111534",
    x1: 56.6265,
    y1: 332.042,
    x2: 93.6773,
    y2: 332.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_11846_111534",
    x1: 34.8843,
    y1: 324.59,
    x2: 78.2553,
    y2: 324.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_11846_111534",
    x1: 33.564,
    y1: 315.414,
    x2: 66.5447,
    y2: 315.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_11846_111534",
    x1: 37.0054,
    y1: 306.932,
    x2: 83.1464,
    y2: 306.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_11846_111534",
    x1: 64.7944,
    y1: 299.541,
    x2: 101.435,
    y2: 299.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_11846_111534",
    x1: 89.4663,
    y1: 294.09,
    x2: 145.378,
    y2: 294.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_11846_111534",
    x1: 149.294,
    y1: 290.679,
    x2: 174.815,
    y2: 290.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_11846_111534",
    x1: 185.275,
    y1: 289.996,
    x2: 211.976,
    y2: 289.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_11846_111534",
    x1: 228.466,
    y1: 291.179,
    x2: 255.867,
    y2: 291.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_11846_111534",
    x1: 255.986,
    y1: 294.992,
    x2: 311.967,
    y2: 294.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_11846_111534",
    x1: 298.814,
    y1: 301.08,
    x2: 335.785,
    y2: 301.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_11846_111534",
    x1: 314.685,
    y1: 310.19,
    x2: 360.396,
    y2: 310.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_11846_111534",
    x1: 185.576,
    y1: 298.852,
    x2: 393.871,
    y2: 298.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_11846_111534",
    x1: 0.103041,
    y1: 305.517,
    x2: 143.869,
    y2: 305.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_11846_111534",
    x1: 30.4546,
    y1: 343.966,
    x2: 311.511,
    y2: 343.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_11846_111534",
    x1: 185.607,
    y1: 334.672,
    x2: 393.902,
    y2: 334.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_11846_111534",
    x1: 302.044,
    y1: 322.695,
    x2: 324.355,
    y2: 322.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_11846_111534",
    x1: 98.2866,
    y1: 316.84,
    x2: 295.671,
    y2: 316.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_11846_111534",
    x1: 104.814,
    y1: 316.741,
    x2: 289.168,
    y2: 316.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_11846_111534",
    x1: 243.064,
    y1: 334.174,
    x2: 298.675,
    y2: 334.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_11846_111534",
    x1: 164.197,
    y1: 339.063,
    x2: 231.948,
    y2: 339.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_11846_111534",
    x1: 96.7241,
    y1: 334.441,
    x2: 152.955,
    y2: 334.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_11846_111534",
    x1: 146.587,
    y1: 295.044,
    x2: 180.168,
    y2: 295.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_11846_111534",
    x1: 315.376,
    y1: 313.826,
    x2: 324.357,
    y2: 313.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_11846_111534",
    x1: 195.794,
    y1: 294.415,
    x2: 229.715,
    y2: 294.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_11846_111534",
    x1: 69.6772,
    y1: 323.08,
    x2: 93.0778,
    y2: 323.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_11846_111534",
    x1: 70.146,
    y1: 306.071,
    x2: 129.437,
    y2: 306.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_11846_111534",
    x1: 239.365,
    y1: 302.387,
    x2: 317.837,
    y2: 302.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_11846_111534",
    x1: 294.158,
    y1: 322.197,
    x2: 313.448,
    y2: 322.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_11846_111534",
    x1: 285.267,
    y1: 326.041,
    x2: 306.018,
    y2: 326.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_11846_111534",
    x1: 274.544,
    y1: 329.49,
    x2: 291.965,
    y2: 329.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_11846_111534",
    x1: 209.248,
    y1: 336.561,
    x2: 225.918,
    y2: 336.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_11846_111534",
    x1: 186.646,
    y1: 336.901,
    x2: 201.716,
    y2: 336.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_11846_111534",
    x1: 162.646,
    y1: 336.392,
    x2: 179.936,
    y2: 336.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_11846_111534",
    x1: 143.134,
    y1: 335.065,
    x2: 156.895,
    y2: 335.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_11846_111534",
    x1: 256.724,
    y1: 332.426,
    x2: 277.795,
    y2: 332.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_11846_111534",
    x1: 230.998,
    y1: 334.986,
    x2: 258.248,
    y2: 334.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_11846_111534",
    x1: 122.505,
    y1: 333.275,
    x2: 143.256,
    y2: 333.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_11846_111534",
    x1: 105.064,
    y1: 330.569,
    x2: 126.464,
    y2: 330.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_11846_111534",
    x1: 91.564,
    y1: 327.254,
    x2: 112.634,
    y2: 327.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_11846_111534",
    x1: 83.4663,
    y1: 323.516,
    x2: 101.287,
    y2: 323.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_11846_111534",
    x1: 83.4546,
    y1: 309.429,
    x2: 103.585,
    y2: 309.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_11846_111534",
    x1: 93.1968,
    y1: 305.741,
    x2: 114.347,
    y2: 305.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_11846_111534",
    x1: 107.294,
    y1: 302.544,
    x2: 128.625,
    y2: 302.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_11846_111534",
    x1: 127.916,
    y1: 299.916,
    x2: 143.246,
    y2: 299.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_11846_111534",
    x1: 78.3257,
    y1: 319.519,
    x2: 96.1561,
    y2: 319.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_11846_111534",
    x1: 78.0366,
    y1: 314.372,
    x2: 96.517,
    y2: 314.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_11846_111534",
    x1: 143.126,
    y1: 298.226,
    x2: 162.357,
    y2: 298.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_11846_111534",
    x1: 165.935,
    y1: 296.999,
    x2: 182.855,
    y2: 296.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_11846_111534",
    x1: 190.044,
    y1: 296.611,
    x2: 205.105,
    y2: 296.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_11846_111534",
    x1: 215.064,
    y1: 297.02,
    x2: 225.944,
    y2: 297.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_11846_111534",
    x1: 274.537,
    y1: 304.449,
    x2: 295.887,
    y2: 304.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_11846_111534",
    x1: 286.724,
    y1: 307.984,
    x2: 307.325,
    y2: 307.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_11846_111534",
    x1: 295.095,
    y1: 311.879,
    x2: 314.056,
    y2: 311.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_11846_111534",
    x1: 299.498,
    y1: 316.012,
    x2: 315.948,
    y2: 316.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_11846_111534",
    x1: 232.595,
    y1: 298.306,
    x2: 251.906,
    y2: 298.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_11846_111534",
    x1: 251.525,
    y1: 300.837,
    x2: 279.226,
    y2: 300.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_11846_111534",
    x1: 363.736,
    y1: 318.872,
    x2: 381.266,
    y2: 318.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_11846_111534",
    x1: 355.908,
    y1: 325.362,
    x2: 377.408,
    y2: 325.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_11846_111534",
    x1: 341.326,
    y1: 331.482,
    x2: 365.856,
    y2: 331.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_11846_111534",
    x1: 323.826,
    y1: 336.971,
    x2: 344.086,
    y2: 336.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_11846_111534",
    x1: 216.947,
    y1: 348.23,
    x2: 241.767,
    y2: 348.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_11846_111534",
    x1: 172.236,
    y1: 348.674,
    x2: 213.157,
    y2: 348.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_11846_111534",
    x1: 143.826,
    y1: 347.941,
    x2: 169.206,
    y2: 347.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_11846_111534",
    x1: 113.498,
    y1: 345.83,
    x2: 131.388,
    y2: 345.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_11846_111534",
    x1: 294.755,
    y1: 341.631,
    x2: 322.196,
    y2: 341.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_11846_111534",
    x1: 252.607,
    y1: 345.696,
    x2: 291.948,
    y2: 345.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_11846_111534",
    x1: 81.5562,
    y1: 342.977,
    x2: 109.037,
    y2: 342.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_11846_111534",
    x1: 54.6265,
    y1: 338.672,
    x2: 81.6271,
    y2: 338.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_11846_111534",
    x1: 33.7163,
    y1: 333.437,
    x2: 59.0769,
    y2: 333.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_11846_111534",
    x1: 21.1577,
    y1: 327.486,
    x2: 40.4982,
    y2: 327.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_11846_111534",
    x1: 21.146,
    y1: 305.157,
    x2: 44.2565,
    y2: 305.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_11846_111534",
    x1: 36.2163,
    y1: 299.296,
    x2: 61.8569,
    y2: 299.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_11846_111534",
    x1: 58.0444,
    y1: 294.194,
    x2: 85.1551,
    y2: 294.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_11846_111534",
    x1: 89.9351,
    y1: 290.012,
    x2: 109.036,
    y2: 290.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_11846_111534",
    x1: 13.1655,
    y1: 321.099,
    x2: 32.076,
    y2: 321.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_11846_111534",
    x1: 12.6968,
    y1: 313.069,
    x2: 34.3973,
    y2: 313.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_11846_111534",
    x1: 113.505,
    y1: 287.33,
    x2: 140.366,
    y2: 287.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_11846_111534",
    x1: 148.908,
    y1: 285.379,
    x2: 173.948,
    y2: 285.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_11846_111534",
    x1: 186.314,
    y1: 284.726,
    x2: 209.535,
    y2: 284.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_11846_111534",
    x1: 226.455,
    y1: 285.412,
    x2: 241.785,
    y2: 285.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_11846_111534",
    x1: 323.826,
    y1: 297.257,
    x2: 350.186,
    y2: 297.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_11846_111534",
    x1: 343.724,
    y1: 302.851,
    x2: 367.905,
    y2: 302.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_11846_111534",
    x1: 357.447,
    y1: 309.036,
    x2: 378.387,
    y2: 309.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_11846_111534",
    x1: 364.677,
    y1: 315.601,
    x2: 381.278,
    y2: 315.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_11846_111534",
    x1: 255.224,
    y1: 287.454,
    x2: 282.125,
    y2: 287.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_11846_111534",
    x1: 263.216,
    y1: 292.072,
    x2: 343.388,
    y2: 292.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_11846_111534",
    x1: 321.685,
    y1: 309.509,
    x2: 337.096,
    y2: 309.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_11846_111534",
    x1: 346.744,
    y1: 309.919,
    x2: 376.604,
    y2: 309.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_11846_111534",
    x1: 326.634,
    y1: 318.519,
    x2: 372.105,
    y2: 318.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_11846_111534",
    x1: 305.064,
    y1: 326.058,
    x2: 340.355,
    y2: 326.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_11846_111534",
    x1: 253.857,
    y1: 331.51,
    x2: 312.718,
    y2: 331.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_11846_111534",
    x1: 219.814,
    y1: 334.914,
    x2: 246.285,
    y2: 334.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_11846_111534",
    x1: 150.806,
    y1: 335.14,
    x2: 206.627,
    y2: 335.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_11846_111534",
    x1: 111.673,
    y1: 333.065,
    x2: 142.624,
    y2: 333.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_11846_111534",
    x1: 73.7554,
    y1: 329.593,
    x2: 112.666,
    y2: 329.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_11846_111534",
    x1: 42.7437,
    y1: 323.705,
    x2: 78.1345,
    y2: 323.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_11846_111534",
    x1: 18.814,
    y1: 316.002,
    x2: 60.3649,
    y2: 316.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_11846_111534",
    x1: 17.3647,
    y1: 306.705,
    x2: 46.8854,
    y2: 306.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_11846_111534",
    x1: 21.1538,
    y1: 298.038,
    x2: 65.9848,
    y2: 298.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_11846_111534",
    x1: 51.6968,
    y1: 290.428,
    x2: 87.0276,
    y2: 290.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_11846_111534",
    x1: 78.8257,
    y1: 284.824,
    x2: 137.627,
    y2: 284.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_11846_111534",
    x1: 144.576,
    y1: 281.314,
    x2: 171.486,
    y2: 281.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_11846_111534",
    x1: 184.126,
    y1: 280.583,
    x2: 213.467,
    y2: 280.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_11846_111534",
    x1: 233.205,
    y1: 281.81,
    x2: 261.705,
    y2: 281.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_11846_111534",
    x1: 264.904,
    y1: 285.773,
    x2: 323.385,
    y2: 285.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_11846_111534",
    x1: 314.154,
    y1: 291.98,
    x2: 349.525,
    y2: 291.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_11846_111534",
    x1: 332.435,
    y1: 301.441,
    x2: 376.606,
    y2: 301.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_11846_111534",
    x1: 319.857,
    y1: 314.346,
    x2: 344.557,
    y2: 314.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_11846_111534",
    x1: 12.5952,
    y1: 308.082,
    x2: 381.414,
    y2: 308.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_11846_111534",
    x1: 73.6343,
    y1: 308.039,
    x2: 320.32,
    y2: 308.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_11846_111534",
    x1: 250.884,
    y1: 326.62,
    x2: 314.796,
    y2: 326.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_11846_111534",
    x1: 159.025,
    y1: 331.8,
    x2: 237.507,
    y2: 331.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_11846_111534",
    x1: 80.814,
    y1: 326.827,
    x2: 145.475,
    y2: 326.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_11846_111534",
    x1: 138.595,
    y1: 284.918,
    x2: 177.346,
    y2: 284.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_11846_111534",
    x1: 335.474,
    y1: 304.953,
    x2: 344.574,
    y2: 304.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_11846_111534",
    x1: 195.607,
    y1: 284.27,
    x2: 234.908,
    y2: 284.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_11846_111534",
    x1: 49.4741,
    y1: 314.751,
    x2: 75.4447,
    y2: 314.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_11846_111534",
    x1: 50.0249,
    y1: 296.724,
    x2: 117.966,
    y2: 296.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_11846_111534",
    x1: 246.564,
    y1: 292.754,
    x2: 337.006,
    y2: 292.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_11846_111534",
    x1: 315.833,
    y1: 314.005,
    x2: 334.144,
    y2: 314.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_11846_111534",
    x1: 304.923,
    y1: 318.22,
    x2: 325.354,
    y2: 318.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_11846_111534",
    x1: 291.857,
    y1: 322.01,
    x2: 308.837,
    y2: 322.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_11846_111534",
    x1: 211.966,
    y1: 329.773,
    x2: 231.077,
    y2: 329.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_11846_111534",
    x1: 184.833,
    y1: 330.133,
    x2: 202.554,
    y2: 330.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_11846_111534",
    x1: 156.556,
    y1: 329.57,
    x2: 176.157,
    y2: 329.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_11846_111534",
    x1: 133.544,
    y1: 328.117,
    x2: 147.935,
    y2: 328.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_11846_111534",
    x1: 270.064,
    y1: 325.209,
    x2: 292.164,
    y2: 325.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_11846_111534",
    x1: 238.595,
    y1: 328.035,
    x2: 269.146,
    y2: 328.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_11846_111534",
    x1: 109.267,
    y1: 326.144,
    x2: 131.258,
    y2: 326.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_11846_111534",
    x1: 88.7437,
    y1: 323.18,
    x2: 110.724,
    y2: 323.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_11846_111534",
    x1: 72.8569,
    y1: 319.565,
    x2: 93.8274,
    y2: 319.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_11846_111534",
    x1: 63.3062,
    y1: 315.445,
    x2: 79.9465,
    y2: 315.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_11846_111534",
    x1: 63.3062,
    y1: 300.024,
    x2: 82.7566,
    y2: 300.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_11846_111534",
    x1: 74.7554,
    y1: 296.008,
    x2: 95.9059,
    y2: 296.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_11846_111534",
    x1: 91.3765,
    y1: 292.459,
    x2: 113.377,
    y2: 292.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_11846_111534",
    x1: 115.646,
    y1: 289.573,
    x2: 131.256,
    y2: 289.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_11846_111534",
    x1: 57.2866,
    y1: 311.053,
    x2: 73.677,
    y2: 311.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_11846_111534",
    x1: 56.9233,
    y1: 305.487,
    x2: 74.1137,
    y2: 305.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_11846_111534",
    x1: 133.544,
    y1: 287.74,
    x2: 154.625,
    y2: 287.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_11846_111534",
    x1: 160.416,
    y1: 286.38,
    x2: 179.706,
    y2: 286.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_11846_111534",
    x1: 188.833,
    y1: 285.956,
    x2: 206.554,
    y2: 285.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_11846_111534",
    x1: 219.064,
    y1: 286.408,
    x2: 231.054,
    y2: 286.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_11846_111534",
    x1: 291.845,
    y1: 294.585,
    x2: 313.466,
    y2: 294.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_11846_111534",
    x1: 306.736,
    y1: 298.44,
    x2: 326.916,
    y2: 298.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_11846_111534",
    x1: 316.986,
    y1: 302.701,
    x2: 334.866,
    y2: 302.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_11846_111534",
    x1: 322.376,
    y1: 307.24,
    x2: 337.087,
    y2: 307.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_11846_111534",
    x1: 240.556,
    y1: 287.82,
    x2: 261.687,
    y2: 287.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_11846_111534",
    x1: 263.685,
    y1: 290.6,
    x2: 293.816,
    y2: 290.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_11846_111534",
    x1: 279.716,
    y1: 293.464,
    x2: 294.407,
    y2: 293.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_11846_111534",
    x1: 275.845,
    y1: 296.577,
    x2: 292.366,
    y2: 296.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_11846_111534",
    x1: 268.615,
    y1: 299.482,
    x2: 286.265,
    y2: 299.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_11846_111534",
    x1: 259.927,
    y1: 302.072,
    x2: 274.758,
    y2: 302.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_11846_111534",
    x1: 206.896,
    y1: 307.438,
    x2: 220.656,
    y2: 307.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_11846_111534",
    x1: 188.556,
    y1: 307.678,
    x2: 200.846,
    y2: 307.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_11846_111534",
    x1: 168.876,
    y1: 307.292,
    x2: 183.167,
    y2: 307.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_11846_111534",
    x1: 152.845,
    y1: 306.299,
    x2: 164.425,
    y2: 306.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_11846_111534",
    x1: 245.486,
    y1: 304.301,
    x2: 263.176,
    y2: 304.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_11846_111534",
    x1: 224.564,
    y1: 306.227,
    x2: 247.154,
    y2: 306.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_11846_111534",
    x1: 135.966,
    y1: 304.934,
    x2: 153.347,
    y2: 304.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_11846_111534",
    x1: 121.716,
    y1: 302.893,
    x2: 139.737,
    y2: 302.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_11846_111534",
    x1: 110.666,
    y1: 300.413,
    x2: 128.536,
    y2: 300.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_11846_111534",
    x1: 104.017,
    y1: 297.547,
    x2: 119.317,
    y2: 297.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_11846_111534",
    x1: 104.017,
    y1: 286.888,
    x2: 121.187,
    y2: 286.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_11846_111534",
    x1: 111.974,
    y1: 284.102,
    x2: 129.915,
    y2: 284.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_11846_111534",
    x1: 123.525,
    y1: 281.672,
    x2: 141.485,
    y2: 281.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_11846_111534",
    x1: 140.396,
    y1: 279.697,
    x2: 153.346,
    y2: 279.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_11846_111534",
    x1: 99.814,
    y1: 294.544,
    x2: 115.154,
    y2: 294.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_11846_111534",
    x1: 99.5757,
    y1: 290.643,
    x2: 115.446,
    y2: 290.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_11846_111534",
    x1: 152.845,
    y1: 278.411,
    x2: 168.866,
    y2: 278.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_11846_111534",
    x1: 171.537,
    y1: 277.497,
    x2: 185.517,
    y2: 277.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_11846_111534",
    x1: 191.326,
    y1: 277.201,
    x2: 203.626,
    y2: 277.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_11846_111534",
    x1: 211.615,
    y1: 277.507,
    x2: 220.665,
    y2: 277.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_11846_111534",
    x1: 259.927,
    y1: 283.144,
    x2: 277.988,
    y2: 283.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_11846_111534",
    x1: 269.794,
    y1: 285.785,
    x2: 287.315,
    y2: 285.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_11846_111534",
    x1: 276.615,
    y1: 288.751,
    x2: 292.865,
    y2: 288.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_11846_111534",
    x1: 280.177,
    y1: 291.875,
    x2: 294.398,
    y2: 291.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_11846_111534",
    x1: 225.884,
    y1: 278.479,
    x2: 241.975,
    y2: 278.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_11846_111534",
    x1: 241.255,
    y1: 280.389,
    x2: 264.336,
    y2: 280.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1696F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#476EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#972ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A424CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11846_111534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.794,
    height: 348.592,
    fill: "white",
    transform: "translate(0.103027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIcon);
export default __webpack_public_path__ + "static/media/PercentIcon.2e20ded7aba78f48ea022c952bb05585.svg";
export { ForwardRef as ReactComponent };